

function initShowMore() {
	$(".showmore").on("click touchstart", function (e) {
		e.preventDefault();
		var t = $(this);
		var target = t.data('target');
		
		var c = $('form[name="' + target + '-nav"] input[name="page"]').val();
		var offset = $('form[name="' + target + '-nav"] input[name="offset"]').val();
    	var np = $('form[name="' + target + '-nav"] input[name="num_pages"]').val()-1;
		$('form[name="' + target + '-nav"] input[name="page"]').val(Number(c) + 1);
		var nv = $('form[name="' + target + '-nav"] input[name="page"]').val();

		t.addClass("loading"), $.ajax({
			data: $('form[name="' + target + '-nav"]').serialize(), 
			dataType: 'html',
			success: function (e) {
				setTimeout(function () {
					t.removeClass("loading"), $("#squares").isotope("insert", $(e));
					if(nv==np ){t.remove();}
					var n = $(".shownore-new-block").find(".showmore");
					n.insertAfter("#squares"), initShowMore(), $("#squares").isotope("reloadItems").isotope()
				}, 150)
			}
		})
	})
}



var requirejs, require, define;
(function (global) {
	function isFunction(e) {
		return ostring.call(e) === "[object Function]"
	}


	function isArray(e) {
		return ostring.call(e) === "[object Array]"
	}

	function each(e, t) {
		if (e) {
			var n;
			for (n = 0; n < e.length; n += 1)
				if (e[n] && t(e[n], n, e)) break
		}
	}

	function eachReverse(e, t) {
		if (e) {
			var n;
			for (n = e.length - 1; n > -1; n -= 1)
				if (e[n] && t(e[n], n, e)) break
		}
	}

	function hasProp(e, t) {
		return hasOwn.call(e, t)
	}

	function getOwn(e, t) {
		return hasProp(e, t) && e[t]
	}

	function eachProp(e, t) {
		var n;
		for (n in e)
			if (hasProp(e, n) && t(e[n], n)) break
	}

	function mixin(e, t, n, r) {
		return t && eachProp(t, function (t, i) {
			if (n || !hasProp(e, i)) r && typeof t == "object" && t && !isArray(t) && !isFunction(t) && !(t instanceof RegExp) ? (e[i] || (e[i] = {}), mixin(e[i], t, n, r)) : e[i] = t
		}), e
	}

	function bind(e, t) {
		return function () {
			return t.apply(e, arguments)
		}
	}

	function scripts() {
		return document.getElementsByTagName("script")
	}

	function defaultOnError(e) {
		throw e
	}

	function getGlobal(e) {
		if (!e) return e;
		var t = global;
		return each(e.split("."), function (e) {
			t = t[e]
		}), t
	}

	function makeError(e, t, n, r) {
		var i = new Error(t + "\nhttp://requirejs.org/docs/errors.html#" + e);
		return i.requireType = e, i.requireModules = r, n && (i.originalError = n), i
	}

	function newContext(e) {
		function m(e) {
			var t, n;
			for (t = 0; t < e.length; t++) {
				n = e[t];
				if (n === ".") e.splice(t, 1), t -= 1;
				else if (n === "..") {
					if (t === 0 || t == 1 && e[2] === ".." || e[t - 1] === "..") continue;
					t > 0 && (e.splice(t - 1, 2), t -= 2)
				}
			}
		}

		function g(e, t, n) {
			var r, i, s, u, a, f, l, c, h, p, d, v, g = t && t.split("/"),
				y = o.map,
				b = y && y["*"];
			e && (e = e.split("/"), l = e.length - 1, o.nodeIdCompat && jsSuffixRegExp.test(e[l]) && (e[l] = e[l].replace(jsSuffixRegExp, "")), e[0].charAt(0) === "." && g && (v = g.slice(0, g.length - 1), e = v.concat(e)), m(e), e = e.join("/"));
			if (n && y && (g || b)) {
				s = e.split("/");
				e: for (u = s.length; u > 0; u -= 1) {
					f = s.slice(0, u).join("/");
					if (g)
						for (a = g.length; a > 0; a -= 1) {
							i = getOwn(y, g.slice(0, a).join("/"));
							if (i) {
								i = getOwn(i, f);
								if (i) {
									c = i, h = u;
									break e
								}
							}
						}!p && b && getOwn(b, f) && (p = getOwn(b, f), d = u)
				}!c && p && (c = p, h = d), c && (s.splice(0, h, c), e = s.join("/"))
			}
			return r = getOwn(o.pkgs, e), r ? r : e
		}

		function y(e) {
			isBrowser && each(scripts(), function (t) {
				if (t.getAttribute("data-requiremodule") === e && t.getAttribute("data-requirecontext") === r.contextName) return t.parentNode.removeChild(t), !0
			})
		}

		function b(e) {
			var t = getOwn(o.paths, e);
			if (t && isArray(t) && t.length > 1) return t.shift(), r.require.undef(e), r.makeRequire(null, {
				skipMap: !0
			})([e]), !0
		}

		function w(e) {
			var t, n = e ? e.indexOf("!") : -1;
			return n > -1 && (t = e.substring(0, n), e = e.substring(n + 1, e.length)), [t, e]
		}

		function E(e, t, n, i) {
			var s, o, u, a, f = null,
				l = t ? t.name : null,
				h = e,
				p = !0,
				m = "";
			return e || (p = !1, e = "_@r" + (d += 1)), a = w(e), f = a[0], e = a[1], f && (f = g(f, l, i), o = getOwn(c, f)), e && (f ? o && o.normalize ? m = o.normalize(e, function (e) {
				return g(e, l, i)
			}) : m = e.indexOf("!") === -1 ? g(e, l, i) : e : (m = g(e, l, i), a = w(m), f = a[0], m = a[1], n = !0, s = r.nameToUrl(m))), u = f && !o && !n ? "_unnormalized" + (v += 1) : "", {
				prefix: f,
				name: m,
				parentMap: t,
				unnormalized: !!u,
				url: s,
				originalName: h,
				isDefine: p,
				id: (f ? f + "!" + m : m) + u
			}
		}

		function S(e) {
			var t = e.id,
				n = getOwn(u, t);
			return n || (n = u[t] = new r.Module(e)), n
		}

		function x(e, t, n) {
			var r = e.id,
				i = getOwn(u, r);
			hasProp(c, r) && (!i || i.defineEmitComplete) ? t === "defined" && n(c[r]) : (i = S(e), i.error && t === "error" ? n(i.error) : i.on(t, n))
		}

		function T(e, t) {
			var n = e.requireModules,
				r = !1;
			t ? t(e) : (each(n, function (t) {
				var n = getOwn(u, t);
				n && (n.error = e, n.events.error && (r = !0, n.emit("error", e)))
			}), r || req.onError(e))
		}

		function N() {
			globalDefQueue.length && (apsp.apply(l, [l.length, 0].concat(globalDefQueue)), globalDefQueue = [])
		}

		function C(e) {
			delete u[e], delete a[e]
		}

		
		function k(e, t, n) {
			var r = e.map.id;
			e.error ? e.emit("error", e.error) : (t[r] = !0, each(e.depMaps, function (r, i) {
				var s = r.id,
					o = getOwn(u, s);
				o && !e.depMatched[i] && !n[s] && (getOwn(t, s) ? (e.defineDep(i, c[s]), e.check()) : k(o, t, n))
			}), n[r] = !0)
		}

		function L() {
			var e, n, i = o.waitSeconds * 1e3,
				u = i && r.startTime + i < (new Date).getTime(),
				f = [],
				l = [],
				c = !1,
				h = !0;
			if (t) return;
			t = !0, eachProp(a, function (e) {
				var t = e.map,
					r = t.id;
				if (!e.enabled) return;
				t.isDefine || l.push(e);
				if (!e.error)
					if (!e.inited && u) b(r) ? (n = !0, c = !0) : (f.push(r), y(r));
					else if (!e.inited && e.fetched && t.isDefine) {
					c = !0;
					if (!t.prefix) return h = !1
				}
			});
			if (u && f.length) return e = makeError("timeout", "Load timeout for modules: " + f, null, f), e.contextName = r.contextName, T(e);
			h && each(l, function (e) {
				k(e, {}, {})
			}), (!u || n) && c && (isBrowser || isWebWorker) && !s && (s = setTimeout(function () {
				s = 0, L()
			}, 50)), t = !1
		}

		function A(e) {
			hasProp(c, e[0]) || S(E(e[0], null, !0)).init(e[1], e[2])
		}

		function O(e, t, n, r) {
			e.detachEvent && !isOpera ? r && e.detachEvent(r, t) : e.removeEventListener(n, t, !1)
		}

		function M(e) {
			var t = e.currentTarget || e.srcElement;
			return O(t, r.onScriptLoad, "load", "onreadystatechange"), O(t, r.onScriptError, "error"), {
				node: t,
				id: t && t.getAttribute("data-requiremodule")
			}
		}

		function _() {
			var e;
			N();
			while (l.length) {
				e = l.shift();
				if (e[0] === null) return T(makeError("mismatch", "Mismatched anonymous define() module: " + e[e.length - 1]));
				A(e)
			}
		}
		var t, n, r, i, s, o = {
				waitSeconds: 7,
				baseUrl: "./",
				paths: {},
				bundles: {},
				pkgs: {},
				shim: {},
				config: {}
			},
			u = {},
			a = {},
			f = {},
			l = [],
			c = {},
			h = {},
			p = {},
			d = 1,
			v = 1;
		return i = {
			require: function (e) {
				return e.require ? e.require : e.require = r.makeRequire(e.map)
			},
			exports: function (e) {
				e.usingExports = !0;
				if (e.map.isDefine) return e.exports ? c[e.map.id] = e.exports : e.exports = c[e.map.id] = {}
			},
			module: function (e) {
				return e.module ? e.module : e.module = {
					id: e.map.id,
					uri: e.map.url,
					config: function () {
						return getOwn(o.config, e.map.id) || {}
					},
					exports: e.exports || (e.exports = {})
				}
			}
		}, n = function (e) {
			this.events = getOwn(f, e.id) || {}, this.map = e, this.shim = getOwn(o.shim, e.id), this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, this.depCount = 0
		}, n.prototype = {
			init: function (e, t, n, r) {
				r = r || {};
				if (this.inited) return;
				this.factory = t, n ? this.on("error", n) : this.events.error && (n = bind(this, function (e) {
					this.emit("error", e)
				})), this.depMaps = e && e.slice(0), this.errback = n, this.inited = !0, this.ignore = r.ignore, r.enabled || this.enabled ? this.enable() : this.check()
			},
			defineDep: function (e, t) {
				this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, this.depExports[e] = t)
			},
			fetch: function () {
				if (this.fetched) return;
				this.fetched = !0, r.startTime = (new Date).getTime();
				var e = this.map;
				if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
				r.makeRequire(this.map, {
					enableBuildCallback: !0
				})(this.shim.deps || [], bind(this, function () {
					return e.prefix ? this.callPlugin() : this.load()
				}))
			},
			load: function () {
				var e = this.map.url;
				h[e] || (h[e] = !0, r.load(this.map.id, e))
			},
			check: function () {
				if (!this.enabled || this.enabling) return;
				var e, t, n = this.map.id,
					i = this.depExports,
					s = this.exports,
					o = this.factory;
				if (!this.inited) this.fetch();
				else if (this.error) this.emit("error", this.error);
				else if (!this.defining) {
					this.defining = !0;
					if (this.depCount < 1 && !this.defined) {
						if (isFunction(o)) {
							if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) try {
								s = r.execCb(n, o, i, s)
							} catch (u) {
								e = u
							} else s = r.execCb(n, o, i, s);
							this.map.isDefine && s === undefined && (t = this.module, t ? s = t.exports : this.usingExports && (s = this.exports));
							if (e) return e.requireMap = this.map, e.requireModules = this.map.isDefine ? [this.map.id] : null, e.requireType = this.map.isDefine ? "define" : "require", T(this.error = e)
						} else s = o;
						this.exports = s, this.map.isDefine && !this.ignore && (c[n] = s, req.onResourceLoad && req.onResourceLoad(r, this.map, this.depMaps)), C(n), this.defined = !0
					}
					this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, this.emit("defined", this.exports), this.defineEmitComplete = !0)
				}
			},
			callPlugin: function () {
				var e = this.map,
					t = e.id,
					n = E(e.prefix);
				this.depMaps.push(n), x(n, "defined", bind(this, function (n) {
					var i, s, a, f = getOwn(p, this.map.id),
						l = this.map.name,
						c = this.map.parentMap ? this.map.parentMap.name : null,
						h = r.makeRequire(e.parentMap, {
							enableBuildCallback: !0
						});
					if (this.map.unnormalized) {
						n.normalize && (l = n.normalize(l, function (e) {
							return g(e, c, !0)
						}) || ""), s = E(e.prefix + "!" + l, this.map.parentMap), x(s, "defined", bind(this, function (e) {
							this.init([], function () {
								return e
							}, null, {
								enabled: !0,
								ignore: !0
							})
						})), a = getOwn(u, s.id), a && (this.depMaps.push(s), this.events.error && a.on("error", bind(this, function (e) {
							this.emit("error", e)
						})), a.enable());
						return
					}
					if (f) {
						this.map.url = r.nameToUrl(f), this.load();
						return
					}
					i = bind(this, function (e) {
						this.init([], function () {
							return e
						}, null, {
							enabled: !0
						})
					}), i.error = bind(this, function (e) {
						this.inited = !0, this.error = e, e.requireModules = [t], eachProp(u, function (e) {
							e.map.id.indexOf(t + "_unnormalized") === 0 && C(e.map.id)
						}), T(e)
					}), i.fromText = bind(this, function (n, s) {
						var u = e.name,
							a = E(u),
							f = useInteractive;
						s && (n = s), f && (useInteractive = !1), S(a), hasProp(o.config, t) && (o.config[u] = o.config[t]);
						try {
							req.exec(n)
						} catch (l) {
							return T(makeError("fromtexteval", "fromText eval for " + t + " failed: " + l, l, [t]))
						}
						f && (useInteractive = !0), this.depMaps.push(a), r.completeLoad(u), h([u], i)
					}), n.load(e.name, h, i, o)
				})), r.enable(n, this), this.pluginMaps[n.id] = n
			},
			enable: function () {
				a[this.map.id] = this, this.enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function (e, t) {
					var n, s, o;
					if (typeof e == "string") {
						e = E(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), this.depMaps[t] = e, o = getOwn(i, e.id);
						if (o) {
							this.depExports[t] = o(this);
							return
						}
						this.depCount += 1, x(e, "defined", bind(this, function (e) {
							this.defineDep(t, e), this.check()
						})), this.errback && x(e, "error", bind(this, this.errback))
					}
					n = e.id, s = u[n], !hasProp(i, n) && s && !s.enabled && r.enable(e, this)
				})), eachProp(this.pluginMaps, bind(this, function (e) {
					var t = getOwn(u, e.id);
					t && !t.enabled && r.enable(e, this)
				})), this.enabling = !1, this.check()
			},
			on: function (e, t) {
				var n = this.events[e];
				n || (n = this.events[e] = []), n.push(t)
			},
			emit: function (e, t) {
				each(this.events[e], function (e) {
					e(t)
				}), e === "error" && delete this.events[e]
			}
		}, r = {
			config: o,
			contextName: e,
			registry: u,
			defined: c,
			urlFetched: h,
			defQueue: l,
			Module: n,
			makeModuleMap: E,
			nextTick: req.nextTick,
			onError: T,
			configure: function (e) {
				e.baseUrl && e.baseUrl.charAt(e.baseUrl.length - 1) !== "/" && (e.baseUrl += "/");
				var t = o.shim,
					n = {
						paths: !0,
						bundles: !0,
						config: !0,
						map: !0
					};
				eachProp(e, function (e, t) {
					n[t] ? (o[t] || (o[t] = {}), mixin(o[t], e, !0, !0)) : o[t] = e
				}), e.bundles && eachProp(e.bundles, function (e, t) {
					each(e, function (e) {
						e !== t && (p[e] = t)
					})
				}), e.shim && (eachProp(e.shim, function (e, n) {
					isArray(e) && (e = {
						deps: e
					}), (e.exports || e.init) && !e.exportsFn && (e.exportsFn = r.makeShimExports(e)), t[n] = e
				}), o.shim = t), e.packages && each(e.packages, function (e) {
					var t, n;
					e = typeof e == "string" ? {
						name: e
					} : e, n = e.name, t = e.location, t && (o.paths[n] = e.location), o.pkgs[n] = e.name + "/" + (e.main || "main").replace(currDirRegExp, "").replace(jsSuffixRegExp, "")
				}), eachProp(u, function (e, t) {
					!e.inited && !e.map.unnormalized && (e.map = E(t))
				}), (e.deps || e.callback) && r.require(e.deps || [], e.callback)
			},
			makeShimExports: function (e) {
				function t() {
					var t;
					return e.init && (t = e.init.apply(global, arguments)), t || e.exports && getGlobal(e.exports)
				}
				return t
			},
			makeRequire: function (t, n) {
				function s(o, a, f) {
					var l, h, p;
					return n.enableBuildCallback && a && isFunction(a) && (a.__requireJsBuild = !0), typeof o == "string" ? isFunction(a) ? T(makeError("requireargs", "Invalid require call"), f) : t && hasProp(i, o) ? i[o](u[t.id]) : req.get ? req.get(r, o, t, s) : (h = E(o, t, !1, !0), l = h.id, hasProp(c, l) ? c[l] : T(makeError("notloaded", 'Module name "' + l + '" has not been loaded yet for context: ' + e + (t ? "" : ". Use require([])")))) : (_(), r.nextTick(function () {
						_(), p = S(E(null, t)), p.skipMap = n.skipMap, p.init(o, a, f, {
							enabled: !0
						}), L()
					}), s)
				}
				return n = n || {}, mixin(s, {
					isBrowser: isBrowser,
					toUrl: function (e) {
						var n, i = e.lastIndexOf("."),
							s = e.split("/")[0],
							o = s === "." || s === "..";
						return i !== -1 && (!o || i > 1) && (n = e.substring(i, e.length), e = e.substring(0, i)), r.nameToUrl(g(e, t && t.id, !0), n, !0)
					},
					defined: function (e) {
						return hasProp(c, E(e, t, !1, !0).id)
					},
					specified: function (e) {
						return e = E(e, t, !1, !0).id, hasProp(c, e) || hasProp(u, e)
					}
				}), t || (s.undef = function (e) {
					N();
					var n = E(e, t, !0),
						r = getOwn(u, e);
					y(e), delete c[e], delete h[n.url], delete f[e], eachReverse(l, function (t, n) {
						t[0] === e && l.splice(n, 1)
					}), r && (r.events.defined && (f[e] = r.events), C(e))
				}), s
			},
			enable: function (e) {
				var t = getOwn(u, e.id);
				t && S(e).enable()
			},
			completeLoad: function (e) {
				var t, n, r, i = getOwn(o.shim, e) || {},
					s = i.exports;
				N();
				while (l.length) {
					n = l.shift();
					if (n[0] === null) {
						n[0] = e;
						if (t) break;
						t = !0
					} else n[0] === e && (t = !0);
					A(n)
				}
				r = getOwn(u, e);
				if (!t && !hasProp(c, e) && r && !r.inited) {
					if (o.enforceDefine && (!s || !getGlobal(s))) {
						if (b(e)) return;
						return T(makeError("nodefine", "No define call for " + e, null, [e]))
					}
					A([e, i.deps || [], i.exportsFn])
				}
				L()
			},
			nameToUrl: function (e, t, n) {
				var i, s, u, a, f, l, c, h = getOwn(o.pkgs, e);
				h && (e = h), c = getOwn(p, e);
				if (c) return r.nameToUrl(c, t, n);
				if (req.jsExtRegExp.test(e)) f = e + (t || "");
				else {
					i = o.paths, s = e.split("/");
					for (u = s.length; u > 0; u -= 1) {
						a = s.slice(0, u).join("/"), l = getOwn(i, a);
						if (l) {
							isArray(l) && (l = l[0]), s.splice(0, u, l);
							break
						}
					}
					f = s.join("/"), f += t || (/^data\:|\?/.test(f) || n ? "" : ".js"), f = (f.charAt(0) === "/" || f.match(/^[\w\+\.\-]+:/) ? "" : o.baseUrl) + f
				}
				return o.urlArgs ? f + ((f.indexOf("?") === -1 ? "?" : "&") + o.urlArgs) : f
			},
			load: function (e, t) {
				req.load(r, e, t)
			},
			execCb: function (e, t, n, r) {
				return t.apply(r, n)
			},
			onScriptLoad: function (e) {
				if (e.type === "load" || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
					interactiveScript = null;
					var t = M(e);
					r.completeLoad(t.id)
				}
			},
			onScriptError: function (e) {
				var t = M(e);
				if (!b(t.id)) return T(makeError("scripterror", "Script error for: " + t.id, e, [t.id]))
			}
		}, r.require = r.makeRequire(), r
	}

	function getInteractiveScript() {
		return interactiveScript && interactiveScript.readyState === "interactive" ? interactiveScript : (eachReverse(scripts(), function (e) {
			if (e.readyState === "interactive") return interactiveScript = e
		}), interactiveScript)
	}
	var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath, version = "2.1.14",
		commentRegExp = /(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/mg,
		cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
		jsSuffixRegExp = /\.js$/,
		currDirRegExp = /^\.\//,
		op = Object.prototype,
		ostring = op.toString,
		hasOwn = op.hasOwnProperty,
		ap = Array.prototype,
		apsp = ap.splice,
		isBrowser = typeof window != "undefined" && typeof navigator != "undefined" && !!window.document,
		isWebWorker = !isBrowser && typeof importScripts != "undefined",
		readyRegExp = isBrowser && navigator.platform === "PLAYSTATION 3" ? /^complete$/ : /^(complete|loaded)$/,
		defContextName = "_",
		isOpera = typeof opera != "undefined" && opera.toString() === "[object Opera]",
		contexts = {},
		cfg = {},
		globalDefQueue = [],
		useInteractive = !1;
	if (typeof define != "undefined") return;
	if (typeof requirejs != "undefined") {
		if (isFunction(requirejs)) return;
		cfg = requirejs, requirejs = undefined
	}
	typeof require != "undefined" && !isFunction(require) && (cfg = require, require = undefined), req = requirejs = function (e, t, n, r) {
		var i, s, o = defContextName;
		return !isArray(e) && typeof e != "string" && (s = e, isArray(t) ? (e = t, t = n, n = r) : e = []), s && s.context && (o = s.context), i = getOwn(contexts, o), i || (i = contexts[o] = req.s.newContext(o)), s && i.configure(s), i.require(e, t, n)
	}, req.config = function (e) {
		return req(e)
	}, req.nextTick = typeof setTimeout != "undefined" ? function (e) {
		setTimeout(e, 4)
	} : function (e) {
		e()
	}, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, req.isBrowser = isBrowser, s = req.s = {
		contexts: contexts,
		newContext: newContext
	}, req({}), each(["toUrl", "undef", "defined", "specified"], function (e) {
		req[e] = function () {
			var t = contexts[defContextName];
			return t.require[e].apply(t, arguments)
		}
	}), isBrowser && (head = s.head = document.getElementsByTagName("head")[0], baseElement = document.getElementsByTagName("base")[0], baseElement && (head = s.head = baseElement.parentNode)), req.onError = defaultOnError, req.createNode = function (e, t, n) {
		var r = e.xhtml ? document.createElementNS("http://www.w3.org/1999/xhtml", "html:script") : document.createElement("script");
		return r.type = e.scriptType || "text/javascript", r.charset = "utf-8", r.async = !0, r
	}, req.load = function (e, t, n) {
		var r = e && e.config || {},
			i;
		if (isBrowser) return i = req.createNode(r, t, n), i.setAttribute("data-requirecontext", e.contextName), i.setAttribute("data-requiremodule", t), i.attachEvent && !(i.attachEvent.toString && i.attachEvent.toString().indexOf("[native code") < 0) && !isOpera ? (useInteractive = !0, i.attachEvent("onreadystatechange", e.onScriptLoad)) : (i.addEventListener("load", e.onScriptLoad, !1), i.addEventListener("error", e.onScriptError, !1)), i.src = n, currentlyAddingScript = i, baseElement ? head.insertBefore(i, baseElement) : head.appendChild(i), currentlyAddingScript = null, i;
		if (isWebWorker) try {
			importScripts(n), e.completeLoad(t)
		} catch (s) {
			e.onError(makeError("importscripts", "importScripts failed for " + t + " at " + n, s, [t]))
		}
	}, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function (e) {
		head || (head = e.parentNode), dataMain = e.getAttribute("data-main");
		if (dataMain) return mainScript = dataMain, cfg.baseUrl || (src = mainScript.split("/"), mainScript = src.pop(), subPath = src.length ? src.join("/") + "/" : "./", cfg.baseUrl = subPath), mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [mainScript], !0
	}), define = function (e, t, n) {
		var r, i;
		typeof e != "string" && (n = t, t = e, e = null), isArray(t) || (n = t, t = null), !t && isFunction(n) && (t = [], n.length && (n.toString().replace(commentRegExp, "").replace(cjsRequireRegExp, function (e, n) {
			t.push(n)
		}), t = (n.length === 1 ? ["require"] : ["require", "exports", "module"]).concat(t))), useInteractive && (r = currentlyAddingScript || getInteractiveScript(), r && (e || (e = r.getAttribute("data-requiremodule")), i = contexts[r.getAttribute("data-requirecontext")])), (i ? i.defQueue : globalDefQueue).push([e, t, n])
	}, define.amd = {
		jQuery: !0
	}, req.exec = function (text) {
		return eval(text)
	}, req(cfg)
})(this), define("lib/require.js", function () {}), ! function (e, t) {
		"object" == typeof module && "object" == typeof module.exports ? module.exports = e.document ? t(e, !0) : function (e) {
			if (!e.document) throw new Error("jQuery requires a window with a document");
			return t(e)
		} : t(e)
	}("undefined" != typeof window ? window : this, function (e, t) {
		function g(e) {
			var t = e.length,
				n = h.type(e);
			return "function" === n || h.isWindow(e) ? !1 : 1 === e.nodeType && t ? !0 : "array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e
		}

		function S(e, t, n) {
			if (h.isFunction(t)) return h.grep(e, function (e, r) {
				return !!t.call(e, r, e) !== n
			});
			if (t.nodeType) return h.grep(e, function (e) {
				return e === t !== n
			});
			if ("string" == typeof t) {
				if (E.test(t)) return h.filter(t, e, n);
				t = h.filter(t, e)
			}
			return h.grep(e, function (e) {
				return h.inArray(e, t) >= 0 !== n
			})
		}

		function A(e, t) {
			do e = e[t]; while (e && 1 !== e.nodeType);
			return e
		}

		function _(e) {
			var t = M[e] = {};
			return h.each(e.match(O) || [], function (e, n) {
				t[n] = !0
			}), t
		}

		function P() {
			T.addEventListener ? (T.removeEventListener("DOMContentLoaded", H, !1), e.removeEventListener("load", H, !1)) : (T.detachEvent("onreadystatechange", H), e.detachEvent("onload", H))
		}

		function H() {
			(T.addEventListener || "load" === event.type || "complete" === T.readyState) && (P(), h.ready())
		}

		function q(e, t, n) {
			if (void 0 === n && 1 === e.nodeType) {
				var r = "data-" + t.replace(I, "-$1").toLowerCase();
				if (n = e.getAttribute(r), "string" == typeof n) {
					try {
						n = "true" === n ? !0 : "false" === n ? !1 : "null" === n ? null : +n + "" === n ? +n : F.test(n) ? h.parseJSON(n) : n
					} catch (i) {}
					h.data(e, t, n)
				} else n = void 0
			}
			return n
		}

		function R(e) {
			var t;
			for (t in e)
				if (("data" !== t || !h.isEmptyObject(e[t])) && "toJSON" !== t) return !1;
			return !0
		}

		function U(e, t, r, i) {
			if (h.acceptData(e)) {
				var s, o, u = h.expando,
					a = e.nodeType,
					f = a ? h.cache : e,
					l = a ? e[u] : e[u] && u;
				if (l && f[l] && (i || f[l].data) || void 0 !== r || "string" != typeof t) return l || (l = a ? e[u] = n.pop() || h.guid++ : u), f[l] || (f[l] = a ? {} : {
					toJSON: h.noop
				}), ("object" == typeof t || "function" == typeof t) && (i ? f[l] = h.extend(f[l], t) : f[l].data = h.extend(f[l].data, t)), o = f[l], i || (o.data || (o.data = {}), o = o.data), void 0 !== r && (o[h.camelCase(t)] = r), "string" == typeof t ? (s = o[t], null == s && (s = o[h.camelCase(t)])) : s = o, s
			}
		}

		function z(e, t, n) {
			if (h.acceptData(e)) {
				var r, i, s = e.nodeType,
					o = s ? h.cache : e,
					u = s ? e[h.expando] : h.expando;
				if (o[u]) {
					if (t && (r = n ? o[u] : o[u].data)) {
						h.isArray(t) ? t = t.concat(h.map(t, h.camelCase)) : t in r ? t = [t] : (t = h.camelCase(t), t = t in r ? [t] : t.split(" ")), i = t.length;
						while (i--) delete r[t[i]];
						if (n ? !R(r) : !h.isEmptyObject(r)) return
					}(n || (delete o[u].data, R(o[u]))) && (s ? h.cleanData([e], !0) : l.deleteExpando || o != o.window ? delete o[u] : o[u] = null)
				}
			}
		}

		function et() {
			return !0
		}

		function tt() {
			return !1
		}

		function nt() {
			try {
				return T.activeElement
			} catch (e) {}
		}

		function rt(e) {
			var t = it.split("|"),
				n = e.createDocumentFragment();
			if (n.createElement)
				while (t.length) n.createElement(t.pop());
			return n
		}

		function wt(e, t) {
			var n, r, i = 0,
				s = typeof e.getElementsByTagName !== B ? e.getElementsByTagName(t || "*") : typeof e.querySelectorAll !== B ? e.querySelectorAll(t || "*") : void 0;
			if (!s)
				for (s = [], n = e.childNodes || e; null != (r = n[i]); i++) !t || h.nodeName(r, t) ? s.push(r) : h.merge(s, wt(r, t));
			return void 0 === t || t && h.nodeName(e, t) ? h.merge([e], s) : s
		}

		function Et(e) {
			J.test(e.type) && (e.defaultChecked = e.checked)
		}

		function St(e, t) {
			return h.nodeName(e, "table") && h.nodeName(11 !== t.nodeType ? t : t.firstChild, "tr") ? e.getElementsByTagName("tbody")[0] || e.appendChild(e.ownerDocument.createElement("tbody")) : e
		}

		function xt(e) {
			return e.type = (null !== h.find.attr(e, "type")) + "/" + e.type, e
		}

		function Tt(e) {
			var t = vt.exec(e.type);
			return t ? e.type = t[1] : e.removeAttribute("type"), e
		}

		function Nt(e, t) {
			for (var n, r = 0; null != (n = e[r]); r++) h._data(n, "globalEval", !t || h._data(t[r], "globalEval"))
		}

		function Ct(e, t) {
			if (1 === t.nodeType && h.hasData(e)) {
				var n, r, i, s = h._data(e),
					o = h._data(t, s),
					u = s.events;
				if (u) {
					delete o.handle, o.events = {};
					for (n in u)
						for (r = 0, i = u[n].length; i > r; r++) h.event.add(t, n, u[n][r])
				}
				o.data && (o.data = h.extend({}, o.data))
			}
		}

		function kt(e, t) {
			var n, r, i;
			if (1 === t.nodeType) {
				if (n = t.nodeName.toLowerCase(), !l.noCloneEvent && t[h.expando]) {
					i = h._data(t);
					for (r in i.events) h.removeEvent(t, r, i.handle);
					t.removeAttribute(h.expando)
				}
				"script" === n && t.text !== e.text ? (xt(t).text = e.text, Tt(t)) : "object" === n ? (t.parentNode && (t.outerHTML = e.outerHTML), l.html5Clone && e.innerHTML && !h.trim(t.innerHTML) && (t.innerHTML = e.innerHTML)) : "input" === n && J.test(e.type) ? (t.defaultChecked = t.checked = e.checked, t.value !== e.value && (t.value = e.value)) : "option" === n ? t.defaultSelected = t.selected = e.defaultSelected : ("input" === n || "textarea" === n) && (t.defaultValue = e.defaultValue)
			}
		}

		function Ot(t, n) {
			var r, i = h(n.createElement(t)).appendTo(n.body),
				s = e.getDefaultComputedStyle && (r = e.getDefaultComputedStyle(i[0])) ? r.display : h.css(i[0], "display");
			return i.detach(), s
		}

		function Mt(e) {
			var t = T,
				n = At[e];
			return n || (n = Ot(e, t), "none" !== n && n || (Lt = (Lt || h("<iframe frameborder='0' width='0' height='0'/>")).appendTo(t.documentElement), t = (Lt[0].contentWindow || Lt[0].contentDocument).document, t.write(), t.close(), n = Ot(e, t), Lt.detach()), At[e] = n), n
		}

		function jt(e, t) {
			return {
				get: function () {
					var n = e();
					if (null != n) return n ? void delete this.get : (this.get = t).apply(this, arguments)
				}
			}
		}

		function Vt(e, t) {
			if (t in e) return t;
			var n = t.charAt(0).toUpperCase() + t.slice(1),
				r = t,
				i = Xt.length;
			while (i--)
				if (t = Xt[i] + n, t in e) return t;
			return r
		}

		function $t(e, t) {
			for (var n, r, i, s = [], o = 0, u = e.length; u > o; o++) r = e[o], r.style && (s[o] = h._data(r, "olddisplay"), n = r.style.display, t ? (s[o] || "none" !== n || (r.style.display = ""), "" === r.style.display && V(r) && (s[o] = h._data(r, "olddisplay", Mt(r.nodeName)))) : (i = V(r), (n && "none" !== n || !i) && h._data(r, "olddisplay", i ? n : h.css(r, "display"))));
			for (o = 0; u > o; o++) r = e[o], r.style && (t && "none" !== r.style.display && "" !== r.style.display || (r.style.display = t ? s[o] || "" : "none"));
			return e
		}

		function Jt(e, t, n) {
			var r = Rt.exec(t);
			return r ? Math.max(0, r[1] - (n || 0)) + (r[2] || "px") : t
		}

		function Kt(e, t, n, r, i) {
			for (var s = n === (r ? "border" : "content") ? 4 : "width" === t ? 1 : 0, o = 0; 4 > s; s += 2) "margin" === n && (o += h.css(e, n + X[s], !0, i)), r ? ("content" === n && (o -= h.css(e, "padding" + X[s], !0, i)), "margin" !== n && (o -= h.css(e, "border" + X[s] + "Width", !0, i))) : (o += h.css(e, "padding" + X[s], !0, i), "padding" !== n && (o += h.css(e, "border" + X[s] + "Width", !0, i)));
			return o
		}

		function Qt(e, t, n) {
			var r = !0,
				i = "width" === t ? e.offsetWidth : e.offsetHeight,
				s = Pt(e),
				o = l.boxSizing && "border-box" === h.css(e, "boxSizing", !1, s);
			if (0 >= i || null == i) {
				if (i = Ht(e, t, s), (0 > i || null == i) && (i = e.style[t]), Dt.test(i)) return i;
				r = o && (l.boxSizingReliable() || i === e.style[t]), i = parseFloat(i) || 0
			}
			return i + Kt(e, t, n || (o ? "border" : "content"), r, s) + "px"
		}

		function Gt(e, t, n, r, i) {
			return new Gt.prototype.init(e, t, n, r, i)
		}

		function on() {
			return setTimeout(function () {
				Yt = void 0
			}), Yt = h.now()
		}

		function un(e, t) {
			var n, r = {
					height: e
				},
				i = 0;
			for (t = t ? 1 : 0; 4 > i; i += 2 - t) n = X[i], r["margin" + n] = r["padding" + n] = e;
			return t && (r.opacity = r.width = e), r
		}

		function an(e, t, n) {
			for (var r, i = (sn[t] || []).concat(sn["*"]), s = 0, o = i.length; o > s; s++)
				if (r = i[s].call(n, t, e)) return r
		}

		function fn(e, t, n) {
			var r, i, s, o, u, a, f, c, p = this,
				d = {},
				v = e.style,
				m = e.nodeType && V(e),
				g = h._data(e, "fxshow");
			n.queue || (u = h._queueHooks(e, "fx"), null == u.unqueued && (u.unqueued = 0, a = u.empty.fire, u.empty.fire = function () {
				u.unqueued || a()
			}), u.unqueued++, p.always(function () {
				p.always(function () {
					u.unqueued--, h.queue(e, "fx").length || u.empty.fire()
				})
			})), 1 === e.nodeType && ("height" in t || "width" in t) && (n.overflow = [v.overflow, v.overflowX, v.overflowY], f = h.css(e, "display"), c = "none" === f ? h._data(e, "olddisplay") || Mt(e.nodeName) : f, "inline" === c && "none" === h.css(e, "float") && (l.inlineBlockNeedsLayout && "inline" !== Mt(e.nodeName) ? v.zoom = 1 : v.display = "inline-block")), n.overflow && (v.overflow = "hidden", l.shrinkWrapBlocks() || p.always(function () {
				v.overflow = n.overflow[0], v.overflowX = n.overflow[1], v.overflowY = n.overflow[2]
			}));
			for (r in t)
				if (i = t[r], en.exec(i)) {
					if (delete t[r], s = s || "toggle" === i, i === (m ? "hide" : "show")) {
						if ("show" !== i || !g || void 0 === g[r]) continue;
						m = !0
					}
					d[r] = g && g[r] || h.style(e, r)
				} else f = void 0;
			if (h.isEmptyObject(d)) "inline" === ("none" === f ? Mt(e.nodeName) : f) && (v.display = f);
			else {
				g ? "hidden" in g && (m = g.hidden) : g = h._data(e, "fxshow", {}), s && (g.hidden = !m), m ? h(e).show() : p.done(function () {
					h(e).hide()
				}), p.done(function () {
					var t;
					h._removeData(e, "fxshow");
					for (t in d) h.style(e, t, d[t])
				});
				for (r in d) o = an(m ? g[r] : 0, r, p), r in g || (g[r] = o.start, m && (o.end = o.start, o.start = "width" === r || "height" === r ? 1 : 0))
			}
		}

		function ln(e, t) {
			var n, r, i, s, o;
			for (n in e)
				if (r = h.camelCase(n), i = t[r], s = e[n], h.isArray(s) && (i = s[1], s = e[n] = s[0]), n !== r && (e[r] = s, delete e[n]), o = h.cssHooks[r], o && "expand" in o) {
					s = o.expand(s), delete e[r];
					for (n in s) n in e || (e[n] = s[n], t[n] = i)
				} else t[r] = i
		}

		function cn(e, t, n) {
			var r, i, s = 0,
				o = rn.length,
				u = h.Deferred().always(function () {
					delete a.elem
				}),
				a = function () {
					if (i) return !1;
					for (var t = Yt || on(), n = Math.max(0, f.startTime + f.duration - t), r = n / f.duration || 0, s = 1 - r, o = 0, a = f.tweens.length; a > o; o++) f.tweens[o].run(s);
					return u.notifyWith(e, [f, s, n]), 1 > s && a ? n : (u.resolveWith(e, [f]), !1)
				},
				f = u.promise({
					elem: e,
					props: h.extend({}, t),
					opts: h.extend(!0, {
						specialEasing: {}
					}, n),
					originalProperties: t,
					originalOptions: n,
					startTime: Yt || on(),
					duration: n.duration,
					tweens: [],
					createTween: function (t, n) {
						var r = h.Tween(e, f.opts, t, n, f.opts.specialEasing[t] || f.opts.easing);
						return f.tweens.push(r), r
					},
					stop: function (t) {
						var n = 0,
							r = t ? f.tweens.length : 0;
						if (i) return this;
						for (i = !0; r > n; n++) f.tweens[n].run(1);
						return t ? u.resolveWith(e, [f, t]) : u.rejectWith(e, [f, t]), this
					}
				}),
				l = f.props;
			for (ln(l, f.opts.specialEasing); o > s; s++)
				if (r = rn[s].call(f, e, l, f.opts)) return r;
			return h.map(l, an, f), h.isFunction(f.opts.start) && f.opts.start.call(e, f), h.fx.timer(h.extend(a, {
				elem: e,
				anim: f,
				queue: f.opts.queue
			})), f.progress(f.opts.progress).done(f.opts.done, f.opts.complete).fail(f.opts.fail).always(f.opts.always)
		}

		function Fn(e) {
			return function (t, n) {
				"string" != typeof t && (n = t, t = "*");
				var r, i = 0,
					s = t.toLowerCase().match(O) || [];
				if (h.isFunction(n))
					while (r = s[i++]) "+" === r.charAt(0) ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n)
			}
		}

		function In(e, t, n, r) {
			function o(u) {
				var a;
				return i[u] = !0, h.each(e[u] || [], function (e, u) {
					var f = u(t, n, r);
					return "string" != typeof f || s || i[f] ? s ? !(a = f) : void 0 : (t.dataTypes.unshift(f), o(f), !1)
				}), a
			}
			var i = {},
				s = e === Hn;
			return o(t.dataTypes[0]) || !i["*"] && o("*")
		}

		function qn(e, t) {
			var n, r, i = h.ajaxSettings.flatOptions || {};
			for (r in t) void 0 !== t[r] && ((i[r] ? e : n || (n = {}))[r] = t[r]);
			return n && h.extend(!0, e, n), e
		}

		function Rn(e, t, n) {
			var r, i, s, o, u = e.contents,
				a = e.dataTypes;
			while ("*" === a[0]) a.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
			if (i)
				for (o in u)
					if (u[o] && u[o].test(i)) {
						a.unshift(o);
						break
					}
			if (a[0] in n) s = a[0];
			else {
				for (o in n) {
					if (!a[0] || e.converters[o + " " + a[0]]) {
						s = o;
						break
					}
					r || (r = o)
				}
				s = s || r
			}
			return s ? (s !== a[0] && a.unshift(s), n[s]) : void 0
		}

		function Un(e, t, n, r) {
			var i, s, o, u, a, f = {},
				l = e.dataTypes.slice();
			if (l[1])
				for (o in e.converters) f[o.toLowerCase()] = e.converters[o];
			s = l.shift();
			while (s)
				if (e.responseFields[s] && (n[e.responseFields[s]] = t), !a && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), a = s, s = l.shift())
					if ("*" === s) s = a;
					else if ("*" !== a && a !== s) {
				if (o = f[a + " " + s] || f["* " + s], !o)
					for (i in f)
						if (u = i.split(" "), u[1] === s && (o = f[a + " " + u[0]] || f["* " + u[0]])) {
							o === !0 ? o = f[i] : f[i] !== !0 && (s = u[0], l.unshift(u[1]));
							break
						}
				if (o !== !0)
					if (o && e["throws"]) t = o(t);
					else try {
						t = o(t)
					} catch (c) {
						return {
							state: "parsererror",
							error: o ? c : "No conversion from " + a + " to " + s
						}
					}
			}
			return {
				state: "success",
				data: t
			}
		}

		function Jn(e, t, n, r) {
			var i;
			if (h.isArray(t)) h.each(t, function (t, i) {
				n || Wn.test(e) ? r(e, i) : Jn(e + "[" + ("object" == typeof i ? t : "") + "]", i, n, r)
			});
			else if (n || "object" !== h.type(t)) r(e, t);
			else
				for (i in t) Jn(e + "[" + i + "]", t[i], n, r)
		}

		function Yn() {
			try {
				return new e.XMLHttpRequest
			} catch (t) {}
		}

		function Zn() {
			try {
				return new e.ActiveXObject("Microsoft.XMLHTTP")
			} catch (t) {}
		}

		function ir(e) {
			return h.isWindow(e) ? e : 9 === e.nodeType ? e.defaultView || e.parentWindow : !1
		}
		var n = [],
			r = n.slice,
			i = n.concat,
			s = n.push,
			o = n.indexOf,
			u = {},
			a = u.toString,
			f = u.hasOwnProperty,
			l = {},
			c = "1.11.1",
			h = function (e, t) {
				return new h.fn.init(e, t)
			},
			p = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
			d = /^-ms-/,
			v = /-([\da-z])/gi,
			m = function (e, t) {
				return t.toUpperCase()
			};
		h.fn = h.prototype = {
			jquery: c,
			constructor: h,
			selector: "",
			length: 0,
			toArray: function () {
				return r.call(this)
			},
			get: function (e) {
				return null != e ? 0 > e ? this[e + this.length] : this[e] : r.call(this)
			},
			pushStack: function (e) {
				var t = h.merge(this.constructor(), e);
				return t.prevObject = this, t.context = this.context, t
			},
			each: function (e, t) {
				return h.each(this, e, t)
			},
			map: function (e) {
				return this.pushStack(h.map(this, function (t, n) {
					return e.call(t, n, t)
				}))
			},
			slice: function () {
				return this.pushStack(r.apply(this, arguments))
			},
			first: function () {
				return this.eq(0)
			},
			last: function () {
				return this.eq(-1)
			},
			eq: function (e) {
				var t = this.length,
					n = +e + (0 > e ? t : 0);
				return this.pushStack(n >= 0 && t > n ? [this[n]] : [])
			},
			end: function () {
				return this.prevObject || this.constructor(null)
			},
			push: s,
			sort: n.sort,
			splice: n.splice
		}, h.extend = h.fn.extend = function () {
			var e, t, n, r, i, s, o = arguments[0] || {},
				u = 1,
				a = arguments.length,
				f = !1;
			for ("boolean" == typeof o && (f = o, o = arguments[u] || {}, u++), "object" == typeof o || h.isFunction(o) || (o = {}), u === a && (o = this, u--); a > u; u++)
				if (null != (i = arguments[u]))
					for (r in i) e = o[r], n = i[r], o !== n && (f && n && (h.isPlainObject(n) || (t = h.isArray(n))) ? (t ? (t = !1, s = e && h.isArray(e) ? e : []) : s = e && h.isPlainObject(e) ? e : {}, o[r] = h.extend(f, s, n)) : void 0 !== n && (o[r] = n));
			return o
		}, h.extend({
			expando: "jQuery" + (c + Math.random()).replace(/\D/g, ""),
			isReady: !0,
			error: function (e) {
				throw new Error(e)
			},
			noop: function () {},
			isFunction: function (e) {
				return "function" === h.type(e)
			},
			isArray: Array.isArray || function (e) {
				return "array" === h.type(e)
			},
			isWindow: function (e) {
				return null != e && e == e.window
			},
			isNumeric: function (e) {
				return !h.isArray(e) && e - parseFloat(e) >= 0
			},
			isEmptyObject: function (e) {
				var t;
				for (t in e) return !1;
				return !0
			},
			isPlainObject: function (e) {
				var t;
				if (!e || "object" !== h.type(e) || e.nodeType || h.isWindow(e)) return !1;
				try {
					if (e.constructor && !f.call(e, "constructor") && !f.call(e.constructor.prototype, "isPrototypeOf")) return !1
				} catch (n) {
					return !1
				}
				if (l.ownLast)
					for (t in e) return f.call(e, t);
				for (t in e);
				return void 0 === t || f.call(e, t)
			},
			type: function (e) {
				return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? u[a.call(e)] || "object" : typeof e
			},
			globalEval: function (t) {
				t && h.trim(t) && (e.execScript || function (t) {
					e.eval.call(e, t)
				})(t)
			},
			camelCase: function (e) {
				return e.replace(d, "ms-").replace(v, m)
			},
			nodeName: function (e, t) {
				return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
			},
			each: function (e, t, n) {
				var r, i = 0,
					s = e.length,
					o = g(e);
				if (n) {
					if (o) {
						for (; s > i; i++)
							if (r = t.apply(e[i], n), r === !1) break
					} else
						for (i in e)
							if (r = t.apply(e[i], n), r === !1) break
				} else if (o) {
					for (; s > i; i++)
						if (r = t.call(e[i], i, e[i]), r === !1) break
				} else
					for (i in e)
						if (r = t.call(e[i], i, e[i]), r === !1) break; return e
			},
			trim: function (e) {
				return null == e ? "" : (e + "").replace(p, "")
			},
			makeArray: function (e, t) {
				var n = t || [];
				return null != e && (g(Object(e)) ? h.merge(n, "string" == typeof e ? [e] : e) : s.call(n, e)), n
			},
			inArray: function (e, t, n) {
				var r;
				if (t) {
					if (o) return o.call(t, e, n);
					for (r = t.length, n = n ? 0 > n ? Math.max(0, r + n) : n : 0; r > n; n++)
						if (n in t && t[n] === e) return n
				}
				return -1
			},
			merge: function (e, t) {
				var n = +t.length,
					r = 0,
					i = e.length;
				while (n > r) e[i++] = t[r++];
				if (n !== n)
					while (void 0 !== t[r]) e[i++] = t[r++];
				return e.length = i, e
			},
			grep: function (e, t, n) {
				for (var r, i = [], s = 0, o = e.length, u = !n; o > s; s++) r = !t(e[s], s), r !== u && i.push(e[s]);
				return i
			},
			map: function (e, t, n) {
				var r, s = 0,
					o = e.length,
					u = g(e),
					a = [];
				if (u)
					for (; o > s; s++) r = t(e[s], s, n), null != r && a.push(r);
				else
					for (s in e) r = t(e[s], s, n), null != r && a.push(r);
				return i.apply([], a)
			},
			guid: 1,
			proxy: function (e, t) {
				var n, i, s;
				return "string" == typeof t && (s = e[t], t = e, e = s), h.isFunction(e) ? (n = r.call(arguments, 2), i = function () {
					return e.apply(t || this, n.concat(r.call(arguments)))
				}, i.guid = e.guid = e.guid || h.guid++, i) : void 0
			},
			now: function () {
				return +(new Date)
			},
			support: l
		}), h.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (e, t) {
			u["[object " + t + "]"] = t.toLowerCase()
		});
		var y = function (e) {
			function st(e, t, r, i) {
				var s, u, f, l, c, d, g, y, S, x;
				if ((t ? t.ownerDocument || t : E) !== p && h(t), t = t || p, r = r || [], !e || "string" != typeof e) return r;
				if (1 !== (l = t.nodeType) && 9 !== l) return [];
				if (v && !i) {
					if (s = Z.exec(e))
						if (f = s[1]) {
							if (9 === l) {
								if (u = t.getElementById(f), !u || !u.parentNode) return r;
								if (u.id === f) return r.push(u), r
							} else if (t.ownerDocument && (u = t.ownerDocument.getElementById(f)) && b(t, u) && u.id === f) return r.push(u), r
						} else {
							if (s[2]) return P.apply(r, t.getElementsByTagName(e)), r;
							if ((f = s[3]) && n.getElementsByClassName && t.getElementsByClassName) return P.apply(r, t.getElementsByClassName(f)), r
						}
					if (n.qsa && (!m || !m.test(e))) {
						if (y = g = w, S = t, x = 9 === l && e, 1 === l && "object" !== t.nodeName.toLowerCase()) {
							d = o(e), (g = t.getAttribute("id")) ? y = g.replace(tt, "\\$&") : t.setAttribute("id", y), y = "[id='" + y + "'] ", c = d.length;
							while (c--) d[c] = y + mt(d[c]);
							S = et.test(e) && dt(t.parentNode) || t, x = d.join(",")
						}
						if (x) try {
							return P.apply(r, S.querySelectorAll(x)), r
						} catch (T) {} finally {
							g || t.removeAttribute("id")
						}
					}
				}
				return a(e.replace(z, "$1"), t, r, i)
			}

			function ot() {
				function t(n, i) {
					return e.push(n + " ") > r.cacheLength && delete t[e.shift()], t[n + " "] = i
				}
				var e = [];
				return t
			}

			function ut(e) {
				return e[w] = !0, e
			}

			function at(e) {
				var t = p.createElement("div");
				try {
					return !!e(t)
				} catch (n) {
					return !1
				} finally {
					t.parentNode && t.parentNode.removeChild(t), t = null
				}
			}

			function ft(e, t) {
				var n = e.split("|"),
					i = e.length;
				while (i--) r.attrHandle[n[i]] = t
			}

			function lt(e, t) {
				var n = t && e,
					r = n && 1 === e.nodeType && 1 === t.nodeType && (~t.sourceIndex || A) - (~e.sourceIndex || A);
				if (r) return r;
				if (n)
					while (n = n.nextSibling)
						if (n === t) return -1;
				return e ? 1 : -1
			}

			function ct(e) {
				return function (t) {
					var n = t.nodeName.toLowerCase();
					return "input" === n && t.type === e
				}
			}

			function ht(e) {
				return function (t) {
					var n = t.nodeName.toLowerCase();
					return ("input" === n || "button" === n) && t.type === e
				}
			}

			function pt(e) {
				return ut(function (t) {
					return t = +t, ut(function (n, r) {
						var i, s = e([], n.length, t),
							o = s.length;
						while (o--) n[i = s[o]] && (n[i] = !(r[i] = n[i]))
					})
				})
			}

			function dt(e) {
				return e && typeof e.getElementsByTagName !== L && e
			}

			function vt() {}

			function mt(e) {
				for (var t = 0, n = e.length, r = ""; n > t; t++) r += e[t].value;
				return r
			}

			function gt(e, t, n) {
				var r = t.dir,
					i = n && "parentNode" === r,
					s = x++;
				return t.first ? function (t, n, s) {
					while (t = t[r])
						if (1 === t.nodeType || i) return e(t, n, s)
				} : function (t, n, o) {
					var u, a, f = [S, s];
					if (o) {
						while (t = t[r])
							if ((1 === t.nodeType || i) && e(t, n, o)) return !0
					} else
						while (t = t[r])
							if (1 === t.nodeType || i) {
								if (a = t[w] || (t[w] = {}), (u = a[r]) && u[0] === S && u[1] === s) return f[2] = u[2];
								if (a[r] = f, f[2] = e(t, n, o)) return !0
							}
				}
			}

			function yt(e) {
				return e.length > 1 ? function (t, n, r) {
					var i = e.length;
					while (i--)
						if (!e[i](t, n, r)) return !1;
					return !0
				} : e[0]
			}

			function bt(e, t, n) {
				for (var r = 0, i = t.length; i > r; r++) st(e, t[r], n);
				return n
			}

			function wt(e, t, n, r, i) {
				for (var s, o = [], u = 0, a = e.length, f = null != t; a > u; u++)(s = e[u]) && (!n || n(s, r, i)) && (o.push(s), f && t.push(u));
				return o
			}

			function Et(e, t, n, r, i, s) {
				return r && !r[w] && (r = Et(r)), i && !i[w] && (i = Et(i, s)), ut(function (s, o, u, a) {
					var f, l, c, h = [],
						p = [],
						d = o.length,
						v = s || bt(t || "*", u.nodeType ? [u] : u, []),
						m = !e || !s && t ? v : wt(v, h, e, u, a),
						g = n ? i || (s ? e : d || r) ? [] : o : m;
					if (n && n(m, g, u, a), r) {
						f = wt(g, p), r(f, [], u, a), l = f.length;
						while (l--)(c = f[l]) && (g[p[l]] = !(m[p[l]] = c))
					}
					if (s) {
						if (i || e) {
							if (i) {
								f = [], l = g.length;
								while (l--)(c = g[l]) && f.push(m[l] = c);
								i(null, g = [], f, a)
							}
							l = g.length;
							while (l--)(c = g[l]) && (f = i ? B.call(s, c) : h[l]) > -1 && (s[f] = !(o[f] = c))
						}
					} else g = wt(g === o ? g.splice(d, g.length) : g), i ? i(null, o, g, a) : P.apply(o, g)
				})
			}

			function St(e) {
				for (var t, n, i, s = e.length, o = r.relative[e[0].type], u = o || r.relative[" "], a = o ? 1 : 0, l = gt(function (e) {
						return e === t
					}, u, !0), c = gt(function (e) {
						return B.call(t, e) > -1
					}, u, !0), h = [function (e, n, r) {
						return !o && (r || n !== f) || ((t = n).nodeType ? l(e, n, r) : c(e, n, r))
					}]; s > a; a++)
					if (n = r.relative[e[a].type]) h = [gt(yt(h), n)];
					else {
						if (n = r.filter[e[a].type].apply(null, e[a].matches), n[w]) {
							for (i = ++a; s > i; i++)
								if (r.relative[e[i].type]) break;
							return Et(a > 1 && yt(h), a > 1 && mt(e.slice(0, a - 1).concat({
								value: " " === e[a - 2].type ? "*" : ""
							})).replace(z, "$1"), n, i > a && St(e.slice(a, i)), s > i && St(e = e.slice(i)), s > i && mt(e))
						}
						h.push(n)
					}
				return yt(h)
			}

			function xt(e, t) {
				var n = t.length > 0,
					i = e.length > 0,
					s = function (s, o, u, a, l) {
						var c, h, d, v = 0,
							m = "0",
							g = s && [],
							y = [],
							b = f,
							w = s || i && r.find.TAG("*", l),
							E = S += null == b ? 1 : Math.random() || .1,
							x = w.length;
						for (l && (f = o !== p && o); m !== x && null != (c = w[m]); m++) {
							if (i && c) {
								h = 0;
								while (d = e[h++])
									if (d(c, o, u)) {
										a.push(c);
										break
									}
								l && (S = E)
							}
							n && ((c = !d && c) && v--, s && g.push(c))
						}
						if (v += m, n && m !== v) {
							h = 0;
							while (d = t[h++]) d(g, y, o, u);
							if (s) {
								if (v > 0)
									while (m--) g[m] || y[m] || (y[m] = _.call(a));
								y = wt(y)
							}
							P.apply(a, y), l && !s && y.length > 0 && v + t.length > 1 && st.uniqueSort(a)
						}
						return l && (S = E, f = b), g
					};
				return n ? ut(s) : s
			}
			var t, n, r, i, s, o, u, a, f, l, c, h, p, d, v, m, g, y, b, w = "sizzle" + -(new Date),
				E = e.document,
				S = 0,
				x = 0,
				T = ot(),
				N = ot(),
				C = ot(),
				k = function (e, t) {
					return e === t && (c = !0), 0
				},
				L = "undefined",
				A = 1 << 31,
				O = {}.hasOwnProperty,
				M = [],
				_ = M.pop,
				D = M.push,
				P = M.push,
				H = M.slice,
				B = M.indexOf || function (e) {
					for (var t = 0, n = this.length; n > t; t++)
						if (this[t] === e) return t;
					return -1
				},
				j = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
				F = "[\\x20\\t\\r\\n\\f]",
				I = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
				q = I.replace("w", "w#"),
				R = "\\[" + F + "*(" + I + ")(?:" + F + "*([*^$|!~]?=)" + F + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + q + "))|)" + F + "*\\]",
				U = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + R + ")*)|.*)\\)|)",
				z = new RegExp("^" + F + "+|((?:^|[^\\\\])(?:\\\\.)*)" + F + "+$", "g"),
				W = new RegExp("^" + F + "*," + F + "*"),
				X = new RegExp("^" + F + "*([>+~]|" + F + ")" + F + "*"),
				V = new RegExp("=" + F + "*([^\\]'\"]*?)" + F + "*\\]", "g"),
				$ = new RegExp(U),
				J = new RegExp("^" + q + "$"),
				K = {
					ID: new RegExp("^#(" + I + ")"),
					CLASS: new RegExp("^\\.(" + I + ")"),
					TAG: new RegExp("^(" + I.replace("w", "w*") + ")"),
					ATTR: new RegExp("^" + R),
					PSEUDO: new RegExp("^" + U),
					CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + F + "*(even|odd|(([+-]|)(\\d*)n|)" + F + "*(?:([+-]|)" + F + "*(\\d+)|))" + F + "*\\)|)", "i"),
					bool: new RegExp("^(?:" + j + ")$", "i"),
					needsContext: new RegExp("^" + F + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + F + "*((?:-\\d)?\\d*)" + F + "*\\)|)(?=[^-]|$)", "i")
				},
				Q = /^(?:input|select|textarea|button)$/i,
				G = /^h\d$/i,
				Y = /^[^{]+\{\s*\[native \w/,
				Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
				et = /[+~]/,
				tt = /'|\\/g,
				nt = new RegExp("\\\\([\\da-f]{1,6}" + F + "?|(" + F + ")|.)", "ig"),
				rt = function (e, t, n) {
					var r = "0x" + t - 65536;
					return r !== r || n ? t : 0 > r ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320)
				};
			try {
				P.apply(M = H.call(E.childNodes), E.childNodes), M[E.childNodes.length].nodeType
			} catch (it) {
				P = {
					apply: M.length ? function (e, t) {
						D.apply(e, H.call(t))
					} : function (e, t) {
						var n = e.length,
							r = 0;
						while (e[n++] = t[r++]);
						e.length = n - 1
					}
				}
			}
			n = st.support = {}, s = st.isXML = function (e) {
				var t = e && (e.ownerDocument || e).documentElement;
				return t ? "HTML" !== t.nodeName : !1
			}, h = st.setDocument = function (e) {
				var t, i = e ? e.ownerDocument || e : E,
					o = i.defaultView;
				return i !== p && 9 === i.nodeType && i.documentElement ? (p = i, d = i.documentElement, v = !s(i), o && o !== o.top && (o.addEventListener ? o.addEventListener("unload", function () {
					h()
				}, !1) : o.attachEvent && o.attachEvent("onunload", function () {
					h()
				})), n.attributes = at(function (e) {
					return e.className = "i", !e.getAttribute("className")
				}), n.getElementsByTagName = at(function (e) {
					return e.appendChild(i.createComment("")), !e.getElementsByTagName("*").length
				}), n.getElementsByClassName = Y.test(i.getElementsByClassName) && at(function (e) {
					return e.innerHTML = "<div class='a'></div><div class='a i'></div>", e.firstChild.className = "i", 2 === e.getElementsByClassName("i").length
				}), n.getById = at(function (e) {
					return d.appendChild(e).id = w, !i.getElementsByName || !i.getElementsByName(w).length
				}), n.getById ? (r.find.ID = function (e, t) {
					if (typeof t.getElementById !== L && v) {
						var n = t.getElementById(e);
						return n && n.parentNode ? [n] : []
					}
				}, r.filter.ID = function (e) {
					var t = e.replace(nt, rt);
					return function (e) {
						return e.getAttribute("id") === t
					}
				}) : (delete r.find.ID, r.filter.ID = function (e) {
					var t = e.replace(nt, rt);
					return function (e) {
						var n = typeof e.getAttributeNode !== L && e.getAttributeNode("id");
						return n && n.value === t
					}
				}), r.find.TAG = n.getElementsByTagName ? function (e, t) {
					return typeof t.getElementsByTagName !== L ? t.getElementsByTagName(e) : void 0
				} : function (e, t) {
					var n, r = [],
						i = 0,
						s = t.getElementsByTagName(e);
					if ("*" === e) {
						while (n = s[i++]) 1 === n.nodeType && r.push(n);
						return r
					}
					return s
				}, r.find.CLASS = n.getElementsByClassName && function (e, t) {
					return typeof t.getElementsByClassName !== L && v ? t.getElementsByClassName(e) : void 0
				}, g = [], m = [], (n.qsa = Y.test(i.querySelectorAll)) && (at(function (e) {
					e.innerHTML = "<select msallowclip=''><option selected=''></option></select>", e.querySelectorAll("[msallowclip^='']").length && m.push("[*^$]=" + F + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || m.push("\\[" + F + "*(?:value|" + j + ")"), e.querySelectorAll(":checked").length || m.push(":checked")
				}), at(function (e) {
					var t = i.createElement("input");
					t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && m.push("name" + F + "*[*^$|!~]?="), e.querySelectorAll(":enabled").length || m.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), m.push(",.*:")
				})), (n.matchesSelector = Y.test(y = d.matches || d.webkitMatchesSelector || d.mozMatchesSelector || d.oMatchesSelector || d.msMatchesSelector)) && at(function (e) {
					n.disconnectedMatch = y.call(e, "div"), y.call(e, "[s!='']:x"), g.push("!=", U)
				}), m = m.length && new RegExp(m.join("|")), g = g.length && new RegExp(g.join("|")), t = Y.test(d.compareDocumentPosition), b = t || Y.test(d.contains) ? function (e, t) {
					var n = 9 === e.nodeType ? e.documentElement : e,
						r = t && t.parentNode;
					return e === r || !!r && 1 === r.nodeType && !!(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r))
				} : function (e, t) {
					if (t)
						while (t = t.parentNode)
							if (t === e) return !0;
					return !1
				}, k = t ? function (e, t) {
					if (e === t) return c = !0, 0;
					var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
					return r ? r : (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1, 1 & r || !n.sortDetached && t.compareDocumentPosition(e) === r ? e === i || e.ownerDocument === E && b(E, e) ? -1 : t === i || t.ownerDocument === E && b(E, t) ? 1 : l ? B.call(l, e) - B.call(l, t) : 0 : 4 & r ? -1 : 1)
				} : function (e, t) {
					if (e === t) return c = !0, 0;
					var n, r = 0,
						s = e.parentNode,
						o = t.parentNode,
						u = [e],
						a = [t];
					if (!s || !o) return e === i ? -1 : t === i ? 1 : s ? -1 : o ? 1 : l ? B.call(l, e) - B.call(l, t) : 0;
					if (s === o) return lt(e, t);
					n = e;
					while (n = n.parentNode) u.unshift(n);
					n = t;
					while (n = n.parentNode) a.unshift(n);
					while (u[r] === a[r]) r++;
					return r ? lt(u[r], a[r]) : u[r] === E ? -1 : a[r] === E ? 1 : 0
				}, i) : p
			}, st.matches = function (e, t) {
				return st(e, null, null, t)
			}, st.matchesSelector = function (e, t) {
				if ((e.ownerDocument || e) !== p && h(e), t = t.replace(V, "='$1']"), !(!n.matchesSelector || !v || g && g.test(t) || m && m.test(t))) try {
					var r = y.call(e, t);
					if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r
				} catch (i) {}
				return st(t, p, null, [e]).length > 0
			}, st.contains = function (e, t) {
				return (e.ownerDocument || e) !== p && h(e), b(e, t)
			}, st.attr = function (e, t) {
				(e.ownerDocument || e) !== p && h(e);
				var i = r.attrHandle[t.toLowerCase()],
					s = i && O.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !v) : void 0;
				return void 0 !== s ? s : n.attributes || !v ? e.getAttribute(t) : (s = e.getAttributeNode(t)) && s.specified ? s.value : null
			}, st.error = function (e) {
				throw new Error("Syntax error, unrecognized expression: " + e)
			}, st.uniqueSort = function (e) {
				var t, r = [],
					i = 0,
					s = 0;
				if (c = !n.detectDuplicates, l = !n.sortStable && e.slice(0), e.sort(k), c) {
					while (t = e[s++]) t === e[s] && (i = r.push(s));
					while (i--) e.splice(r[i], 1)
				}
				return l = null, e
			}, i = st.getText = function (e) {
				var t, n = "",
					r = 0,
					s = e.nodeType;
				if (s) {
					if (1 === s || 9 === s || 11 === s) {
						if ("string" == typeof e.textContent) return e.textContent;
						for (e = e.firstChild; e; e = e.nextSibling) n += i(e)
					} else if (3 === s || 4 === s) return e.nodeValue
				} else
					while (t = e[r++]) n += i(t);
				return n
			}, r = st.selectors = {
				cacheLength: 50,
				createPseudo: ut,
				match: K,
				attrHandle: {},
				find: {},
				relative: {
					">": {
						dir: "parentNode",
						first: !0
					},
					" ": {
						dir: "parentNode"
					},
					"+": {
						dir: "previousSibling",
						first: !0
					},
					"~": {
						dir: "previousSibling"
					}
				},
				preFilter: {
					ATTR: function (e) {
						return e[1] = e[1].replace(nt, rt), e[3] = (e[3] || e[4] || e[5] || "").replace(nt, rt), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
					},
					CHILD: function (e) {
						return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || st.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && st.error(e[0]), e
					},
					PSEUDO: function (e) {
						var t, n = !e[6] && e[2];
						return K.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && $.test(n) && (t = o(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
					}
				},
				filter: {
					TAG: function (e) {
						var t = e.replace(nt, rt).toLowerCase();
						return "*" === e ? function () {
							return !0
						} : function (e) {
							return e.nodeName && e.nodeName.toLowerCase() === t
						}
					},
					CLASS: function (e) {
						var t = T[e + " "];
						return t || (t = new RegExp("(^|" + F + ")" + e + "(" + F + "|$)")) && T(e, function (e) {
							return t.test("string" == typeof e.className && e.className || typeof e.getAttribute !== L && e.getAttribute("class") || "")
						})
					},
					ATTR: function (e, t, n) {
						return function (r) {
							var i = st.attr(r, e);
							return null == i ? "!=" === t : t ? (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i + " ").indexOf(n) > -1 : "|=" === t ? i === n || i.slice(0, n.length + 1) === n + "-" : !1) : !0
						}
					},
					CHILD: function (e, t, n, r, i) {
						var s = "nth" !== e.slice(0, 3),
							o = "last" !== e.slice(-4),
							u = "of-type" === t;
						return 1 === r && 0 === i ? function (e) {
							return !!e.parentNode
						} : function (t, n, a) {
							var f, l, c, h, p, d, v = s !== o ? "nextSibling" : "previousSibling",
								m = t.parentNode,
								g = u && t.nodeName.toLowerCase(),
								y = !a && !u;
							if (m) {
								if (s) {
									while (v) {
										c = t;
										while (c = c[v])
											if (u ? c.nodeName.toLowerCase() === g : 1 === c.nodeType) return !1;
										d = v = "only" === e && !d && "nextSibling"
									}
									return !0
								}
								if (d = [o ? m.firstChild : m.lastChild], o && y) {
									l = m[w] || (m[w] = {}), f = l[e] || [], p = f[0] === S && f[1], h = f[0] === S && f[2], c = p && m.childNodes[p];
									while (c = ++p && c && c[v] || (h = p = 0) || d.pop())
										if (1 === c.nodeType && ++h && c === t) {
											l[e] = [S, p, h];
											break
										}
								} else if (y && (f = (t[w] || (t[w] = {}))[e]) && f[0] === S) h = f[1];
								else
									while (c = ++p && c && c[v] || (h = p = 0) || d.pop())
										if ((u ? c.nodeName.toLowerCase() === g : 1 === c.nodeType) && ++h && (y && ((c[w] || (c[w] = {}))[e] = [S, h]), c === t)) break; return h -= i, h === r || h % r === 0 && h / r >= 0
							}
						}
					},
					PSEUDO: function (e, t) {
						var n, i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || st.error("unsupported pseudo: " + e);
						return i[w] ? i(t) : i.length > 1 ? (n = [e, e, "", t], r.setFilters.hasOwnProperty(e.toLowerCase()) ? ut(function (e, n) {
							var r, s = i(e, t),
								o = s.length;
							while (o--) r = B.call(e, s[o]), e[r] = !(n[r] = s[o])
						}) : function (e) {
							return i(e, 0, n)
						}) : i
					}
				},
				pseudos: {
					not: ut(function (e) {
						var t = [],
							n = [],
							r = u(e.replace(z, "$1"));
						return r[w] ? ut(function (e, t, n, i) {
							var s, o = r(e, null, i, []),
								u = e.length;
							while (u--)(s = o[u]) && (e[u] = !(t[u] = s))
						}) : function (e, i, s) {
							return t[0] = e, r(t, null, s, n), !n.pop()
						}
					}),
					has: ut(function (e) {
						return function (t) {
							return st(e, t).length > 0
						}
					}),
					contains: ut(function (e) {
						return function (t) {
							return (t.textContent || t.innerText || i(t)).indexOf(e) > -1
						}
					}),
					lang: ut(function (e) {
						return J.test(e || "") || st.error("unsupported lang: " + e), e = e.replace(nt, rt).toLowerCase(),
							function (t) {
								var n;
								do
									if (n = v ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return n = n.toLowerCase(), n === e || 0 === n.indexOf(e + "-");
								while ((t = t.parentNode) && 1 === t.nodeType);
								return !1
							}
					}),
					target: function (t) {
						var n = e.location && e.location.hash;
						return n && n.slice(1) === t.id
					},
					root: function (e) {
						return e === d
					},
					focus: function (e) {
						return e === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
					},
					enabled: function (e) {
						return e.disabled === !1
					},
					disabled: function (e) {
						return e.disabled === !0
					},
					checked: function (e) {
						var t = e.nodeName.toLowerCase();
						return "input" === t && !!e.checked || "option" === t && !!e.selected
					},
					selected: function (e) {
						return e.parentNode && e.parentNode.selectedIndex, e.selected === !0
					},
					empty: function (e) {
						for (e = e.firstChild; e; e = e.nextSibling)
							if (e.nodeType < 6) return !1;
						return !0
					},
					parent: function (e) {
						return !r.pseudos.empty(e)
					},
					header: function (e) {
						return G.test(e.nodeName)
					},
					input: function (e) {
						return Q.test(e.nodeName)
					},
					button: function (e) {
						var t = e.nodeName.toLowerCase();
						return "input" === t && "button" === e.type || "button" === t
					},
					text: function (e) {
						var t;
						return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
					},
					first: pt(function () {
						return [0]
					}),
					last: pt(function (e, t) {
						return [t - 1]
					}),
					eq: pt(function (e, t, n) {
						return [0 > n ? n + t : n]
					}),
					even: pt(function (e, t) {
						for (var n = 0; t > n; n += 2) e.push(n);
						return e
					}),
					odd: pt(function (e, t) {
						for (var n = 1; t > n; n += 2) e.push(n);
						return e
					}),
					lt: pt(function (e, t, n) {
						for (var r = 0 > n ? n + t : n; --r >= 0;) e.push(r);
						return e
					}),
					gt: pt(function (e, t, n) {
						for (var r = 0 > n ? n + t : n; ++r < t;) e.push(r);
						return e
					})
				}
			}, r.pseudos.nth = r.pseudos.eq;
			for (t in {
					radio: !0,
					checkbox: !0,
					file: !0,
					password: !0,
					image: !0
				}) r.pseudos[t] = ct(t);
			for (t in {
					submit: !0,
					reset: !0
				}) r.pseudos[t] = ht(t);
			return vt.prototype = r.filters = r.pseudos, r.setFilters = new vt, o = st.tokenize = function (e, t) {
				var n, i, s, o, u, a, f, l = N[e + " "];
				if (l) return t ? 0 : l.slice(0);
				u = e, a = [], f = r.preFilter;
				while (u) {
					(!n || (i = W.exec(u))) && (i && (u = u.slice(i[0].length) || u), a.push(s = [])), n = !1, (i = X.exec(u)) && (n = i.shift(), s.push({
						value: n,
						type: i[0].replace(z, " ")
					}), u = u.slice(n.length));
					for (o in r.filter) !(i = K[o].exec(u)) || f[o] && !(i = f[o](i)) || (n = i.shift(), s.push({
						value: n,
						type: o,
						matches: i
					}), u = u.slice(n.length));
					if (!n) break
				}
				return t ? u.length : u ? st.error(e) : N(e, a).slice(0)
			}, u = st.compile = function (e, t) {
				var n, r = [],
					i = [],
					s = C[e + " "];
				if (!s) {
					t || (t = o(e)), n = t.length;
					while (n--) s = St(t[n]), s[w] ? r.push(s) : i.push(s);
					s = C(e, xt(i, r)), s.selector = e
				}
				return s
			}, a = st.select = function (e, t, i, s) {
				var a, f, l, c, h, p = "function" == typeof e && e,
					d = !s && o(e = p.selector || e);
				if (i = i || [], 1 === d.length) {
					if (f = d[0] = d[0].slice(0), f.length > 2 && "ID" === (l = f[0]).type && n.getById && 9 === t.nodeType && v && r.relative[f[1].type]) {
						if (t = (r.find.ID(l.matches[0].replace(nt, rt), t) || [])[0], !t) return i;
						p && (t = t.parentNode), e = e.slice(f.shift().value.length)
					}
					a = K.needsContext.test(e) ? 0 : f.length;
					while (a--) {
						if (l = f[a], r.relative[c = l.type]) break;
						if ((h = r.find[c]) && (s = h(l.matches[0].replace(nt, rt), et.test(f[0].type) && dt(t.parentNode) || t))) {
							if (f.splice(a, 1), e = s.length && mt(f), !e) return P.apply(i, s), i;
							break
						}
					}
				}
				return (p || u(e, d))(s, t, !v, i, et.test(e) && dt(t.parentNode) || t), i
			}, n.sortStable = w.split("").sort(k).join("") === w, n.detectDuplicates = !!c, h(), n.sortDetached = at(function (e) {
				return 1 & e.compareDocumentPosition(p.createElement("div"))
			}), at(function (e) {
				return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
			}) || ft("type|href|height|width", function (e, t, n) {
				return n ? void 0 : e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
			}), n.attributes && at(function (e) {
				return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
			}) || ft("value", function (e, t, n) {
				return n || "input" !== e.nodeName.toLowerCase() ? void 0 : e.defaultValue
			}), at(function (e) {
				return null == e.getAttribute("disabled")
			}) || ft(j, function (e, t, n) {
				var r;
				return n ? void 0 : e[t] === !0 ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null
			}), st
		}(e);
		h.find = y, h.expr = y.selectors, h.expr[":"] = h.expr.pseudos, h.unique = y.uniqueSort, h.text = y.getText, h.isXMLDoc = y.isXML, h.contains = y.contains;
		var b = h.expr.match.needsContext,
			w = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
			E = /^.[^:#\[\.,]*$/;
		h.filter = function (e, t, n) {
			var r = t[0];
			return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? h.find.matchesSelector(r, e) ? [r] : [] : h.find.matches(e, h.grep(t, function (e) {
				return 1 === e.nodeType
			}))
		}, h.fn.extend({
			find: function (e) {
				var t, n = [],
					r = this,
					i = r.length;
				if ("string" != typeof e) return this.pushStack(h(e).filter(function () {
					for (t = 0; i > t; t++)
						if (h.contains(r[t], this)) return !0
				}));
				for (t = 0; i > t; t++) h.find(e, r[t], n);
				return n = this.pushStack(i > 1 ? h.unique(n) : n), n.selector = this.selector ? this.selector + " " + e : e, n
			},
			filter: function (e) {
				return this.pushStack(S(this, e || [], !1))
			},
			not: function (e) {
				return this.pushStack(S(this, e || [], !0))
			},
			is: function (e) {
				return !!S(this, "string" == typeof e && b.test(e) ? h(e) : e || [], !1).length
			}
		});
		var x, T = e.document,
			N = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
			C = h.fn.init = function (e, t) {
				var n, r;
				if (!e) return this;
				if ("string" == typeof e) {
					if (n = "<" === e.charAt(0) && ">" === e.charAt(e.length - 1) && e.length >= 3 ? [null, e, null] : N.exec(e), !n || !n[1] && t) return !t || t.jquery ? (t || x).find(e) : this.constructor(t).find(e);
					if (n[1]) {
						if (t = t instanceof h ? t[0] : t, h.merge(this, h.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : T, !0)), w.test(n[1]) && h.isPlainObject(t))
							for (n in t) h.isFunction(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
						return this
					}
					if (r = T.getElementById(n[2]), r && r.parentNode) {
						if (r.id !== n[2]) return x.find(e);
						this.length = 1, this[0] = r
					}
					return this.context = T, this.selector = e, this
				}
				return e.nodeType ? (this.context = this[0] = e, this.length = 1, this) : h.isFunction(e) ? "undefined" != typeof x.ready ? x.ready(e) : e(h) : (void 0 !== e.selector && (this.selector = e.selector, this.context = e.context), h.makeArray(e, this))
			};
		C.prototype = h.fn, x = h(T);
		var k = /^(?:parents|prev(?:Until|All))/,
			L = {
				children: !0,
				contents: !0,
				next: !0,
				prev: !0
			};
		h.extend({
			dir: function (e, t, n) {
				var r = [],
					i = e[t];
				while (i && 9 !== i.nodeType && (void 0 === n || 1 !== i.nodeType || !h(i).is(n))) 1 === i.nodeType && r.push(i), i = i[t];
				return r
			},
			sibling: function (e, t) {
				for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
				return n
			}
		}), h.fn.extend({
			has: function (e) {
				var t, n = h(e, this),
					r = n.length;
				return this.filter(function () {
					for (t = 0; r > t; t++)
						if (h.contains(this, n[t])) return !0
				})
			},
			closest: function (e, t) {
				for (var n, r = 0, i = this.length, s = [], o = b.test(e) || "string" != typeof e ? h(e, t || this.context) : 0; i > r; r++)
					for (n = this[r]; n && n !== t; n = n.parentNode)
						if (n.nodeType < 11 && (o ? o.index(n) > -1 : 1 === n.nodeType && h.find.matchesSelector(n, e))) {
							s.push(n);
							break
						}
				return this.pushStack(s.length > 1 ? h.unique(s) : s)
			},
			index: function (e) {
				return e ? "string" == typeof e ? h.inArray(this[0], h(e)) : h.inArray(e.jquery ? e[0] : e, this) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
			},
			add: function (e, t) {
				return this.pushStack(h.unique(h.merge(this.get(), h(e, t))))
			},
			addBack: function (e) {
				return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
			}
		}), h.each({
			parent: function (e) {
				var t = e.parentNode;
				return t && 11 !== t.nodeType ? t : null
			},
			parents: function (e) {
				return h.dir(e, "parentNode")
			},
			parentsUntil: function (e, t, n) {
				return h.dir(e, "parentNode", n)
			},
			next: function (e) {
				return A(e, "nextSibling")
			},
			prev: function (e) {
				return A(e, "previousSibling")
			},
			nextAll: function (e) {
				return h.dir(e, "nextSibling")
			},
			prevAll: function (e) {
				return h.dir(e, "previousSibling")
			},
			nextUntil: function (e, t, n) {
				return h.dir(e, "nextSibling", n)
			},
			prevUntil: function (e, t, n) {
				return h.dir(e, "previousSibling", n)
			},
			siblings: function (e) {
				return h.sibling((e.parentNode || {}).firstChild, e)
			},
			children: function (e) {
				return h.sibling(e.firstChild)
			},
			contents: function (e) {
				return h.nodeName(e, "iframe") ? e.contentDocument || e.contentWindow.document : h.merge([], e.childNodes)
			}
		}, function (e, t) {
			h.fn[e] = function (n, r) {
				var i = h.map(this, t, n);
				return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = h.filter(r, i)), this.length > 1 && (L[e] || (i = h.unique(i)), k.test(e) && (i = i.reverse())), this.pushStack(i)
			}
		});
		var O = /\S+/g,
			M = {};
		h.Callbacks = function (e) {
			e = "string" == typeof e ? M[e] || _(e) : h.extend({}, e);
			var t, n, r, i, s, o, u = [],
				a = !e.once && [],
				f = function (c) {
					for (n = e.memory && c, r = !0, s = o || 0, o = 0, i = u.length, t = !0; u && i > s; s++)
						if (u[s].apply(c[0], c[1]) === !1 && e.stopOnFalse) {
							n = !1;
							break
						}
					t = !1, u && (a ? a.length && f(a.shift()) : n ? u = [] : l.disable())
				},
				l = {
					add: function () {
						if (u) {
							var r = u.length;
							! function s(t) {
								h.each(t, function (t, n) {
									var r = h.type(n);
									"function" === r ? e.unique && l.has(n) || u.push(n) : n && n.length && "string" !== r && s(n)
								})
							}(arguments), t ? i = u.length : n && (o = r, f(n))
						}
						return this
					},
					remove: function () {
						return u && h.each(arguments, function (e, n) {
							var r;
							while ((r = h.inArray(n, u, r)) > -1) u.splice(r, 1), t && (i >= r && i--, s >= r && s--)
						}), this
					},
					has: function (e) {
						return e ? h.inArray(e, u) > -1 : !!u && !!u.length
					},
					empty: function () {
						return u = [], i = 0, this
					},
					disable: function () {
						return u = a = n = void 0, this
					},
					disabled: function () {
						return !u
					},
					lock: function () {
						return a = void 0, n || l.disable(), this
					},
					locked: function () {
						return !a
					},
					fireWith: function (e, n) {
						return !u || r && !a || (n = n || [], n = [e, n.slice ? n.slice() : n], t ? a.push(n) : f(n)), this
					},
					fire: function () {
						return l.fireWith(this, arguments), this
					},
					fired: function () {
						return !!r
					}
				};
			return l
		}, h.extend({
			Deferred: function (e) {
				var t = [
						["resolve", "done", h.Callbacks("once memory"), "resolved"],
						["reject", "fail", h.Callbacks("once memory"), "rejected"],
						["notify", "progress", h.Callbacks("memory")]
					],
					n = "pending",
					r = {
						state: function () {
							return n
						},
						always: function () {
							return i.done(arguments).fail(arguments), this
						},
						then: function () {
							var e = arguments;
							return h.Deferred(function (n) {
								h.each(t, function (t, s) {
									var o = h.isFunction(e[t]) && e[t];
									i[s[1]](function () {
										var e = o && o.apply(this, arguments);
										e && h.isFunction(e.promise) ? e.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[s[0] + "With"](this === r ? n.promise() : this, o ? [e] : arguments)
									})
								}), e = null
							}).promise()
						},
						promise: function (e) {
							return null != e ? h.extend(e, r) : r
						}
					},
					i = {};
				return r.pipe = r.then, h.each(t, function (e, s) {
					var o = s[2],
						u = s[3];
					r[s[1]] = o.add, u && o.add(function () {
						n = u
					}, t[1 ^ e][2].disable, t[2][2].lock), i[s[0]] = function () {
						return i[s[0] + "With"](this === i ? r : this, arguments), this
					}, i[s[0] + "With"] = o.fireWith
				}), r.promise(i), e && e.call(i, i), i
			},
			when: function (e) {
				var t = 0,
					n = r.call(arguments),
					i = n.length,
					s = 1 !== i || e && h.isFunction(e.promise) ? i : 0,
					o = 1 === s ? e : h.Deferred(),
					u = function (e, t, n) {
						return function (i) {
							t[e] = this, n[e] = arguments.length > 1 ? r.call(arguments) : i, n === a ? o.notifyWith(t, n) : --s || o.resolveWith(t, n)
						}
					},
					a, f, l;
				if (i > 1)
					for (a = new Array(i), f = new Array(i), l = new Array(i); i > t; t++) n[t] && h.isFunction(n[t].promise) ? n[t].promise().done(u(t, l, n)).fail(o.reject).progress(u(t, f, a)) : --s;
				return s || o.resolveWith(l, n), o.promise()
			}
		});
		var D;
		h.fn.ready = function (e) {
			return h.ready.promise().done(e), this
		}, h.extend({
			isReady: !1,
			readyWait: 1,
			holdReady: function (e) {
				e ? h.readyWait++ : h.ready(!0)
			},
			ready: function (e) {
				if (e === !0 ? !--h.readyWait : !h.isReady) {
					if (!T.body) return setTimeout(h.ready);
					h.isReady = !0, e !== !0 && --h.readyWait > 0 || (D.resolveWith(T, [h]), h.fn.triggerHandler && (h(T).triggerHandler("ready"), h(T).off("ready")))
				}
			}
		}), h.ready.promise = function (t) {
			if (!D)
				if (D = h.Deferred(), "complete" === T.readyState) setTimeout(h.ready);
				else if (T.addEventListener) T.addEventListener("DOMContentLoaded", H, !1), e.addEventListener("load", H, !1);
			else {
				T.attachEvent("onreadystatechange", H), e.attachEvent("onload", H);
				var n = !1;
				try {
					n = null == e.frameElement && T.documentElement
				} catch (r) {}
				n && n.doScroll && ! function i() {
					if (!h.isReady) {
						try {
							n.doScroll("left")
						} catch (e) {
							return setTimeout(i, 50)
						}
						P(), h.ready()
					}
				}()
			}
			return D.promise(t)
		};
		var B = "undefined",
			j;
		for (j in h(l)) break;
		l.ownLast = "0" !== j, l.inlineBlockNeedsLayout = !1, h(function () {
				var e, t, n, r;
				n = T.getElementsByTagName("body")[0], n && n.style && (t = T.createElement("div"), r = T.createElement("div"), r.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(r).appendChild(t), typeof t.style.zoom !== B && (t.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1", l.inlineBlockNeedsLayout = e = 3 === t.offsetWidth, e && (n.style.zoom = 1)), n.removeChild(r))
			}),
			function () {
				var e = T.createElement("div");
				if (null == l.deleteExpando) {
					l.deleteExpando = !0;
					try {
						delete e.test
					} catch (t) {
						l.deleteExpando = !1
					}
				}
				e = null
			}(), h.acceptData = function (e) {
				var t = h.noData[(e.nodeName + " ").toLowerCase()],
					n = +e.nodeType || 1;
				return 1 !== n && 9 !== n ? !1 : !t || t !== !0 && e.getAttribute("classid") === t
			};
		var F = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
			I = /([A-Z])/g;
		h.extend({
			cache: {},
			noData: {
				"applet ": !0,
				"embed ": !0,
				"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
			},
			hasData: function (e) {
				return e = e.nodeType ? h.cache[e[h.expando]] : e[h.expando], !!e && !R(e)
			},
			data: function (e, t, n) {
				return U(e, t, n)
			},
			removeData: function (e, t) {
				return z(e, t)
			},
			_data: function (e, t, n) {
				return U(e, t, n, !0)
			},
			_removeData: function (e, t) {
				return z(e, t, !0)
			}
		}), h.fn.extend({
			data: function (e, t) {
				var n, r, i, s = this[0],
					o = s && s.attributes;
				if (void 0 === e) {
					if (this.length && (i = h.data(s), 1 === s.nodeType && !h._data(s, "parsedAttrs"))) {
						n = o.length;
						while (n--) o[n] && (r = o[n].name, 0 === r.indexOf("data-") && (r = h.camelCase(r.slice(5)), q(s, r, i[r])));
						h._data(s, "parsedAttrs", !0)
					}
					return i
				}
				return "object" == typeof e ? this.each(function () {
					h.data(this, e)
				}) : arguments.length > 1 ? this.each(function () {
					h.data(this, e, t)
				}) : s ? q(s, e, h.data(s, e)) : void 0
			},
			removeData: function (e) {
				return this.each(function () {
					h.removeData(this, e)
				})
			}
		}), h.extend({
			queue: function (e, t, n) {
				var r;
				return e ? (t = (t || "fx") + "queue", r = h._data(e, t), n && (!r || h.isArray(n) ? r = h._data(e, t, h.makeArray(n)) : r.push(n)), r || []) : void 0
			},
			dequeue: function (e, t) {
				t = t || "fx";
				var n = h.queue(e, t),
					r = n.length,
					i = n.shift(),
					s = h._queueHooks(e, t),
					o = function () {
						h.dequeue(e, t)
					};
				"inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete s.stop, i.call(e, o, s)), !r && s && s.empty.fire()
			},
			_queueHooks: function (e, t) {
				var n = t + "queueHooks";
				return h._data(e, n) || h._data(e, n, {
					empty: h.Callbacks("once memory").add(function () {
						h._removeData(e, t + "queue"), h._removeData(e, n)
					})
				})
			}
		}), h.fn.extend({
			queue: function (e, t) {
				var n = 2;
				return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? h.queue(this[0], e) : void 0 === t ? this : this.each(function () {
					var n = h.queue(this, e, t);
					h._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && h.dequeue(this, e)
				})
			},
			dequeue: function (e) {
				return this.each(function () {
					h.dequeue(this, e)
				})
			},
			clearQueue: function (e) {
				return this.queue(e || "fx", [])
			},
			promise: function (e, t) {
				var n, r = 1,
					i = h.Deferred(),
					s = this,
					o = this.length,
					u = function () {
						--r || i.resolveWith(s, [s])
					};
				"string" != typeof e && (t = e, e = void 0), e = e || "fx";
				while (o--) n = h._data(s[o], e + "queueHooks"), n && n.empty && (r++, n.empty.add(u));
				return u(), i.promise(t)
			}
		});
		var W = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
			X = ["Top", "Right", "Bottom", "Left"],
			V = function (e, t) {
				return e = t || e, "none" === h.css(e, "display") || !h.contains(e.ownerDocument, e)
			},
			$ = h.access = function (e, t, n, r, i, s, o) {
				var u = 0,
					a = e.length,
					f = null == n;
				if ("object" === h.type(n)) {
					i = !0;
					for (u in n) h.access(e, t, u, n[u], !0, s, o)
				} else if (void 0 !== r && (i = !0, h.isFunction(r) || (o = !0), f && (o ? (t.call(e, r), t = null) : (f = t, t = function (e, t, n) {
						return f.call(h(e), n)
					})), t))
					for (; a > u; u++) t(e[u], n, o ? r : r.call(e[u], u, t(e[u], n)));
				return i ? e : f ? t.call(e) : a ? t(e[0], n) : s
			},
			J = /^(?:checkbox|radio)$/i;
		! function () {
			var e = T.createElement("input"),
				t = T.createElement("div"),
				n = T.createDocumentFragment();
			if (t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", l.leadingWhitespace = 3 === t.firstChild.nodeType, l.tbody = !t.getElementsByTagName("tbody").length, l.htmlSerialize = !!t.getElementsByTagName("link").length, l.html5Clone = "<:nav></:nav>" !== T.createElement("nav").cloneNode(!0).outerHTML, e.type = "checkbox", e.checked = !0, n.appendChild(e), l.appendChecked = e.checked, t.innerHTML = "<textarea>x</textarea>", l.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue, n.appendChild(t), t.innerHTML = "<input type='radio' checked='checked' name='t'/>", l.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, l.noCloneEvent = !0, t.attachEvent && (t.attachEvent("onclick", function () {
					l.noCloneEvent = !1
				}), t.cloneNode(!0).click()), null == l.deleteExpando) {
				l.deleteExpando = !0;
				try {
					delete t.test
				} catch (r) {
					l.deleteExpando = !1
				}
			}
		}(),
		function () {
			var t, n, r = T.createElement("div");
			for (t in {
					submit: !0,
					change: !0,
					focusin: !0
				}) n = "on" + t, (l[t + "Bubbles"] = n in e) || (r.setAttribute(n, "t"), l[t + "Bubbles"] = r.attributes[n].expando === !1);
			r = null
		}();
		var K = /^(?:input|select|textarea)$/i,
			Q = /^key/,
			G = /^(?:mouse|pointer|contextmenu)|click/,
			Y = /^(?:focusinfocus|focusoutblur)$/,
			Z = /^([^.]*)(?:\.(.+)|)$/;
		h.event = {
			global: {},
			add: function (e, t, n, r, i) {
				var s, o, u, a, f, l, c, p, d, v, m, g = h._data(e);
				if (g) {
					n.handler && (a = n, n = a.handler, i = a.selector), n.guid || (n.guid = h.guid++), (o = g.events) || (o = g.events = {}), (l = g.handle) || (l = g.handle = function (e) {
						return typeof h === B || e && h.event.triggered === e.type ? void 0 : h.event.dispatch.apply(l.elem, arguments)
					}, l.elem = e), t = (t || "").match(O) || [""], u = t.length;
					while (u--) s = Z.exec(t[u]) || [], d = m = s[1], v = (s[2] || "").split(".").sort(), d && (f = h.event.special[d] || {}, d = (i ? f.delegateType : f.bindType) || d, f = h.event.special[d] || {}, c = h.extend({
						type: d,
						origType: m,
						data: r,
						handler: n,
						guid: n.guid,
						selector: i,
						needsContext: i && h.expr.match.needsContext.test(i),
						namespace: v.join(".")
					}, a), (p = o[d]) || (p = o[d] = [], p.delegateCount = 0, f.setup && f.setup.call(e, r, v, l) !== !1 || (e.addEventListener ? e.addEventListener(d, l, !1) : e.attachEvent && e.attachEvent("on" + d, l))), f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, c) : p.push(c), h.event.global[d] = !0);
					e = null
				}
			},
			remove: function (e, t, n, r, i) {
				var s, o, u, a, f, l, c, p, d, v, m, g = h.hasData(e) && h._data(e);
				if (g && (l = g.events)) {
					t = (t || "").match(O) || [""], f = t.length;
					while (f--)
						if (u = Z.exec(t[f]) || [], d = m = u[1], v = (u[2] || "").split(".").sort(), d) {
							c = h.event.special[d] || {}, d = (r ? c.delegateType : c.bindType) || d, p = l[d] || [], u = u[2] && new RegExp("(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = s = p.length;
							while (s--) o = p[s], !i && m !== o.origType || n && n.guid !== o.guid || u && !u.test(o.namespace) || r && r !== o.selector && ("**" !== r || !o.selector) || (p.splice(s, 1), o.selector && p.delegateCount--, c.remove && c.remove.call(e, o));
							a && !p.length && (c.teardown && c.teardown.call(e, v, g.handle) !== !1 || h.removeEvent(e, d, g.handle), delete l[d])
						} else
							for (d in l) h.event.remove(e, d + t[f], n, r, !0);
					h.isEmptyObject(l) && (delete g.handle, h._removeData(e, "events"))
				}
			},
			trigger: function (t, n, r, i) {
				var s, o, u, a, l, c, p, d = [r || T],
					v = f.call(t, "type") ? t.type : t,
					m = f.call(t, "namespace") ? t.namespace.split(".") : [];
				if (u = c = r = r || T, 3 !== r.nodeType && 8 !== r.nodeType && !Y.test(v + h.event.triggered) && (v.indexOf(".") >= 0 && (m = v.split("."), v = m.shift(), m.sort()), o = v.indexOf(":") < 0 && "on" + v, t = t[h.expando] ? t : new h.Event(v, "object" == typeof t && t), t.isTrigger = i ? 2 : 3, t.namespace = m.join("."), t.namespace_re = t.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = r), n = null == n ? [t] : h.makeArray(n, [t]), l = h.event.special[v] || {}, i || !l.trigger || l.trigger.apply(r, n) !== !1)) {
					if (!i && !l.noBubble && !h.isWindow(r)) {
						for (a = l.delegateType || v, Y.test(a + v) || (u = u.parentNode); u; u = u.parentNode) d.push(u), c = u;
						c === (r.ownerDocument || T) && d.push(c.defaultView || c.parentWindow || e)
					}
					p = 0;
					while ((u = d[p++]) && !t.isPropagationStopped()) t.type = p > 1 ? a : l.bindType || v, s = (h._data(u, "events") || {})[t.type] && h._data(u, "handle"), s && s.apply(u, n), s = o && u[o], s && s.apply && h.acceptData(u) && (t.result = s.apply(u, n), t.result === !1 && t.preventDefault());
					if (t.type = v, !i && !t.isDefaultPrevented() && (!l._default || l._default.apply(d.pop(), n) === !1) && h.acceptData(r) && o && r[v] && !h.isWindow(r)) {
						c = r[o], c && (r[o] = null), h.event.triggered = v;
						try {
							r[v]()
						} catch (g) {}
						h.event.triggered = void 0, c && (r[o] = c)
					}
					return t.result
				}
			},
			dispatch: function (e) {
				e = h.event.fix(e);
				var t, n, i, s, o, u = [],
					a = r.call(arguments),
					f = (h._data(this, "events") || {})[e.type] || [],
					l = h.event.special[e.type] || {};
				if (a[0] = e, e.delegateTarget = this, !l.preDispatch || l.preDispatch.call(this, e) !== !1) {
					u = h.event.handlers.call(this, e, f), t = 0;
					while ((s = u[t++]) && !e.isPropagationStopped()) {
						e.currentTarget = s.elem, o = 0;
						while ((i = s.handlers[o++]) && !e.isImmediatePropagationStopped())(!e.namespace_re || e.namespace_re.test(i.namespace)) && (e.handleObj = i, e.data = i.data, n = ((h.event.special[i.origType] || {}).handle || i.handler).apply(s.elem, a), void 0 !== n && (e.result = n) === !1 && (e.preventDefault(), e.stopPropagation()))
					}
					return l.postDispatch && l.postDispatch.call(this, e), e.result
				}
			},
			handlers: function (e, t) {
				var n, r, i, s, o = [],
					u = t.delegateCount,
					a = e.target;
				if (u && a.nodeType && (!e.button || "click" !== e.type))
					for (; a != this; a = a.parentNode || this)
						if (1 === a.nodeType && (a.disabled !== !0 || "click" !== e.type)) {
							for (i = [], s = 0; u > s; s++) r = t[s], n = r.selector + " ", void 0 === i[n] && (i[n] = r.needsContext ? h(n, this).index(a) >= 0 : h.find(n, this, null, [a]).length), i[n] && i.push(r);
							i.length && o.push({
								elem: a,
								handlers: i
							})
						}
				return u < t.length && o.push({
					elem: this,
					handlers: t.slice(u)
				}), o
			},
			fix: function (e) {
				if (e[h.expando]) return e;
				var t, n, r, i = e.type,
					s = e,
					o = this.fixHooks[i];
				o || (this.fixHooks[i] = o = G.test(i) ? this.mouseHooks : Q.test(i) ? this.keyHooks : {}), r = o.props ? this.props.concat(o.props) : this.props, e = new h.Event(s), t = r.length;
				while (t--) n = r[t], e[n] = s[n];
				return e.target || (e.target = s.srcElement || T), 3 === e.target.nodeType && (e.target = e.target.parentNode), e.metaKey = !!e.metaKey, o.filter ? o.filter(e, s) : e
			},
			props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
			fixHooks: {},
			keyHooks: {
				props: "char charCode key keyCode".split(" "),
				filter: function (e, t) {
					return null == e.which && (e.which = null != t.charCode ? t.charCode : t.keyCode), e
				}
			},
			mouseHooks: {
				props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
				filter: function (e, t) {
					var n, r, i, s = t.button,
						o = t.fromElement;
					return null == e.pageX && null != t.clientX && (r = e.target.ownerDocument || T, i = r.documentElement, n = r.body, e.pageX = t.clientX + (i && i.scrollLeft || n && n.scrollLeft || 0) - (i && i.clientLeft || n && n.clientLeft || 0), e.pageY = t.clientY + (i && i.scrollTop || n && n.scrollTop || 0) - (i && i.clientTop || n && n.clientTop || 0)), !e.relatedTarget && o && (e.relatedTarget = o === e.target ? t.toElement : o), e.which || void 0 === s || (e.which = 1 & s ? 1 : 2 & s ? 3 : 4 & s ? 2 : 0), e
				}
			},
			special: {
				load: {
					noBubble: !0
				},
				focus: {
					trigger: function () {
						if (this !== nt() && this.focus) try {
							return this.focus(), !1
						} catch (e) {}
					},
					delegateType: "focusin"
				},
				blur: {
					trigger: function () {
						return this === nt() && this.blur ? (this.blur(), !1) : void 0
					},
					delegateType: "focusout"
				},
				click: {
					trigger: function () {
						return h.nodeName(this, "input") && "checkbox" === this.type && this.click ? (this.click(), !1) : void 0
					},
					_default: function (e) {
						return h.nodeName(e.target, "a")
					}
				},
				beforeunload: {
					postDispatch: function (e) {
						void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
					}
				}
			},
			simulate: function (e, t, n, r) {
				var i = h.extend(new h.Event, n, {
					type: e,
					isSimulated: !0,
					originalEvent: {}
				});
				r ? h.event.trigger(i, null, t) : h.event.dispatch.call(t, i), i.isDefaultPrevented() && n.preventDefault()
			}
		}, h.removeEvent = T.removeEventListener ? function (e, t, n) {
			e.removeEventListener && e.removeEventListener(t, n, !1)
		} : function (e, t, n) {
			var r = "on" + t;
			e.detachEvent && (typeof e[r] === B && (e[r] = null), e.detachEvent(r, n))
		}, h.Event = function (e, t) {
			return this instanceof h.Event ? (e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && e.returnValue === !1 ? et : tt) : this.type = e, t && h.extend(this, t), this.timeStamp = e && e.timeStamp || h.now(), void(this[h.expando] = !0)) : new h.Event(e, t)
		}, h.Event.prototype = {
			isDefaultPrevented: tt,
			isPropagationStopped: tt,
			isImmediatePropagationStopped: tt,
			preventDefault: function () {
				var e = this.originalEvent;
				this.isDefaultPrevented = et, e && (e.preventDefault ? e.preventDefault() : e.returnValue = !1)
			},
			stopPropagation: function () {
				var e = this.originalEvent;
				this.isPropagationStopped = et, e && (e.stopPropagation && e.stopPropagation(), e.cancelBubble = !0)
			},
			stopImmediatePropagation: function () {
				var e = this.originalEvent;
				this.isImmediatePropagationStopped = et, e && e.stopImmediatePropagation && e.stopImmediatePropagation(), this.stopPropagation()
			}
		}, h.each({
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			pointerenter: "pointerover",
			pointerleave: "pointerout"
		}, function (e, t) {
			h.event.special[e] = {
				delegateType: t,
				bindType: t,
				handle: function (e) {
					var n, r = this,
						i = e.relatedTarget,
						s = e.handleObj;
					return (!i || i !== r && !h.contains(r, i)) && (e.type = s.origType, n = s.handler.apply(this, arguments), e.type = t), n
				}
			}
		}), l.submitBubbles || (h.event.special.submit = {
			setup: function () {
				return h.nodeName(this, "form") ? !1 : void h.event.add(this, "click._submit keypress._submit", function (e) {
					var t = e.target,
						n = h.nodeName(t, "input") || h.nodeName(t, "button") ? t.form : void 0;
					n && !h._data(n, "submitBubbles") && (h.event.add(n, "submit._submit", function (e) {
						e._submit_bubble = !0
					}), h._data(n, "submitBubbles", !0))
				})
			},
			postDispatch: function (e) {
				e._submit_bubble && (delete e._submit_bubble, this.parentNode && !e.isTrigger && h.event.simulate("submit", this.parentNode, e, !0))
			},
			teardown: function () {
				return h.nodeName(this, "form") ? !1 : void h.event.remove(this, "._submit")
			}
		}), l.changeBubbles || (h.event.special.change = {
			setup: function () {
				return K.test(this.nodeName) ? (("checkbox" === this.type || "radio" === this.type) && (h.event.add(this, "propertychange._change", function (e) {
					"checked" === e.originalEvent.propertyName && (this._just_changed = !0)
				}), h.event.add(this, "click._change", function (e) {
					this._just_changed && !e.isTrigger && (this._just_changed = !1), h.event.simulate("change", this, e, !0)
				})), !1) : void h.event.add(this, "beforeactivate._change", function (e) {
					var t = e.target;
					K.test(t.nodeName) && !h._data(t, "changeBubbles") && (h.event.add(t, "change._change", function (e) {
						!this.parentNode || e.isSimulated || e.isTrigger || h.event.simulate("change", this.parentNode, e, !0)
					}), h._data(t, "changeBubbles", !0))
				})
			},
			handle: function (e) {
				var t = e.target;
				return this !== t || e.isSimulated || e.isTrigger || "radio" !== t.type && "checkbox" !== t.type ? e.handleObj.handler.apply(this, arguments) : void 0
			},
			teardown: function () {
				return h.event.remove(this, "._change"), !K.test(this.nodeName)
			}
		}), l.focusinBubbles || h.each({
			focus: "focusin",
			blur: "focusout"
		}, function (e, t) {
			var n = function (e) {
				h.event.simulate(t, e.target, h.event.fix(e), !0)
			};
			h.event.special[t] = {
				setup: function () {
					var r = this.ownerDocument || this,
						i = h._data(r, t);
					i || r.addEventListener(e, n, !0), h._data(r, t, (i || 0) + 1)
				},
				teardown: function () {
					var r = this.ownerDocument || this,
						i = h._data(r, t) - 1;
					i ? h._data(r, t, i) : (r.removeEventListener(e, n, !0), h._removeData(r, t))
				}
			}
		}), h.fn.extend({
			on: function (e, t, n, r, i) {
				var s, o;
				if ("object" == typeof e) {
					"string" != typeof t && (n = n || t, t = void 0);
					for (s in e) this.on(s, t, n, e[s], i);
					return this
				}
				if (null == n && null == r ? (r = t, n = t = void 0) : null == r && ("string" == typeof t ? (r = n, n = void 0) : (r = n, n = t, t = void 0)), r === !1) r = tt;
				else if (!r) return this;
				return 1 === i && (o = r, r = function (e) {
					return h().off(e), o.apply(this, arguments)
				}, r.guid = o.guid || (o.guid = h.guid++)), this.each(function () {
					h.event.add(this, e, r, n, t)
				})
			},
			one: function (e, t, n, r) {
				return this.on(e, t, n, r, 1)
			},
			off: function (e, t, n) {
				var r, i;
				if (e && e.preventDefault && e.handleObj) return r = e.handleObj, h(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
				if ("object" == typeof e) {
					for (i in e) this.off(i, t, e[i]);
					return this
				}
				return (t === !1 || "function" == typeof t) && (n = t, t = void 0), n === !1 && (n = tt), this.each(function () {
					h.event.remove(this, e, n, t)
				})
			},
			trigger: function (e, t) {
				return this.each(function () {
					h.event.trigger(e, t, this)
				})
			},
			triggerHandler: function (e, t) {
				var n = this[0];
				return n ? h.event.trigger(e, t, n, !0) : void 0
			}
		});
		var it = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
			st = / jQuery\d+="(?:null|\d+)"/g,
			ot = new RegExp("<(?:" + it + ")[\\s/>]", "i"),
			ut = /^\s+/,
			at = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
			ft = /<([\w:]+)/,
			lt = /<tbody/i,
			ct = /<|&#?\w+;/,
			ht = /<(?:script|style|link)/i,
			pt = /checked\s*(?:[^=]|=\s*.checked.)/i,
			dt = /^$|\/(?:java|ecma)script/i,
			vt = /^true\/(.*)/,
			mt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
			gt = {
				option: [1, "<select multiple='multiple'>", "</select>"],
				legend: [1, "<fieldset>", "</fieldset>"],
				area: [1, "<map>", "</map>"],
				param: [1, "<object>", "</object>"],
				thead: [1, "<table>", "</table>"],
				tr: [2, "<table><tbody>", "</tbody></table>"],
				col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
				td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
				_default: l.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"]
			},
			yt = rt(T),
			bt = yt.appendChild(T.createElement("div"));
		gt.optgroup = gt.option, gt.tbody = gt.tfoot = gt.colgroup = gt.caption = gt.thead, gt.th = gt.td, h.extend({
			clone: function (e, t, n) {
				var r, i, s, o, u, a = h.contains(e.ownerDocument, e);
				if (l.html5Clone || h.isXMLDoc(e) || !ot.test("<" + e.nodeName + ">") ? s = e.cloneNode(!0) : (bt.innerHTML = e.outerHTML, bt.removeChild(s = bt.firstChild)), !(l.noCloneEvent && l.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || h.isXMLDoc(e)))
					for (r = wt(s), u = wt(e), o = 0; null != (i = u[o]); ++o) r[o] && kt(i, r[o]);
				if (t)
					if (n)
						for (u = u || wt(e), r = r || wt(s), o = 0; null != (i = u[o]); o++) Ct(i, r[o]);
					else Ct(e, s);
				return r = wt(s, "script"), r.length > 0 && Nt(r, !a && wt(e, "script")), r = u = i = null, s
			},
			buildFragment: function (e, t, n, r) {
				for (var i, s, o, u, a, f, c, p = e.length, d = rt(t), v = [], m = 0; p > m; m++)
					if (s = e[m], s || 0 === s)
						if ("object" === h.type(s)) h.merge(v, s.nodeType ? [s] : s);
						else if (ct.test(s)) {
					u = u || d.appendChild(t.createElement("div")), a = (ft.exec(s) || ["", ""])[1].toLowerCase(), c = gt[a] || gt._default, u.innerHTML = c[1] + s.replace(at, "<$1><$2>") + c[2], i = c[0];
					while (i--) u = u.lastChild;
					if (!l.leadingWhitespace && ut.test(s) && v.push(t.createTextNode(ut.exec(s)[0])), !l.tbody) {
						s = "table" !== a || lt.test(s) ? "<table>" !== c[1] || lt.test(s) ? 0 : u : u.firstChild, i = s && s.childNodes.length;
						while (i--) h.nodeName(f = s.childNodes[i], "tbody") && !f.childNodes.length && s.removeChild(f)
					}
					h.merge(v, u.childNodes), u.textContent = "";
					while (u.firstChild) u.removeChild(u.firstChild);
					u = d.lastChild
				} else v.push(t.createTextNode(s));
				u && d.removeChild(u), l.appendChecked || h.grep(wt(v, "input"), Et), m = 0;
				while (s = v[m++])
					if ((!r || -1 === h.inArray(s, r)) && (o = h.contains(s.ownerDocument, s), u = wt(d.appendChild(s), "script"), o && Nt(u), n)) {
						i = 0;
						while (s = u[i++]) dt.test(s.type || "") && n.push(s)
					}
				return u = null, d
			},
			cleanData: function (e, t) {
				for (var r, i, s, o, u = 0, a = h.expando, f = h.cache, c = l.deleteExpando, p = h.event.special; null != (r = e[u]); u++)
					if ((t || h.acceptData(r)) && (s = r[a], o = s && f[s])) {
						if (o.events)
							for (i in o.events) p[i] ? h.event.remove(r, i) : h.removeEvent(r, i, o.handle);
						f[s] && (delete f[s], c ? delete r[a] : typeof r.removeAttribute !== B ? r.removeAttribute(a) : r[a] = null, n.push(s))
					}
			}
		}), h.fn.extend({
			text: function (e) {
				return $(this, function (e) {
					return void 0 === e ? h.text(this) : this.empty().append((this[0] && this[0].ownerDocument || T).createTextNode(e))
				}, null, e, arguments.length)
			},
			append: function () {
				return this.domManip(arguments, function (e) {
					if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
						var t = St(this, e);
						t.appendChild(e)
					}
				})
			},
			prepend: function () {
				return this.domManip(arguments, function (e) {
					if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
						var t = St(this, e);
						t.insertBefore(e, t.firstChild)
					}
				})
			},
			before: function () {
				return this.domManip(arguments, function (e) {
					this.parentNode && this.parentNode.insertBefore(e, this)
				})
			},
			after: function () {
				return this.domManip(arguments, function (e) {
					this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
				})
			},
			remove: function (e, t) {
				for (var n, r = e ? h.filter(e, this) : this, i = 0; null != (n = r[i]); i++) t || 1 !== n.nodeType || h.cleanData(wt(n)), n.parentNode && (t && h.contains(n.ownerDocument, n) && Nt(wt(n, "script")), n.parentNode.removeChild(n));
				return this
			},
			empty: function () {
				for (var e, t = 0; null != (e = this[t]); t++) {
					1 === e.nodeType && h.cleanData(wt(e, !1));
					while (e.firstChild) e.removeChild(e.firstChild);
					e.options && h.nodeName(e, "select") && (e.options.length = 0)
				}
				return this
			},
			clone: function (e, t) {
				return e = null == e ? !1 : e, t = null == t ? e : t, this.map(function () {
					return h.clone(this, e, t)
				})
			},
			html: function (e) {
				return $(this, function (e) {
					var t = this[0] || {},
						n = 0,
						r = this.length;
					if (void 0 === e) return 1 === t.nodeType ? t.innerHTML.replace(st, "") : void 0;
					if (!("string" != typeof e || ht.test(e) || !l.htmlSerialize && ot.test(e) || !l.leadingWhitespace && ut.test(e) || gt[(ft.exec(e) || ["", ""])[1].toLowerCase()])) {
						e = e.replace(at, "<$1><$2>");
						try {
							for (; r > n; n++) t = this[n] || {}, 1 === t.nodeType && (h.cleanData(wt(t, !1)), t.innerHTML = e);
							t = 0
						} catch (i) {}
					}
					t && this.empty().append(e)
				}, null, e, arguments.length)
			},
			replaceWith: function () {
				var e = arguments[0];
				return this.domManip(arguments, function (t) {
					e = this.parentNode, h.cleanData(wt(this)), e && e.replaceChild(t, this)
				}), e && (e.length || e.nodeType) ? this : this.remove()
			},
			detach: function (e) {
				return this.remove(e, !0)
			},
			domManip: function (e, t) {
				e = i.apply([], e);
				var n, r, s, o, u, a, f = 0,
					c = this.length,
					p = this,
					d = c - 1,
					v = e[0],
					m = h.isFunction(v);
				if (m || c > 1 && "string" == typeof v && !l.checkClone && pt.test(v)) return this.each(function (n) {
					var r = p.eq(n);
					m && (e[0] = v.call(this, n, r.html())), r.domManip(e, t)
				});
				if (c && (a = h.buildFragment(e, this[0].ownerDocument, !1, this), n = a.firstChild, 1 === a.childNodes.length && (a = n), n)) {
					for (o = h.map(wt(a, "script"), xt), s = o.length; c > f; f++) r = a, f !== d && (r = h.clone(r, !0, !0), s && h.merge(o, wt(r, "script"))), t.call(this[f], r, f);
					if (s)
						for (u = o[o.length - 1].ownerDocument, h.map(o, Tt), f = 0; s > f; f++) r = o[f], dt.test(r.type || "") && !h._data(r, "globalEval") && h.contains(u, r) && (r.src ? h._evalUrl && h._evalUrl(r.src) : h.globalEval((r.text || r.textContent || r.innerHTML || "").replace(mt, "")));
					a = n = null
				}
				return this
			}
		}), h.each({
			appendTo: "append",
			prependTo: "prepend",
			insertBefore: "before",
			insertAfter: "after",
			replaceAll: "replaceWith"
		}, function (e, t) {
			h.fn[e] = function (e) {
				for (var n, r = 0, i = [], o = h(e), u = o.length - 1; u >= r; r++) n = r === u ? this : this.clone(!0), h(o[r])[t](n), s.apply(i, n.get());
				return this.pushStack(i)
			}
		});
		var Lt, At = {};
		! function () {
			var e;
			l.shrinkWrapBlocks = function () {
				if (null != e) return e;
				e = !1;
				var t, n, r;
				return n = T.getElementsByTagName("body")[0], n && n.style ? (t = T.createElement("div"), r = T.createElement("div"), r.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(r).appendChild(t), typeof t.style.zoom !== B && (t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1", t.appendChild(T.createElement("div")).style.width = "5px", e = 3 !== t.offsetWidth), n.removeChild(r), e) : void 0
			}
		}();
		var _t = /^margin/,
			Dt = new RegExp("^(" + W + ")(?!px)[a-z%]+$", "i"),
			Pt, Ht, Bt = /^(top|right|bottom|left)$/;
		e.getComputedStyle ? (Pt = function (e) {
			return e.ownerDocument.defaultView.getComputedStyle(e, null)
		}, Ht = function (e, t, n) {
			var r, i, s, o, u = e.style;
			return n = n || Pt(e), o = n ? n.getPropertyValue(t) || n[t] : void 0, n && ("" !== o || h.contains(e.ownerDocument, e) || (o = h.style(e, t)), Dt.test(o) && _t.test(t) && (r = u.width, i = u.minWidth, s = u.maxWidth, u.minWidth = u.maxWidth = u.width = o, o = n.width, u.width = r, u.minWidth = i, u.maxWidth = s)), void 0 === o ? o : o + ""
		}) : T.documentElement.currentStyle && (Pt = function (e) {
			return e.currentStyle
		}, Ht = function (e, t, n) {
			var r, i, s, o, u = e.style;
			return n = n || Pt(e), o = n ? n[t] : void 0, null == o && u && u[t] && (o = u[t]), Dt.test(o) && !Bt.test(t) && (r = u.left, i = e.runtimeStyle, s = i && i.left, s && (i.left = e.currentStyle.left), u.left = "fontSize" === t ? "1em" : o, o = u.pixelLeft + "px", u.left = r, s && (i.left = s)), void 0 === o ? o : o + "" || "auto"
		}), ! function () {
			var t, n, r, i, s, o, u;
			if (t = T.createElement("div"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", r = t.getElementsByTagName("a")[0], n = r && r.style) {
				n.cssText = "float:left;opacity:.5", l.opacity = "0.5" === n.opacity, l.cssFloat = !!n.cssFloat, t.style.backgroundClip = "content-box", t.cloneNode(!0).style.backgroundClip = "", l.clearCloneStyle = "content-box" === t.style.backgroundClip, l.boxSizing = "" === n.boxSizing || "" === n.MozBoxSizing || "" === n.WebkitBoxSizing, h.extend(l, {
					reliableHiddenOffsets: function () {
						return null == o && a(), o
					},
					boxSizingReliable: function () {
						return null == s && a(), s
					},
					pixelPosition: function () {
						return null == i && a(), i
					},
					reliableMarginRight: function () {
						return null == u && a(), u
					}
				});

				function a() {
					var t, n, r, a;
					n = T.getElementsByTagName("body")[0], n && n.style && (t = T.createElement("div"), r = T.createElement("div"), r.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px", n.appendChild(r).appendChild(t), t.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", i = s = !1, u = !0, e.getComputedStyle && (i = "1%" !== (e.getComputedStyle(t, null) || {}).top, s = "4px" === (e.getComputedStyle(t, null) || {
						width: "4px"
					}).width, a = t.appendChild(T.createElement("div")), a.style.cssText = t.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", a.style.marginRight = a.style.width = "0", t.style.width = "1px", u = !parseFloat((e.getComputedStyle(a, null) || {}).marginRight)), t.innerHTML = "<table><tr><td></td><td>t</td></tr></table>", a = t.getElementsByTagName("td"), a[0].style.cssText = "margin:0;border:0;padding:0;display:none", o = 0 === a[0].offsetHeight, o && (a[0].style.display = "", a[1].style.display = "none", o = 0 === a[0].offsetHeight), n.removeChild(r))
				}
			}
		}(), h.swap = function (e, t, n, r) {
			var i, s, o = {};
			for (s in t) o[s] = e.style[s], e.style[s] = t[s];
			i = n.apply(e, r || []);
			for (s in t) e.style[s] = o[s];
			return i
		};
		var Ft = /alpha\([^)]*\)/i,
			It = /opacity\s*=\s*([^)]*)/,
			qt = /^(none|table(?!-c[ea]).+)/,
			Rt = new RegExp("^(" + W + ")(.*)$", "i"),
			Ut = new RegExp("^([+-])=(" + W + ")", "i"),
			zt = {
				position: "absolute",
				visibility: "hidden",
				display: "block"
			},
			Wt = {
				letterSpacing: "0",
				fontWeight: "400"
			},
			Xt = ["Webkit", "O", "Moz", "ms"];
		h.extend({
			cssHooks: {
				opacity: {
					get: function (e, t) {
						if (t) {
							var n = Ht(e, "opacity");
							return "" === n ? "1" : n
						}
					}
				}
			},
			cssNumber: {
				columnCount: !0,
				fillOpacity: !0,
				flexGrow: !0,
				flexShrink: !0,
				fontWeight: !0,
				lineHeight: !0,
				opacity: !0,
				order: !0,
				orphans: !0,
				widows: !0,
				zIndex: !0,
				zoom: !0
			},
			cssProps: {
				"float": l.cssFloat ? "cssFloat" : "styleFloat"
			},
			style: function (e, t, n, r) {
				if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
					var i, s, o, u = h.camelCase(t),
						a = e.style;
					if (t = h.cssProps[u] || (h.cssProps[u] = Vt(a, u)), o = h.cssHooks[t] || h.cssHooks[u], void 0 === n) return o && "get" in o && void 0 !== (i = o.get(e, !1, r)) ? i : a[t];
					if (s = typeof n, "string" === s && (i = Ut.exec(n)) && (n = (i[1] + 1) * i[2] + parseFloat(h.css(e, t)), s = "number"), null != n && n === n && ("number" !== s || h.cssNumber[u] || (n += "px"), l.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (a[t] = "inherit"), !(o && "set" in o && void 0 === (n = o.set(e, n, r))))) try {
						a[t] = n
					} catch (f) {}
				}
			},
			css: function (e, t, n, r) {
				var i, s, o, u = h.camelCase(t);
				return t = h.cssProps[u] || (h.cssProps[u] = Vt(e.style, u)), o = h.cssHooks[t] || h.cssHooks[u], o && "get" in o && (s = o.get(e, !0, n)), void 0 === s && (s = Ht(e, t, r)), "normal" === s && t in Wt && (s = Wt[t]), "" === n || n ? (i = parseFloat(s), n === !0 || h.isNumeric(i) ? i || 0 : s) : s
			}
		}), h.each(["height", "width"], function (e, t) {
			h.cssHooks[t] = {
				get: function (e, n, r) {
					return n ? qt.test(h.css(e, "display")) && 0 === e.offsetWidth ? h.swap(e, zt, function () {
						return Qt(e, t, r)
					}) : Qt(e, t, r) : void 0
				},
				set: function (e, n, r) {
					var i = r && Pt(e);
					return Jt(e, n, r ? Kt(e, t, r, l.boxSizing && "border-box" === h.css(e, "boxSizing", !1, i), i) : 0)
				}
			}
		}), l.opacity || (h.cssHooks.opacity = {
			get: function (e, t) {
				return It.test((t && e.currentStyle ? e.currentStyle.filter : e.style.filter) || "") ? .01 * parseFloat(RegExp.$1) + "" : t ? "1" : ""
			},
			set: function (e, t) {
				var n = e.style,
					r = e.currentStyle,
					i = h.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
					s = r && r.filter || n.filter || "";
				n.zoom = 1, (t >= 1 || "" === t) && "" === h.trim(s.replace(Ft, "")) && n.removeAttribute && (n.removeAttribute("filter"), "" === t || r && !r.filter) || (n.filter = Ft.test(s) ? s.replace(Ft, i) : s + " " + i)
			}
		}), h.cssHooks.marginRight = jt(l.reliableMarginRight, function (e, t) {
			return t ? h.swap(e, {
				display: "inline-block"
			}, Ht, [e, "marginRight"]) : void 0
		}), h.each({
			margin: "",
			padding: "",
			border: "Width"
		}, function (e, t) {
			h.cssHooks[e + t] = {
				expand: function (n) {
					for (var r = 0, i = {}, s = "string" == typeof n ? n.split(" ") : [n]; 4 > r; r++) i[e + X[r] + t] = s[r] || s[r - 2] || s[0];
					return i
				}
			}, _t.test(e) || (h.cssHooks[e + t].set = Jt)
		}), h.fn.extend({
			css: function (e, t) {
				return $(this, function (e, t, n) {
					var r, i, s = {},
						o = 0;
					if (h.isArray(t)) {
						for (r = Pt(e), i = t.length; i > o; o++) s[t[o]] = h.css(e, t[o], !1, r);
						return s
					}
					return void 0 !== n ? h.style(e, t, n) : h.css(e, t)
				}, e, t, arguments.length > 1)
			},
			show: function () {
				return $t(this, !0)
			},
			hide: function () {
				return $t(this)
			},
			toggle: function (e) {
				return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
					V(this) ? h(this).show() : h(this).hide()
				})
			}
		}), h.Tween = Gt, Gt.prototype = {
			constructor: Gt,
			init: function (e, t, n, r, i, s) {
				this.elem = e, this.prop = n, this.easing = i || "swing", this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = s || (h.cssNumber[n] ? "" : "px")
			},
			cur: function () {
				var e = Gt.propHooks[this.prop];
				return e && e.get ? e.get(this) : Gt.propHooks._default.get(this)
			},
			run: function (e) {
				var t, n = Gt.propHooks[this.prop];
				return this.pos = t = this.options.duration ? h.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : Gt.propHooks._default.set(this), this
			}
		}, Gt.prototype.init.prototype = Gt.prototype, Gt.propHooks = {
			_default: {
				get: function (e) {
					var t;
					return null == e.elem[e.prop] || e.elem.style && null != e.elem.style[e.prop] ? (t = h.css(e.elem, e.prop, ""), t && "auto" !== t ? t : 0) : e.elem[e.prop]
				},
				set: function (e) {
					h.fx.step[e.prop] ? h.fx.step[e.prop](e) : e.elem.style && (null != e.elem.style[h.cssProps[e.prop]] || h.cssHooks[e.prop]) ? h.style(e.elem, e.prop, e.now + e.unit) : e.elem[e.prop] = e.now
				}
			}
		}, Gt.propHooks.scrollTop = Gt.propHooks.scrollLeft = {
			set: function (e) {
				e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
			}
		}, h.easing = {
			linear: function (e) {
				return e
			},
			swing: function (e) {
				return .5 - Math.cos(e * Math.PI) / 2
			}
		}, h.fx = Gt.prototype.init, h.fx.step = {};
		var Yt, Zt, en = /^(?:toggle|show|hide)$/,
			tn = new RegExp("^(?:([+-])=|)(" + W + ")([a-z%]*)$", "i"),
			nn = /queueHooks$/,
			rn = [fn],
			sn = {
				"*": [function (e, t) {
					var n = this.createTween(e, t),
						r = n.cur(),
						i = tn.exec(t),
						s = i && i[3] || (h.cssNumber[e] ? "" : "px"),
						o = (h.cssNumber[e] || "px" !== s && +r) && tn.exec(h.css(n.elem, e)),
						u = 1,
						a = 20;
					if (o && o[3] !== s) {
						s = s || o[3], i = i || [], o = +r || 1;
						do u = u || ".5", o /= u, h.style(n.elem, e, o + s); while (u !== (u = n.cur() / r) && 1 !== u && --a)
					}
					return i && (o = n.start = +o || +r || 0, n.unit = s, n.end = i[1] ? o + (i[1] + 1) * i[2] : +i[2]), n
				}]
			};
		h.Animation = h.extend(cn, {
				tweener: function (e, t) {
					h.isFunction(e) ? (t = e, e = ["*"]) : e = e.split(" ");
					for (var n, r = 0, i = e.length; i > r; r++) n = e[r], sn[n] = sn[n] || [], sn[n].unshift(t)
				},
				prefilter: function (e, t) {
					t ? rn.unshift(e) : rn.push(e)
				}
			}), h.speed = function (e, t, n) {
				var r = e && "object" == typeof e ? h.extend({}, e) : {
					complete: n || !n && t || h.isFunction(e) && e,
					duration: e,
					easing: n && t || t && !h.isFunction(t) && t
				};
				return r.duration = h.fx.off ? 0 : "number" == typeof r.duration ? r.duration : r.duration in h.fx.speeds ? h.fx.speeds[r.duration] : h.fx.speeds._default, (null == r.queue || r.queue === !0) && (r.queue = "fx"), r.old = r.complete, r.complete = function () {
					h.isFunction(r.old) && r.old.call(this), r.queue && h.dequeue(this, r.queue)
				}, r
			}, h.fn.extend({
				fadeTo: function (e, t, n, r) {
					return this.filter(V).css("opacity", 0).show().end().animate({
						opacity: t
					}, e, n, r)
				},
				animate: function (e, t, n, r) {
					var i = h.isEmptyObject(e),
						s = h.speed(t, n, r),
						o = function () {
							var t = cn(this, h.extend({}, e), s);
							(i || h._data(this, "finish")) && t.stop(!0)
						};
					return o.finish = o, i || s.queue === !1 ? this.each(o) : this.queue(s.queue, o)
				},
				stop: function (e, t, n) {
					var r = function (e) {
						var t = e.stop;
						delete e.stop, t(n)
					};
					return "string" != typeof e && (n = t, t = e, e = void 0), t && e !== !1 && this.queue(e || "fx", []), this.each(function () {
						var t = !0,
							i = null != e && e + "queueHooks",
							s = h.timers,
							o = h._data(this);
						if (i) o[i] && o[i].stop && r(o[i]);
						else
							for (i in o) o[i] && o[i].stop && nn.test(i) && r(o[i]);
						for (i = s.length; i--;) s[i].elem !== this || null != e && s[i].queue !== e || (s[i].anim.stop(n), t = !1, s.splice(i, 1));
						(t || !n) && h.dequeue(this, e)
					})
				},
				finish: function (e) {
					return e !== !1 && (e = e || "fx"), this.each(function () {
						var t, n = h._data(this),
							r = n[e + "queue"],
							i = n[e + "queueHooks"],
							s = h.timers,
							o = r ? r.length : 0;
						for (n.finish = !0, h.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = s.length; t--;) s[t].elem === this && s[t].queue === e && (s[t].anim.stop(!0), s.splice(t, 1));
						for (t = 0; o > t; t++) r[t] && r[t].finish && r[t].finish.call(this);
						delete n.finish
					})
				}
			}), h.each(["toggle", "show", "hide"], function (e, t) {
				var n = h.fn[t];
				h.fn[t] = function (e, r, i) {
					return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(un(t, !0), e, r, i)
				}
			}), h.each({
				slideDown: un("show"),
				slideUp: un("hide"),
				slideToggle: un("toggle"),
				fadeIn: {
					opacity: "show"
				},
				fadeOut: {
					opacity: "hide"
				},
				fadeToggle: {
					opacity: "toggle"
				}
			}, function (e, t) {
				h.fn[e] = function (e, n, r) {
					return this.animate(t, e, n, r)
				}
			}), h.timers = [], h.fx.tick = function () {
				var e, t = h.timers,
					n = 0;
				for (Yt = h.now(); n < t.length; n++) e = t[n], e() || t[n] !== e || t.splice(n--, 1);
				t.length || h.fx.stop(), Yt = void 0
			}, h.fx.timer = function (e) {
				h.timers.push(e), e() ? h.fx.start() : h.timers.pop()
			}, h.fx.interval = 13, h.fx.start = function () {
				Zt || (Zt = setInterval(h.fx.tick, h.fx.interval))
			}, h.fx.stop = function () {
				clearInterval(Zt), Zt = null
			}, h.fx.speeds = {
				slow: 600,
				fast: 200,
				_default: 400
			}, h.fn.delay = function (e, t) {
				return e = h.fx ? h.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function (t, n) {
					var r = setTimeout(t, e);
					n.stop = function () {
						clearTimeout(r)
					}
				})
			},
			function () {
				var e, t, n, r, i;
				t = T.createElement("div"), t.setAttribute("className", "t"), t.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>", r = t.getElementsByTagName("a")[0], n = T.createElement("select"), i = n.appendChild(T.createElement("option")), e = t.getElementsByTagName("input")[0], r.style.cssText = "top:1px", l.getSetAttribute = "t" !== t.className, l.style = /top/.test(r.getAttribute("style")), l.hrefNormalized = "/a" === r.getAttribute("href"), l.checkOn = !!e.value, l.optSelected = i.selected, l.enctype = !!T.createElement("form").enctype, n.disabled = !0, l.optDisabled = !i.disabled, e = T.createElement("input"), e.setAttribute("value", ""), l.input = "" === e.getAttribute("value"), e.value = "t", e.setAttribute("type", "radio"), l.radioValue = "t" === e.value
			}();
		var hn = /\r/g;
		h.fn.extend({
			val: function (e) {
				var t, n, r, i = this[0];
				if (arguments.length) return r = h.isFunction(e), this.each(function (n) {
					var i;
					1 === this.nodeType && (i = r ? e.call(this, n, h(this).val()) : e, null == i ? i = "" : "number" == typeof i ? i += "" : h.isArray(i) && (i = h.map(i, function (e) {
						return null == e ? "" : e + ""
					})), t = h.valHooks[this.type] || h.valHooks[this.nodeName.toLowerCase()], t && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i))
				});
				if (i) return t = h.valHooks[i.type] || h.valHooks[i.nodeName.toLowerCase()], t && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : (n = i.value, "string" == typeof n ? n.replace(hn, "") : null == n ? "" : n)
			}
		}), h.extend({
			valHooks: {
				option: {
					get: function (e) {
						var t = h.find.attr(e, "value");
						return null != t ? t : h.trim(h.text(e))
					}
				},
				select: {
					get: function (e) {
						for (var t, n, r = e.options, i = e.selectedIndex, s = "select-one" === e.type || 0 > i, o = s ? null : [], u = s ? i + 1 : r.length, a = 0 > i ? u : s ? i : 0; u > a; a++)
							if (n = r[a], !(!n.selected && a !== i || (l.optDisabled ? n.disabled : null !== n.getAttribute("disabled")) || n.parentNode.disabled && h.nodeName(n.parentNode, "optgroup"))) {
								if (t = h(n).val(), s) return t;
								o.push(t)
							}
						return o
					},
					set: function (e, t) {
						var n, r, i = e.options,
							s = h.makeArray(t),
							o = i.length;
						while (o--)
							if (r = i[o], h.inArray(h.valHooks.option.get(r), s) >= 0) try {
								r.selected = n = !0
							} catch (u) {
								r.scrollHeight
							} else r.selected = !1;
						return n || (e.selectedIndex = -1), i
					}
				}
			}
		}), h.each(["radio", "checkbox"], function () {
			h.valHooks[this] = {
				set: function (e, t) {
					return h.isArray(t) ? e.checked = h.inArray(h(e).val(), t) >= 0 : void 0
				}
			}, l.checkOn || (h.valHooks[this].get = function (e) {
				return null === e.getAttribute("value") ? "on" : e.value
			})
		});
		var pn, dn, vn = h.expr.attrHandle,
			mn = /^(?:checked|selected)$/i,
			gn = l.getSetAttribute,
			yn = l.input;
		h.fn.extend({
			attr: function (e, t) {
				return $(this, h.attr, e, t, arguments.length > 1)
			},
			removeAttr: function (e) {
				return this.each(function () {
					h.removeAttr(this, e)
				})
			}
		}), h.extend({
			attr: function (e, t, n) {
				var r, i, s = e.nodeType;
				if (e && 3 !== s && 8 !== s && 2 !== s) return typeof e.getAttribute === B ? h.prop(e, t, n) : (1 === s && h.isXMLDoc(e) || (t = t.toLowerCase(), r = h.attrHooks[t] || (h.expr.match.bool.test(t) ? dn : pn)), void 0 === n ? r && "get" in r && null !== (i = r.get(e, t)) ? i : (i = h.find.attr(e, t), null == i ? void 0 : i) : null !== n ? r && "set" in r && void 0 !== (i = r.set(e, n, t)) ? i : (e.setAttribute(t, n + ""), n) : void h.removeAttr(e, t))
			},
			removeAttr: function (e, t) {
				var n, r, i = 0,
					s = t && t.match(O);
				if (s && 1 === e.nodeType)
					while (n = s[i++]) r = h.propFix[n] || n, h.expr.match.bool.test(n) ? yn && gn || !mn.test(n) ? e[r] = !1 : e[h.camelCase("default-" + n)] = e[r] = !1 : h.attr(e, n, ""), e.removeAttribute(gn ? n : r)
			},
			attrHooks: {
				type: {
					set: function (e, t) {
						if (!l.radioValue && "radio" === t && h.nodeName(e, "input")) {
							var n = e.value;
							return e.setAttribute("type", t), n && (e.value = n), t
						}
					}
				}
			}
		}), dn = {
			set: function (e, t, n) {
				return t === !1 ? h.removeAttr(e, n) : yn && gn || !mn.test(n) ? e.setAttribute(!gn && h.propFix[n] || n, n) : e[h.camelCase("default-" + n)] = e[n] = !0, n
			}
		}, h.each(h.expr.match.bool.source.match(/\w+/g), function (e, t) {
			var n = vn[t] || h.find.attr;
			vn[t] = yn && gn || !mn.test(t) ? function (e, t, r) {
				var i, s;
				return r || (s = vn[t], vn[t] = i, i = null != n(e, t, r) ? t.toLowerCase() : null, vn[t] = s), i
			} : function (e, t, n) {
				return n ? void 0 : e[h.camelCase("default-" + t)] ? t.toLowerCase() : null
			}
		}), yn && gn || (h.attrHooks.value = {
			set: function (e, t, n) {
				return h.nodeName(e, "input") ? void(e.defaultValue = t) : pn && pn.set(e, t, n)
			}
		}), gn || (pn = {
			set: function (e, t, n) {
				var r = e.getAttributeNode(n);
				return r || e.setAttributeNode(r = e.ownerDocument.createAttribute(n)), r.value = t += "", "value" === n || t === e.getAttribute(n) ? t : void 0
			}
		}, vn.id = vn.name = vn.coords = function (e, t, n) {
			var r;
			return n ? void 0 : (r = e.getAttributeNode(t)) && "" !== r.value ? r.value : null
		}, h.valHooks.button = {
			get: function (e, t) {
				var n = e.getAttributeNode(t);
				return n && n.specified ? n.value : void 0
			},
			set: pn.set
		}, h.attrHooks.contenteditable = {
			set: function (e, t, n) {
				pn.set(e, "" === t ? !1 : t, n)
			}
		}, h.each(["width", "height"], function (e, t) {
			h.attrHooks[t] = {
				set: function (e, n) {
					return "" === n ? (e.setAttribute(t, "auto"), n) : void 0
				}
			}
		})), l.style || (h.attrHooks.style = {
			get: function (e) {
				return e.style.cssText || void 0
			},
			set: function (e, t) {
				return e.style.cssText = t + ""
			}
		});
		var bn = /^(?:input|select|textarea|button|object)$/i,
			wn = /^(?:a|area)$/i;
		h.fn.extend({
			prop: function (e, t) {
				return $(this, h.prop, e, t, arguments.length > 1)
			},
			removeProp: function (e) {
				return e = h.propFix[e] || e, this.each(function () {
					try {
						this[e] = void 0, delete this[e]
					} catch (t) {}
				})
			}
		}), h.extend({
			propFix: {
				"for": "htmlFor",
				"class": "className"
			},
			prop: function (e, t, n) {
				var r, i, s, o = e.nodeType;
				if (e && 3 !== o && 8 !== o && 2 !== o) return s = 1 !== o || !h.isXMLDoc(e), s && (t = h.propFix[t] || t, i = h.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t]
			},
			propHooks: {
				tabIndex: {
					get: function (e) {
						var t = h.find.attr(e, "tabindex");
						return t ? parseInt(t, 10) : bn.test(e.nodeName) || wn.test(e.nodeName) && e.href ? 0 : -1
					}
				}
			}
		}), l.hrefNormalized || h.each(["href", "src"], function (e, t) {
			h.propHooks[t] = {
				get: function (e) {
					return e.getAttribute(t, 4)
				}
			}
		}), l.optSelected || (h.propHooks.selected = {
			get: function (e) {
				var t = e.parentNode;
				return t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex), null
			}
		}), h.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
			h.propFix[this.toLowerCase()] = this
		}), l.enctype || (h.propFix.enctype = "encoding");
		var En = /[\t\r\n\f]/g;
		h.fn.extend({
			addClass: function (e) {
				var t, n, r, i, s, o, u = 0,
					a = this.length,
					f = "string" == typeof e && e;
				if (h.isFunction(e)) return this.each(function (t) {
					h(this).addClass(e.call(this, t, this.className))
				});
				if (f)
					for (t = (e || "").match(O) || []; a > u; u++)
						if (n = this[u], r = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(En, " ") : " ")) {
							s = 0;
							while (i = t[s++]) r.indexOf(" " + i + " ") < 0 && (r += i + " ");
							o = h.trim(r), n.className !== o && (n.className = o)
						}
				return this
			},
			removeClass: function (e) {
				var t, n, r, i, s, o, u = 0,
					a = this.length,
					f = 0 === arguments.length || "string" == typeof e && e;
				if (h.isFunction(e)) return this.each(function (t) {
					h(this).removeClass(e.call(this, t, this.className))
				});
				if (f)
					for (t = (e || "").match(O) || []; a > u; u++)
						if (n = this[u], r = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(En, " ") : "")) {
							s = 0;
							while (i = t[s++])
								while (r.indexOf(" " + i + " ") >= 0) r = r.replace(" " + i + " ", " ");
							o = e ? h.trim(r) : "", n.className !== o && (n.className = o)
						}
				return this
			},
			toggleClass: function (e, t) {
				var n = typeof e;
				return "boolean" == typeof t && "string" === n ? t ? this.addClass(e) : this.removeClass(e) : this.each(h.isFunction(e) ? function (n) {
					h(this).toggleClass(e.call(this, n, this.className, t), t)
				} : function () {
					if ("string" === n) {
						var t, r = 0,
							i = h(this),
							s = e.match(O) || [];
						while (t = s[r++]) i.hasClass(t) ? i.removeClass(t) : i.addClass(t)
					} else(n === B || "boolean" === n) && (this.className && h._data(this, "__className__", this.className), this.className = this.className || e === !1 ? "" : h._data(this, "__className__") || "")
				})
			},
			hasClass: function (e) {
				for (var t = " " + e + " ", n = 0, r = this.length; r > n; n++)
					if (1 === this[n].nodeType && (" " + this[n].className + " ").replace(En, " ").indexOf(t) >= 0) return !0;
				return !1
			}
		}), h.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (e, t) {
			h.fn[t] = function (e, n) {
				return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
			}
		}), h.fn.extend({
			hover: function (e, t) {
				return this.mouseenter(e).mouseleave(t || e)
			},
			bind: function (e, t, n) {
				return this.on(e, null, t, n)
			},
			unbind: function (e, t) {
				return this.off(e, null, t)
			},
			delegate: function (e, t, n, r) {
				return this.on(t, e, n, r)
			},
			undelegate: function (e, t, n) {
				return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
			}
		});
		var Sn = h.now(),
			xn = /\?/,
			Tn = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
		h.parseJSON = function (t) {
			if (e.JSON && e.JSON.parse) return e.JSON.parse(t + "");
			var n, r = null,
				i = h.trim(t + "");
			return i && !h.trim(i.replace(Tn, function (e, t, i, s) {
				return n && t && (r = 0), 0 === r ? e : (n = i || t, r += !s - !i, "")
			})) ? Function("return " + i)() : h.error("Invalid JSON: " + t)
		}, h.parseXML = function (t) {
			var n, r;
			if (!t || "string" != typeof t) return null;
			try {
				e.DOMParser ? (r = new DOMParser, n = r.parseFromString(t, "text/xml")) : (n = new ActiveXObject("Microsoft.XMLDOM"), n.async = "false", n.loadXML(t))
			} catch (i) {
				n = void 0
			}
			return n && n.documentElement && !n.getElementsByTagName("parsererror").length || h.error("Invalid XML: " + t), n
		};
		var Nn, Cn, kn = /#.*$/,
			Ln = /([?&])_=[^&]*/,
			An = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
			On = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
			Mn = /^(?:GET|HEAD)$/,
			_n = /^\/\//,
			Dn = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
			Pn = {},
			Hn = {},
			Bn = "*/".concat("*");
		try {
			Cn = location.href
		} catch (jn) {
			Cn = T.createElement("a"), Cn.href = "", Cn = Cn.href
		}
		Nn = Dn.exec(Cn.toLowerCase()) || [], h.extend({
			active: 0,
			lastModified: {},
			etag: {},
			ajaxSettings: {
				url: Cn,
				type: "GET",
				isLocal: On.test(Nn[1]),
				global: !0,
				processData: !0,
				async: !0,
				contentType: "application/x-www-form-urlencoded; charset=UTF-8",
				accepts: {
					"*": Bn,
					text: "text/plain",
					html: "text/html",
					xml: "application/xml, text/xml",
					json: "application/json, text/javascript"
				},
				contents: {
					xml: /xml/,
					html: /html/,
					json: /json/
				},
				responseFields: {
					xml: "responseXML",
					text: "responseText",
					json: "responseJSON"
				},
				converters: {
					"* text": String,
					"text html": !0,
					"text json": h.parseJSON,
					"text xml": h.parseXML
				},
				flatOptions: {
					url: !0,
					context: !0
				}
			},
			ajaxSetup: function (e, t) {
				return t ? qn(qn(e, h.ajaxSettings), t) : qn(h.ajaxSettings, e)
			},
			ajaxPrefilter: Fn(Pn),
			ajaxTransport: Fn(Hn),
			ajax: function (e, t) {
				function x(e, t, n, r) {
					var f, g, y, w, S, x = t;
					2 !== b && (b = 2, o && clearTimeout(o), a = void 0, s = r || "", E.readyState = e > 0 ? 4 : 0, f = e >= 200 && 300 > e || 304 === e, n && (w = Rn(l, E, n)), w = Un(l, w, E, f), f ? (l.ifModified && (S = E.getResponseHeader("Last-Modified"), S && (h.lastModified[i] = S), S = E.getResponseHeader("etag"), S && (h.etag[i] = S)), 204 === e || "HEAD" === l.type ? x = "nocontent" : 304 === e ? x = "notmodified" : (x = w.state, g = w.data, y = w.error, f = !y)) : (y = x, (e || !x) && (x = "error", 0 > e && (e = 0))), E.status = e, E.statusText = (t || x) + "", f ? d.resolveWith(c, [g, x, E]) : d.rejectWith(c, [E, x, y]), E.statusCode(m), m = void 0, u && p.trigger(f ? "ajaxSuccess" : "ajaxError", [E, l, f ? g : y]), v.fireWith(c, [E, x]), u && (p.trigger("ajaxComplete", [E, l]), --h.active || h.event.trigger("ajaxStop")))
				}
				"object" == typeof e && (t = e, e = void 0), t = t || {};
				var n, r, i, s, o, u, a, f, l = h.ajaxSetup({}, t),
					c = l.context || l,
					p = l.context && (c.nodeType || c.jquery) ? h(c) : h.event,
					d = h.Deferred(),
					v = h.Callbacks("once memory"),
					m = l.statusCode || {},
					g = {},
					y = {},
					b = 0,
					w = "canceled",
					E = {
						readyState: 0,
						getResponseHeader: function (e) {
							var t;
							if (2 === b) {
								if (!f) {
									f = {};
									while (t = An.exec(s)) f[t[1].toLowerCase()] = t[2]
								}
								t = f[e.toLowerCase()]
							}
							return null == t ? null : t
						},
						getAllResponseHeaders: function () {
							return 2 === b ? s : null
						},
						setRequestHeader: function (e, t) {
							var n = e.toLowerCase();
							return b || (e = y[n] = y[n] || e, g[e] = t), this
						},
						overrideMimeType: function (e) {
							return b || (l.mimeType = e), this
						},
						statusCode: function (e) {
							var t;
							if (e)
								if (2 > b)
									for (t in e) m[t] = [m[t], e[t]];
								else E.always(e[E.status]);
							return this
						},
						abort: function (e) {
							var t = e || w;
							return a && a.abort(t), x(0, t), this
						}
					};
				if (d.promise(E).complete = v.add, E.success = E.done, E.error = E.fail, l.url = ((e || l.url || Cn) + "").replace(kn, "").replace(_n, Nn[1] + "//"), l.type = t.method || t.type || l.method || l.type, l.dataTypes = h.trim(l.dataType || "*").toLowerCase().match(O) || [""], null == l.crossDomain && (n = Dn.exec(l.url.toLowerCase()), l.crossDomain = !(!n || n[1] === Nn[1] && n[2] === Nn[2] && (n[3] || ("http:" === n[1] ? "80" : "443")) === (Nn[3] || ("http:" === Nn[1] ? "80" : "443")))), l.data && l.processData && "string" != typeof l.data && (l.data = h.param(l.data, l.traditional)), In(Pn, l, t, E), 2 === b) return E;
				u = l.global, u && 0 === h.active++ && h.event.trigger("ajaxStart"), l.type = l.type.toUpperCase(), l.hasContent = !Mn.test(l.type), i = l.url, l.hasContent || (l.data && (i = l.url += (xn.test(i) ? "&" : "?") + l.data, delete l.data), l.cache === !1 && (l.url = Ln.test(i) ? i.replace(Ln, "$1_=" + Sn++) : i + (xn.test(i) ? "&" : "?") + "_=" + Sn++)), l.ifModified && (h.lastModified[i] && E.setRequestHeader("If-Modified-Since", h.lastModified[i]), h.etag[i] && E.setRequestHeader("If-None-Match", h.etag[i])), (l.data && l.hasContent && l.contentType !== !1 || t.contentType) && E.setRequestHeader("Content-Type", l.contentType), E.setRequestHeader("Accept", l.dataTypes[0] && l.accepts[l.dataTypes[0]] ? l.accepts[l.dataTypes[0]] + ("*" !== l.dataTypes[0] ? ", " + Bn + "; q=0.01" : "") : l.accepts["*"]);
				for (r in l.headers) E.setRequestHeader(r, l.headers[r]);
				if (!l.beforeSend || l.beforeSend.call(c, E, l) !== !1 && 2 !== b) {
					w = "abort";
					for (r in {
							success: 1,
							error: 1,
							complete: 1
						}) E[r](l[r]);
					if (a = In(Hn, l, t, E)) {
						E.readyState = 1, u && p.trigger("ajaxSend", [E, l]), l.async && l.timeout > 0 && (o = setTimeout(function () {
							E.abort("timeout")
						}, l.timeout));
						try {
							b = 1, a.send(g, x)
						} catch (S) {
							if (!(2 > b)) throw S;
							x(-1, S)
						}
					} else x(-1, "No Transport");
					return E
				}
				return E.abort()
			},
			getJSON: function (e, t, n) {
				return h.get(e, t, n, "json")
			},
			getScript: function (e, t) {
				return h.get(e, void 0, t, "script")
			}
		}), h.each(["get", "post"], function (e, t) {
			h[t] = function (e, n, r, i) {
				return h.isFunction(n) && (i = i || r, r = n, n = void 0), h.ajax({
					url: e,
					type: t,
					dataType: i,
					data: n,
					success: r
				})
			}
		}), h.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
			h.fn[t] = function (e) {
				return this.on(t, e)
			}
		}), h._evalUrl = function (e) {
			return h.ajax({
				url: e,
				type: "GET",
				dataType: "script",
				async: !1,
				global: !1,
				"throws": !0
			})
		}, h.fn.extend({
			wrapAll: function (e) {
				if (h.isFunction(e)) return this.each(function (t) {
					h(this).wrapAll(e.call(this, t))
				});
				if (this[0]) {
					var t = h(e, this[0].ownerDocument).eq(0).clone(!0);
					this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
						var e = this;
						while (e.firstChild && 1 === e.firstChild.nodeType) e = e.firstChild;
						return e
					}).append(this)
				}
				return this
			},
			wrapInner: function (e) {
				return this.each(h.isFunction(e) ? function (t) {
					h(this).wrapInner(e.call(this, t))
				} : function () {
					var t = h(this),
						n = t.contents();
					n.length ? n.wrapAll(e) : t.append(e)
				})
			},
			wrap: function (e) {
				var t = h.isFunction(e);
				return this.each(function (n) {
					h(this).wrapAll(t ? e.call(this, n) : e)
				})
			},
			unwrap: function () {
				return this.parent().each(function () {
					h.nodeName(this, "body") || h(this).replaceWith(this.childNodes)
				}).end()
			}
		}), h.expr.filters.hidden = function (e) {
			return e.offsetWidth <= 0 && e.offsetHeight <= 0 || !l.reliableHiddenOffsets() && "none" === (e.style && e.style.display || h.css(e, "display"))
		}, h.expr.filters.visible = function (e) {
			return !h.expr.filters.hidden(e)
		};
		var zn = /%20/g,
			Wn = /\[\]$/,
			Xn = /\r?\n/g,
			Vn = /^(?:submit|button|image|reset|file)$/i,
			$n = /^(?:input|select|textarea|keygen)/i;
		h.param = function (e, t) {
			var n, r = [],
				i = function (e, t) {
					t = h.isFunction(t) ? t() : null == t ? "" : t, r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(t)
				};
			if (void 0 === t && (t = h.ajaxSettings && h.ajaxSettings.traditional), h.isArray(e) || e.jquery && !h.isPlainObject(e)) h.each(e, function () {
				i(this.name, this.value)
			});
			else
				for (n in e) Jn(n, e[n], t, i);
			return r.join("&").replace(zn, "+")
		}, h.fn.extend({
			serialize: function () {
				return h.param(this.serializeArray())
			},
			serializeArray: function () {
				return this.map(function () {
					var e = h.prop(this, "elements");
					return e ? h.makeArray(e) : this
				}).filter(function () {
					var e = this.type;
					return this.name && !h(this).is(":disabled") && $n.test(this.nodeName) && !Vn.test(e) && (this.checked || !J.test(e))
				}).map(function (e, t) {
					var n = h(this).val();
					return null == n ? null : h.isArray(n) ? h.map(n, function (e) {
						return {
							name: t.name,
							value: e.replace(Xn, "\r\n")
						}
					}) : {
						name: t.name,
						value: n.replace(Xn, "\r\n")
					}
				}).get()
			}
		}), h.ajaxSettings.xhr = void 0 !== e.ActiveXObject ? function () {
			return !this.isLocal && /^(get|post|head|put|delete|options)$/i.test(this.type) && Yn() || Zn()
		} : Yn;
		var Kn = 0,
			Qn = {},
			Gn = h.ajaxSettings.xhr();
		e.ActiveXObject && h(e).on("unload", function () {
			for (var e in Qn) Qn[e](void 0, !0)
		}), l.cors = !!Gn && "withCredentials" in Gn, Gn = l.ajax = !!Gn, Gn && h.ajaxTransport(function (e) {
			if (!e.crossDomain || l.cors) {
				var t;
				return {
					send: function (n, r) {
						var i, s = e.xhr(),
							o = ++Kn;
						if (s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
							for (i in e.xhrFields) s[i] = e.xhrFields[i];
						e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType), e.crossDomain || n["X-Requested-With"] || (n["X-Requested-With"] = "XMLHttpRequest");
						for (i in n) void 0 !== n[i] && s.setRequestHeader(i, n[i] + "");
						s.send(e.hasContent && e.data || null), t = function (n, i) {
							var u, a, f;
							if (t && (i || 4 === s.readyState))
								if (delete Qn[o], t = void 0, s.onreadystatechange = h.noop, i) 4 !== s.readyState && s.abort();
								else {
									f = {}, u = s.status, "string" == typeof s.responseText && (f.text = s.responseText);
									try {
										a = s.statusText
									} catch (l) {
										a = ""
									}
									u || !e.isLocal || e.crossDomain ? 1223 === u && (u = 204) : u = f.text ? 200 : 404
								}
							f && r(u, a, f, s.getAllResponseHeaders())
						}, e.async ? 4 === s.readyState ? setTimeout(t) : s.onreadystatechange = Qn[o] = t : t()
					},
					abort: function () {
						t && t(void 0, !0)
					}
				}
			}
		}), h.ajaxSetup({
			accepts: {
				script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
			},
			contents: {
				script: /(?:java|ecma)script/
			},
			converters: {
				"text script": function (e) {
					return h.globalEval(e), e
				}
			}
		}), h.ajaxPrefilter("script", function (e) {
			void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET", e.global = !1)
		}), h.ajaxTransport("script", function (e) {
			if (e.crossDomain) {
				var t, n = T.head || h("head")[0] || T.documentElement;
				return {
					send: function (r, i) {
						t = T.createElement("script"), t.async = !0, e.scriptCharset && (t.charset = e.scriptCharset), t.src = e.url, t.onload = t.onreadystatechange = function (e, n) {
							(n || !t.readyState || /loaded|complete/.test(t.readyState)) && (t.onload = t.onreadystatechange = null, t.parentNode && t.parentNode.removeChild(t), t = null, n || i(200, "success"))
						}, n.insertBefore(t, n.firstChild)
					},
					abort: function () {
						t && t.onload(void 0, !0)
					}
				}
			}
		});
		var er = [],
			tr = /(=)\?(?=&|$)|\?\?/;
		h.ajaxSetup({
			jsonp: "callback",
			jsonpCallback: function () {
				var e = er.pop() || h.expando + "_" + Sn++;
				return this[e] = !0, e
			}
		}), h.ajaxPrefilter("json jsonp", function (t, n, r) {
			var i, s, o, u = t.jsonp !== !1 && (tr.test(t.url) ? "url" : "string" == typeof t.data && !(t.contentType || "").indexOf("application/x-www-form-urlencoded") && tr.test(t.data) && "data");
			return u || "jsonp" === t.dataTypes[0] ? (i = t.jsonpCallback = h.isFunction(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, u ? t[u] = t[u].replace(tr, "$1" + i) : t.jsonp !== !1 && (t.url += (xn.test(t.url) ? "&" : "?") + t.jsonp + "=" + i), t.converters["script json"] = function () {
				return o || h.error(i + " was not called"), o[0]
			}, t.dataTypes[0] = "json", s = e[i], e[i] = function () {
				o = arguments
			}, r.always(function () {
				e[i] = s, t[i] && (t.jsonpCallback = n.jsonpCallback, er.push(i)), o && h.isFunction(s) && s(o[0]), o = s = void 0
			}), "script") : void 0
		}), h.parseHTML = function (e, t, n) {
			if (!e || "string" != typeof e) return null;
			"boolean" == typeof t && (n = t, t = !1), t = t || T;
			var r = w.exec(e),
				i = !n && [];
			return r ? [t.createElement(r[1])] : (r = h.buildFragment([e], t, i), i && i.length && h(i).remove(), h.merge([], r.childNodes))
		};
		var nr = h.fn.load;
		h.fn.load = function (e, t, n) {
			if ("string" != typeof e && nr) return nr.apply(this, arguments);
			var r, i, s, o = this,
				u = e.indexOf(" ");
			return u >= 0 && (r = h.trim(e.slice(u, e.length)), e = e.slice(0, u)), h.isFunction(t) ? (n = t, t = void 0) : t && "object" == typeof t && (s = "POST"), o.length > 0 && h.ajax({
				url: e,
				type: s,
				dataType: "html",
				data: t
			}).done(function (e) {
				i = arguments, o.html(r ? h("<div>").append(h.parseHTML(e)).find(r) : e)
			}).complete(n && function (e, t) {
				o.each(n, i || [e.responseText, t, e])
			}), this
		}, h.expr.filters.animated = function (e) {
			return h.grep(h.timers, function (t) {
				return e === t.elem
			}).length
		};
		var rr = e.document.documentElement;
		h.offset = {
			setOffset: function (e, t, n) {
				var r, i, s, o, u, a, f, l = h.css(e, "position"),
					c = h(e),
					p = {};
				"static" === l && (e.style.position = "relative"), u = c.offset(), s = h.css(e, "top"), a = h.css(e, "left"), f = ("absolute" === l || "fixed" === l) && h.inArray("auto", [s, a]) > -1, f ? (r = c.position(), o = r.top, i = r.left) : (o = parseFloat(s) || 0, i = parseFloat(a) || 0), h.isFunction(t) && (t = t.call(e, n, u)), null != t.top && (p.top = t.top - u.top + o), null != t.left && (p.left = t.left - u.left + i), "using" in t ? t.using.call(e, p) : c.css(p)
			}
		}, h.fn.extend({
			offset: function (e) {
				if (arguments.length) return void 0 === e ? this : this.each(function (t) {
					h.offset.setOffset(this, e, t)
				});
				var t, n, r = {
						top: 0,
						left: 0
					},
					i = this[0],
					s = i && i.ownerDocument;
				if (s) return t = s.documentElement, h.contains(t, i) ? (typeof i.getBoundingClientRect !== B && (r = i.getBoundingClientRect()), n = ir(s), {
					top: r.top + (n.pageYOffset || t.scrollTop) - (t.clientTop || 0),
					left: r.left + (n.pageXOffset || t.scrollLeft) - (t.clientLeft || 0)
				}) : r
			},
			position: function () {
				if (this[0]) {
					var e, t, n = {
							top: 0,
							left: 0
						},
						r = this[0];
					return "fixed" === h.css(r, "position") ? t = r.getBoundingClientRect() : (e = this.offsetParent(), t = this.offset(), h.nodeName(e[0], "html") || (n = e.offset()), n.top += h.css(e[0], "borderTopWidth", !0), n.left += h.css(e[0], "borderLeftWidth", !0)), {
						top: t.top - n.top - h.css(r, "marginTop", !0),
						left: t.left - n.left - h.css(r, "marginLeft", !0)
					}
				}
			},
			offsetParent: function () {
				return this.map(function () {
					var e = this.offsetParent || rr;
					while (e && !h.nodeName(e, "html") && "static" === h.css(e, "position")) e = e.offsetParent;
					return e || rr
				})
			}
		}), h.each({
			scrollLeft: "pageXOffset",
			scrollTop: "pageYOffset"
		}, function (e, t) {
			var n = /Y/.test(t);
			h.fn[e] = function (r) {
				return $(this, function (e, r, i) {
					var s = ir(e);
					return void 0 === i ? s ? t in s ? s[t] : s.document.documentElement[r] : e[r] : void(s ? s.scrollTo(n ? h(s).scrollLeft() : i, n ? i : h(s).scrollTop()) : e[r] = i)
				}, e, r, arguments.length, null)
			}
		}), h.each(["top", "left"], function (e, t) {
			h.cssHooks[t] = jt(l.pixelPosition, function (e, n) {
				return n ? (n = Ht(e, t), Dt.test(n) ? h(e).position()[t] + "px" : n) : void 0
			})
		}), h.each({
			Height: "height",
			Width: "width"
		}, function (e, t) {
			h.each({
				padding: "inner" + e,
				content: t,
				"": "outer" + e
			}, function (n, r) {
				h.fn[r] = function (r, i) {
					var s = arguments.length && (n || "boolean" != typeof r),
						o = n || (r === !0 || i === !0 ? "margin" : "border");
					return $(this, function (t, n, r) {
						var i;
						return h.isWindow(t) ? t.document.documentElement["client" + e] : 9 === t.nodeType ? (i = t.documentElement, Math.max(t.body["scroll" + e], i["scroll" + e], t.body["offset" + e], i["offset" + e], i["client" + e])) : void 0 === r ? h.css(t, n, o) : h.style(t, n, r, o)
					}, t, s ? r : void 0, s, null)
				}
			})
		}), h.fn.size = function () {
			return this.length
		}, h.fn.andSelf = h.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function () {
			return h
		});
		var sr = e.jQuery,
			or = e.$;
		return h.noConflict = function (t) {
			return e.$ === h && (e.$ = or), t && e.jQuery === h && (e.jQuery = sr), h
		}, typeof t === B && (e.jQuery = e.$ = h), h
	}),
	function (e) {
		typeof define == "function" && define.amd ? define("lib/jquery.matchHeight", ["jquery"], e) : typeof module != "undefined" && module.exports ? module.exports = e(require("jquery")) : e(jQuery)
	}(function (e) {
		var t = -1,
			n = -1,
			r = function (e) {
				return parseFloat(e) || 0
			},
			i = function (t) {
				var n = 1,
					i = e(t),
					s = null,
					o = [];
				return i.each(function () {
					var t = e(this),
						i = t.offset().top - r(t.css("margin-top")),
						u = o.length > 0 ? o[o.length - 1] : null;
					u === null ? o.push(t) : Math.floor(Math.abs(s - i)) <= n ? o[o.length - 1] = u.add(t) : o.push(t), s = i
				}), o
			},
			s = function (t) {
				var n = {
					byRow: !0,
					property: "height",
					target: null,
					remove: !1
				};
				return typeof t == "object" ? e.extend(n, t) : (typeof t == "boolean" ? n.byRow = t : t === "remove" && (n.remove = !0), n)
			},
			o = e.fn.matchHeight = function (t) {
				var n = s(t);
				if (n.remove) {
					var r = this;
					return this.css(n.property, ""), e.each(o._groups, function (e, t) {
						t.elements = t.elements.not(r)
					}), this
				}
				return this.length <= 1 && !n.target ? this : (o._groups.push({
					elements: this,
					options: n
				}), o._apply(this, n), this)
			};
		o.version = "master", o._groups = [], o._throttle = 80, o._maintainScroll = !1, o._beforeUpdate = null, o._afterUpdate = null, o._rows = i, o._parse = r, o._parseOptions = s, o._apply = function (t, n) {
			var u = s(n),
				a = e(t),
				f = [a],
				l = e(window).scrollTop(),
				c = e("html").outerHeight(!0),
				h = a.parents().filter(":hidden");
			return h.each(function () {
				var t = e(this);
				t.data("style-cache", t.attr("style"))
			}), h.css("display", "block"), u.byRow && !u.target && (a.each(function () {
				var t = e(this),
					n = t.css("display");
				n !== "inline-block" && n !== "flex" && n !== "inline-flex" && (n = "block"), t.data("style-cache", t.attr("style")), t.css({
					display: n,
					"padding-top": "0",
					"padding-bottom": "0",
					"margin-top": "0",
					"margin-bottom": "0",
					"border-top-width": "0",
					"border-bottom-width": "0",
					height: "100px",
					overflow: "hidden"
				})
			}), f = i(a), a.each(function () {
				var t = e(this);
				t.attr("style", t.data("style-cache") || "")
			})), e.each(f, function (t, n) {
				var i = e(n),
					s = 0;
				if (!u.target) {
					if (u.byRow && i.length <= 1) {
						i.css(u.property, "");
						return
					}
					i.each(function () {
						var t = e(this),
							n = t.attr("style"),
							r = t.css("display");
						r !== "inline-block" && r !== "flex" && r !== "inline-flex" && (r = "block");
						var i = {
							display: r
						};
						i[u.property] = "", t.css(i), t.outerHeight(!1) > s && (s = t.outerHeight(!1)), n ? t.attr("style", n) : t.css("display", "")
					})
				} else s = u.target.outerHeight(!1);
				i.each(function () {
					var t = e(this),
						n = 0;
					if (u.target && t.is(u.target)) return;
					t.css("box-sizing") !== "border-box" && (n += r(t.css("border-top-width")) + r(t.css("border-bottom-width")), n += r(t.css("padding-top")) + r(t.css("padding-bottom"))), t.css(u.property, s - n + "px")
				})
			}), h.each(function () {
				var t = e(this);
				t.attr("style", t.data("style-cache") || null)
			}), o._maintainScroll && e(window).scrollTop(l / c * e("html").outerHeight(!0)), this
		}, o._applyDataApi = function () {
			var t = {};
			e("[data-match-height], [data-mh]").each(function () {
				var n = e(this),
					r = n.attr("data-mh") || n.attr("data-match-height");
				r in t ? t[r] = t[r].add(n) : t[r] = n
			}), e.each(t, function () {
				this.matchHeight(!0)
			})
		};
		var u = function (t) {
			o._beforeUpdate && o._beforeUpdate(t, o._groups), e.each(o._groups, function () {
				o._apply(this.elements, this.options)
			}), o._afterUpdate && o._afterUpdate(t, o._groups)
		};
		o._update = function (r, i) {
			if (i && i.type === "resize") {
				var s = e(window).width();
				if (s === t) return;
				t = s
			}
			r ? n === -1 && (n = setTimeout(function () {
				u(i), n = -1
			}, o._throttle)) : u(i)
		}, e(o._applyDataApi);
		var a = e.fn.on ? "on" : "bind";
		e(window)[a]("load", function (e) {
			o._update(!1, e)
		}), e(window)[a]("resize orientationchange", function (e) {
			o._update(!0, e)
		})
	}), define("modules/hamburger", ["jquery", "../lib/jquery.matchHeight"], function (e) {
		e(function () {
			function t() {
				delay = 200, w > 767 ? inc = 100 : inc = 30, e(".menu__items .menu__folder").each(function () {
					e(this).css("-webkit-transition-delay", delay + "ms"), e(this).css("transition-delay", delay + "ms"), delay += inc, delay >= 600 && w > 767 && (delay = 200)
				})
			}
			w = e(window).width();
			var n = 0;
			e(".hamburger").on("click touchstart", function (r) {
				r.preventDefault(), e(".menu-panel").scrollTop(0), e(".hamburger__bar").toggleClass("animate"), e("#main-menu").toggleClass("active"), e("#side-login").toggleClass("active"), e("body").hasClass("popup__active") ? (e("body").removeClass("popup__active"), e("body,html").scrollTop(n)) : (n = e(window).scrollTop(), console.log(n), e("body").addClass("popup__active")), e(".hamburger__bar").hasClass("animate") && (e(".menu__folder h5").removeClass("active"), e(".menu__subfolder").removeClass("active"), e(window).resize(), t())
			}), e(".menu__folder").matchHeight(), e(".menu__folder h5").on("click", function (t) {
				t.preventDefault(), e(this).hasClass("active") ? (e(this).removeClass("active"), e(this).next(".menu__subfolder").removeClass("active"), e(window).resize()) : (e(".menu__folder h5").removeClass("active"), e(".menu__subfolder").removeClass("active"), e(this).addClass("active"), e(this).next(".menu__subfolder").addClass("active"), e(window).resize())
			}), e(window).on("resize orientationchange", function () {
				
				 e(".menu__wrapper").css("height", e(".menu__items").outerHeight() + "px"), w = e(window).width(),e("#main-menu .positive-lines.negative").css("max-height", e(".menu__wrapper").outerHeight() + "px")
			}).resize(), e(window).on("hashchange", function () {
				e("#main-menu").hasClass("active") && (linkId = location.hash.slice(1), e(".menu-panel").scrollTop(0), e(".hamburger__bar").toggleClass("animate"), e("body").removeClass("popup__active"), e("#main-menu").toggleClass("active"), e("#side-login").toggleClass("active"), e("html, body").animate({
					scrollTop: e("#" + linkId).offset().top
				}, 400))
			})
		})
	}), define("modules/topmenu", ["jquery"], function (e) {
		e(function () {
			e(window).on("scroll", function () {
				e(document).scrollTop() > 60 ? e(".topmenu").addClass("back") : e(".topmenu").removeClass("back")
			}).scroll()
		})
	}), define("modules/steps", ["jquery", "../lib/jquery.matchHeight"], function (e) {
		e(function () {
			e(".steps__title h5").matchHeight(), e(".steps__inside p").matchHeight(), e(".steps__item").matchHeight()
		})
	}), define("modules/campus-switch", ["jquery", "../lib/jquery.matchHeight"], function (e) {
		e(function () {
			w = e(window).width(), e(".campus-details__title").matchHeight(), w > 1023 && e(".campus__switch").matchHeight({
				target: e(".campus-details")
			}), e.fn.matchHeight._afterUpdate = function (t, n) {
				e(window).width() <= 1023 && (h = e(".campus-details__title").height() + e(".campus-details__info").height() + 140, e(".campus-details__item").css("height", h + "px"))
			}, e(".campus__switch__item").on("click touchstart", function (t) {
				t.preventDefault(), e(this).hasClass("active") || (e(".campus__switch__item").removeClass("active"), e(this).addClass("active"), module = e(this).attr("data-campus"), e(".campus-details__item").removeClass("active"), e(".campus-image").removeClass("active"), e("#" + module + "-text").addClass("active"), e("#" + module + "-img").addClass("active"))
			})
		})
	}), define("modules/home-events", ["jquery", "../lib/jquery.matchHeight"], function (e) {
		e(function () {
			e(".events__item").matchHeight(), e(".events__item").hover(function () {
				o = e(this).find(".bg"), o.addClass("hover")
			}, function () {
				o = e(this).find(".bg"), o.removeClass("hover")
			})
		})
	}), ! function (e) {
		"function" == typeof define && define.amd ? define("lib/slick.min", ["jquery"], e) : "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
	}(function (e) {
		 var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };
		
	 e.fn.slick = function() {
        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if (typeof opt == 'object' || typeof opt == 'undefined')
	                _[i].slick = new Slick(_[i], opt);
	            else
	                ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };

	}), define("modules/bannerslider", ["jquery", "../lib/slick.min"], function (e) {
		e(function () {
			e(".home-slider__items").slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: !0,
				arrows: !1,
				fade: !0,
				dots: !1,
				pauseOnHover: !1,
				autoplay: !0,
				autoplaySpeed: 4e3,
				speed: 1e3
			});
			0 == /Google Page Speed Insights/i.test(navigator.userAgent) && (1 < window.devicePixelRatio && window.matchMedia("(min-width:601px)").matches ? e("[data-slideretina]").each(function () {
				var a = $(this),
					e = a.data("slideretina");
				a.css("background-image", "url(" + e + ")")
			}) : e("[data-slideimage]").each(function () {
				var a = $(this),
					e = a.data("slideimage");
				a.css("background-image", "url(" + e + ")")
			}));;
		})
	}), define("modules/admission", ["jquery", "../lib/jquery.matchHeight"], function (e) {
		e(function () {
			e(".admission-fees__title").matchHeight(), e(".admission-fees__item .address").matchHeight()
		})
	}), define("modules/accordion", ["jquery", "../lib/jquery.matchHeight"], function (e) {
		e(function () {
			e(".accordion__title").on("click", function (t) {
				t.preventDefault(), e(this).hasClass("active") ? (e(this).removeClass("active"), e(this).parent().removeClass("active")) : (e(this).addClass("active"), e(this).parent().addClass("active"))
			})
		})
	}), define("modules/simple_carousel", ["jquery", "../lib/slick.min", "../lib/jquery.matchHeight"], function (e) {
		e(function () {
			function t() {
				var t = 0;
				e(".facilities-item.slick-slide").each(function (n, r) {
					t < e(r).find("h6").height() && (t = e(r).find("h6").height()), e(".facilities-item").length == n + 1 && e(".facilities-item").find("h6").css({
						"min-height": t
					})
				})
			}
			e(".fleet-slider-init").slick({
				dots: !0,
				arrows: !0,
				infinite: !1,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 3,
				
				responsive: [{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 660,
					settings: {
						dots: !1,
						arrows: !0,
						swipe: !1,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			}),


			e(".simple_carousel").slick({
				dots: !1,
				infinite: !1,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 3,
				responsive: [{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 660,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: !1,
						arrows: !1
					}
				}]
			}), e(".articles_gallery").slick({
				dots: !0,
				arrows: !1,
				infinite: !1,
				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 4,
				autoplay: !0,
				pauseOnHover: !0,
				pauseOnDotsHover: !0,
				responsive: [{
					breakpoint: 1023,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}, {
					breakpoint: 660,
					settings: {
						dots: !1,
						ows: !1,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			}), e(window).on("resize", function () {
				window.matchMedia("(min-width: 641px)").matches ? setTimeout(function () {
					t(!0)
				}, 200) : e(".facilities-item h6").css({
					"min-height": "0"
				})
			}), e(".facilities-block-body").on("init", function () {
				window.matchMedia("(min-width: 641px)").matches && setTimeout(function () {
					t()
				}, 200)
			}),
			e(".page-slider-init").slick({
				dots: !0,
				arrows: !0,
				infinite: !1,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 3,
				
				responsive: [{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 660,
					settings: {
						dots: !1,
						arrows: !1,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			}),
			e(".album_trigger").click(function(){
	       	 var target =  $(this).data('target');
		      e('#'+target).trigger( "click" );
		        return false;
		      }),
			
			 e(".facilities-block-body").slick({
				dots: !1,
				infinite: !1,
				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 4,
				responsive: [{
					breakpoint: 1023,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}, {
					breakpoint: 641,
					settings: {
						dots: !1,
						ows: !1,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			}), e(".post-carousel__header").length && e(".post-carousel__header").matchHeight()
		})
	}), define("modules/contact_section", ["jquery", "../lib/jquery.matchHeight"], function (e) {
		function r(e, r, s) {
			var o = [{
					stylers: [{
						hue: "#C8CFA1"
					}, {
						saturation: -60
					}, {
						gamma: .72
					}]
				}],
				u = new google.maps.LatLng(e, r),
				a = {
					zoom: s,
					scrollwheel: !1,
					center: u,
					draggable: !0,
					scrollwheel: !1,
					zoomControl: !0,
					mapTypeControl: !0,
					streetViewControl: !0,
					mapTypeId: google.maps.MapTypeId.ROADMAP
				},
				f = "/i/loc_small.svg",
				l = new google.maps.MarkerImage(f, new google.maps.Size(40, 50));
			t = new google.maps.Map(document.getElementById("map"), a), n = new google.maps.Marker({
				position: u,
				map: t,
				icon: {
					path: "M27,12.19A13.35,13.35,0,0,0,13.5,0,13.35,13.35,0,0,0,0,12.19a11.47,11.47,0,0,0,.82,5.18,13.71,13.71,0,0,0,3,4.58l8.79,9.68a1.09,1.09,0,0,0,1.63,0L23.11,22a14.13,14.13,0,0,0,3-4.58A12.08,12.08,0,0,0,27,12.19Zm-13.47,4a4.13,4.13,0,0,1-4.16-4.05,4.16,4.16,0,0,1,8.32,0A4.13,4.13,0,0,1,13.5,16.2Z",
					fillColor: "#bd3739",
					fillOpacity: 1,
					scale: 1,
					strokeColor: "#bd3739"
				}
			}), t.panTo(u), google.maps.event.addDomListener(window, "resize", function () {
				t.setCenter(u)
			}), n.addListener("click", i), n.setAnimation(google.maps.Animation.BOUNCE)
		}

		function i() {
			n.getAnimation() !== null ? n.setAnimation(null) : n.setAnimation(google.maps.Animation.BOUNCE)
		}
		var t, n;
		e(function () {
			var t = e("#map");
			t.length && (t.hasClass("loaded") || (t.addClass("loaded"), lat = e("#map").data("lat"), lng = e("#map").data("lng"), zoom = e("#map").data("zoom"), r(lat, lng, zoom)))
		})
	}),
	function (e, t, n) {
		var r = e.document,
			i = e.Modernizr,
			s = function (e) {
				return e.charAt(0).toUpperCase() + e.slice(1)
			},
			o = "Moz Webkit O Ms".split(" "),
			u = function (e) {
				var t = r.documentElement.style,
					n;
				if (typeof t[e] == "string") return e;
				e = s(e);
				for (var i = 0, u = o.length; i < u; i++) {
					n = o[i] + e;
					if (typeof t[n] == "string") return n
				}
			},
			a = u("transform"),
			f = u("transitionProperty"),
			l = {
				csstransforms: function () {
					return !!a
				},
				csstransforms3d: function () {
					var e = !!u("perspective");
					if (e) {
						var n = " -o- -moz- -ms- -webkit- -khtml- ".split(" "),
							r = "@media (" + n.join("transform-3d),(") + "modernizr)",
							i = t("<style>" + r + "{#modernizr{height:3px}}" + "</style>").appendTo("head"),
							s = t('<div id="modernizr" />').appendTo("html");
						e = s.height() === 3, s.remove(), i.remove()
					}
					return e
				},
				csstransitions: function () {
					return !!f
				}
			},
			c;
		if (i)
			for (c in l) i.hasOwnProperty(c) || i.addTest(c, l[c]);
		else {
			i = e.Modernizr = {
				_version: "1.6ish: miniModernizr for Isotope"
			};
			var h = " ",
				p;
			for (c in l) p = l[c](), i[c] = p, h += " " + (p ? "" : "no-") + c;
			t("html").addClass(h)
		}
		if (i.csstransforms) {
			var d = i.csstransforms3d ? {
					translate: function (e) {
						return "translate3d(" + e[0] + "px, " + e[1] + "px, 0) "
					},
					scale: function (e) {
						return "scale3d(" + e + ", " + e + ", 1) "
					}
				} : {
					translate: function (e) {
						return "translate(" + e[0] + "px, " + e[1] + "px) "
					},
					scale: function (e) {
						return "scale(" + e + ") "
					}
				},
				v = function (e, n, r) {
					var i = t.data(e, "isoTransform") || {},
						s = {},
						o, u = {},
						f;
					s[n] = r, t.extend(i, s);
					for (o in i) f = i[o], u[o] = d[o](f);
					var l = u.translate || "",
						c = u.scale || "",
						h = l + c;
					t.data(e, "isoTransform", i), e.style[a] = h
				};
			t.cssNumber.scale = !0, t.cssHooks.scale = {
				set: function (e, t) {
					v(e, "scale", t)
				},
				get: function (e, n) {
					var r = t.data(e, "isoTransform");
					return r && r.scale ? r.scale : 1
				}
			}, t.fx.step.scale = function (e) {
				t.cssHooks.scale.set(e.elem, e.now + e.unit)
			}, t.cssNumber.translate = !0, t.cssHooks.translate = {
				set: function (e, t) {
					v(e, "translate", t)
				},
				get: function (e, n) {
					var r = t.data(e, "isoTransform");
					return r && r.translate ? r.translate : [0, 0]
				}
			}
		}
		var m, g;
		i.csstransitions && (m = {
			WebkitTransitionProperty: "webkitTransitionEnd",
			MozTransitionProperty: "transitionend",
			OTransitionProperty: "oTransitionEnd otransitionend",
			transitionProperty: "transitionend"
		}[f], g = u("transitionDuration"));
		var y = t.event,
			b = t.event.handle ? "handle" : "dispatch",
			w;
		y.special.smartresize = {
			setup: function () {
				t(this).bind("resize", y.special.smartresize.handler)
			},
			teardown: function () {
				t(this).unbind("resize", y.special.smartresize.handler)
			},
			handler: function (e, t) {
				var n = this,
					r = arguments;
				e.type = "smartresize", w && clearTimeout(w), w = setTimeout(function () {
					y[b].apply(n, r)
				}, t === "execAsap" ? 0 : 100)
			}
		}, t.fn.smartresize = function (e) {
			return e ? this.bind("smartresize", e) : this.trigger("smartresize", ["execAsap"])
		}, t.Isotope = function (e, n, r) {
			this.element = t(n), this._create(e), this._init(r)
		};
		var E = ["width", "height"],
			S = t(e);
		t.Isotope.settings = {
			resizable: !0,
			layoutMode: "masonry",
			containerClass: "isotope",
			itemClass: "isotope-item",
			hiddenClass: "isotope-hidden",
			hiddenStyle: {
				opacity: 0,
				scale: .001
			},
			visibleStyle: {
				opacity: 1,
				scale: 1
			},
			containerStyle: {
				position: "relative",
				overflow: "hidden"
			},
			animationEngine: "best-available",
			animationOptions: {
				queue: !1,
				duration: 800
			},
			sortBy: "original-order",
			sortAscending: !0,
			resizesContainer: !0,
			transformsEnabled: !0,
			itemPositionDataEnabled: !1
		}, t.Isotope.prototype = {
			_create: function (e) {
				this.options = t.extend({}, t.Isotope.settings, e), this.styleQueue = [], this.elemCount = 0;
				var n = this.element[0].style;
				this.originalStyle = {};
				var r = E.slice(0);
				for (var i in this.options.containerStyle) r.push(i);
				for (var s = 0, o = r.length; s < o; s++) i = r[s], this.originalStyle[i] = n[i] || "";
				this.element.css(this.options.containerStyle), this._updateAnimationEngine(), this._updateUsingTransforms();
				var u = {
					"original-order": function (e, t) {
						return t.elemCount++, t.elemCount
					},
					random: function () {
						return Math.random()
					}
				};
				this.options.getSortData = t.extend(this.options.getSortData, u), this.reloadItems(), this.offset = {
					left: parseInt(this.element.css("padding-left") || 0, 10),
					top: parseInt(this.element.css("padding-top") || 0, 10)
				};
				var a = this;
				setTimeout(function () {
					a.element.addClass(a.options.containerClass)
				}, 0), this.options.resizable && S.bind("smartresize.isotope", function () {
					a.resize()
				}), this.element.delegate("." + this.options.hiddenClass, "click", function () {
					return !1
				})
			},
			_getAtoms: function (e) {
				var t = this.options.itemSelector,
					n = t ? e.filter(t).add(e.find(t)) : e,
					r = {
						position: "absolute"
					};
				return n = n.filter(function (e, t) {
					return t.nodeType === 1
				}), this.usingTransforms && (r.left = 0, r.top = 0), n.css(r).addClass(this.options.itemClass), this.updateSortData(n, !0), n
			},
			_init: function (e) {
				this.$filteredAtoms = this._filter(this.$allAtoms), this._sort(), this.reLayout(e)
			},
			option: function (e) {
				if (t.isPlainObject(e)) {
					this.options = t.extend(!0, this.options, e);
					var n;
					for (var r in e) n = "_update" + s(r), this[n] && this[n]()
				}
			},
			_updateAnimationEngine: function () {
				var e = this.options.animationEngine.toLowerCase().replace(/[ _\-]/g, ""),
					t;
				switch (e) {
					case "css":
					case "none":
						t = !1;
						break;
					case "jquery":
						t = !0;
						break;
					default:
						t = !i.csstransitions
				}
				this.isUsingJQueryAnimation = t, this._updateUsingTransforms()
			},
			_updateTransformsEnabled: function () {
				this._updateUsingTransforms()
			},
			_updateUsingTransforms: function () {
				var e = this.usingTransforms = this.options.transformsEnabled && i.csstransforms && i.csstransitions && !this.isUsingJQueryAnimation;
				e || (delete this.options.hiddenStyle.scale, delete this.options.visibleStyle.scale), this.getPositionStyles = e ? this._translate : this._positionAbs
			},
			_filter: function (e) {
				var t = this.options.filter === "" ? "*" : this.options.filter;
				if (!t) return e;
				var n = this.options.hiddenClass,
					r = "." + n,
					i = e.filter(r),
					s = i;
				if (t !== "*") {
					s = i.filter(t);
					var o = e.not(r).not(t).addClass(n);
					this.styleQueue.push({
						$el: o,
						style: this.options.hiddenStyle
					})
				}
				return this.styleQueue.push({
					$el: s,
					style: this.options.visibleStyle
				}), s.removeClass(n), e.filter(t)
			},
			updateSortData: function (e, n) {
				var r = this,
					i = this.options.getSortData,
					s, o;
				e.each(function () {
					s = t(this), o = {};
					for (var e in i) !n && e === "original-order" ? o[e] = t.data(this, "isotope-sort-data")[e] : o[e] = i[e](s, r);
					t.data(this, "isotope-sort-data", o)
				})
			},
			_sort: function () {
				var e = this.options.sortBy,
					t = this._getSorter,
					n = this.options.sortAscending ? 1 : -1,
					r = function (r, i) {
						var s = t(r, e),
							o = t(i, e);
						return s === o && e !== "original-order" && (s = t(r, "original-order"), o = t(i, "original-order")), (s > o ? 1 : s < o ? -1 : 0) * n
					};
				this.$filteredAtoms.sort(r)
			},
			_getSorter: function (e, n) {
				return t.data(e, "isotope-sort-data")[n]
			},
			_translate: function (e, t) {
				return {
					translate: [e, t]
				}
			},
			_positionAbs: function (e, t) {
				return {
					left: e,
					top: t
				}
			},
			_pushPosition: function (e, t, n) {
				t = Math.round(t + this.offset.left), n = Math.round(n + this.offset.top);
				var r = this.getPositionStyles(t, n);
				this.styleQueue.push({
					$el: e,
					style: r
				}), this.options.itemPositionDataEnabled && e.data("isotope-item-position", {
					x: t,
					y: n
				})
			},
			layout: function (e, t) {
				var n = this.options.layoutMode;
				this["_" + n + "Layout"](e);
				if (this.options.resizesContainer) {
					var r = this["_" + n + "GetContainerSize"]();
					this.styleQueue.push({
						$el: this.element,
						style: r
					})
				}
				this._processStyleQueue(e, t), this.isLaidOut = !0
			},
			_processStyleQueue: function (e, n) {
				var r = this.isLaidOut ? this.isUsingJQueryAnimation ? "animate" : "css" : "css",
					s = this.options.animationOptions,
					o = this.options.onLayout,
					u, a, f, l;
				a = function (e, t) {
					t.$el[r](t.style, s)
				};
				if (this._isInserting && this.isUsingJQueryAnimation) a = function (e, t) {
					u = t.$el.hasClass("no-transition") ? "css" : r, t.$el[u](t.style, s)
				};
				else if (n || o || s.complete) {
					var c = !1,
						h = [n, o, s.complete],
						p = this;
					f = !0, l = function () {
						if (c) return;
						var t;
						for (var n = 0, r = h.length; n < r; n++) t = h[n], typeof t == "function" && t.call(p.element, e, p);
						c = !0
					};
					if (this.isUsingJQueryAnimation && r === "animate") s.complete = l, f = !1;
					else if (i.csstransitions) {
						var d = 0,
							v = this.styleQueue[0],
							y = v && v.$el,
							b;
						while (!y || !y.length) {
							b = this.styleQueue[d++];
							if (!b) return;
							y = b.$el
						}
						var w = parseFloat(getComputedStyle(y[0])[g]);
						w > 0 && (a = function (e, t) {
							t.$el[r](t.style, s).one(m, l)
						}, f = !1)
					}
				}
				t.each(this.styleQueue, a), f && l(), this.styleQueue = []
			},
			resize: function () {
				this["_" + this.options.layoutMode + "ResizeChanged"]() && this.reLayout()
			},
			reLayout: function (e) {
				this["_" + this.options.layoutMode + "Reset"](), this.layout(this.$filteredAtoms, e)
			},
			addItems: function (e, t) {
				var n = this._getAtoms(e);
				this.$allAtoms = this.$allAtoms.add(n), t && t(n)
			},
			insert: function (e, t) {
				this.element.append(e);
				var n = this;
				this.addItems(e, function (e) {
					var r = n._filter(e);
					n._addHideAppended(r), n._sort(), n.reLayout(), n._revealAppended(r, t)
				})
			},
			appended: function (e, t) {
				var n = this;
				this.addItems(e, function (e) {
					n._addHideAppended(e), n.layout(e), n._revealAppended(e, t)
				})
			},
			_addHideAppended: function (e) {
				this.$filteredAtoms = this.$filteredAtoms.add(e), e.addClass("no-transition"), this._isInserting = !0, this.styleQueue.push({
					$el: e,
					style: this.options.hiddenStyle
				})
			},
			_revealAppended: function (e, t) {
				var n = this;
				setTimeout(function () {
					e.removeClass("no-transition"), n.styleQueue.push({
						$el: e,
						style: n.options.visibleStyle
					}), n._isInserting = !1, n._processStyleQueue(e, t)
				}, 10)
			},
			reloadItems: function () {
				this.$allAtoms = this._getAtoms(this.element.children())
			},
			remove: function (e, t) {
				this.$allAtoms = this.$allAtoms.not(e), this.$filteredAtoms = this.$filteredAtoms.not(e);
				var n = this,
					r = function () {
						e.remove(), t && t.call(n.element)
					};
				e.filter(":not(." + this.options.hiddenClass + ")").length ? (this.styleQueue.push({
					$el: e,
					style: this.options.hiddenStyle
				}), this._sort(), this.reLayout(r)) : r()
			},
			shuffle: function (e) {
				this.updateSortData(this.$allAtoms), this.options.sortBy = "random", this._sort(), this.reLayout(e)
			},
			destroy: function () {
				var e = this.usingTransforms,
					t = this.options;
				this.$allAtoms.removeClass(t.hiddenClass + " " + t.itemClass).each(function () {
					var t = this.style;
					t.position = "", t.top = "", t.left = "", t.opacity = "", e && (t[a] = "")
				});
				var n = this.element[0].style;
				for (var r in this.originalStyle) n[r] = this.originalStyle[r];
				this.element.unbind(".isotope").undelegate("." + t.hiddenClass, "click").removeClass(t.containerClass).removeData("isotope"), S.unbind(".isotope")
			},
			_getSegments: function (e) {
				var t = this.options.layoutMode,
					n = e ? "rowHeight" : "columnWidth",
					r = e ? "height" : "width",
					i = e ? "rows" : "cols",
					o = this.element[r](),
					u, a = this.options[t] && this.options[t][n] || this.$filteredAtoms["outer" + s(r)](!0) || o;
				u = Math.floor(o / a), u = Math.max(u, 1), this[t][i] = u, this[t][n] = a
			},
			_checkIfSegmentsChanged: function (e) {
				var t = this.options.layoutMode,
					n = e ? "rows" : "cols",
					r = this[t][n];
				return this._getSegments(e), this[t][n] !== r
			},
			_masonryReset: function () {
				this.masonry = {}, this._getSegments();
				var e = this.masonry.cols;
				this.masonry.colYs = [];
				while (e--) this.masonry.colYs.push(0)
			},
			_masonryLayout: function (e) {
				var n = this,
					r = n.masonry;
				e.each(function () {
					var e = t(this),
						i = Math.ceil(e.outerWidth(!0) / r.columnWidth);
					i = Math.min(i, r.cols);
					if (i === 1) n._masonryPlaceBrick(e, r.colYs);
					else {
						var s = r.cols + 1 - i,
							o = [],
							u, a;
						for (a = 0; a < s; a++) u = r.colYs.slice(a, a + i), o[a] = Math.max.apply(Math, u);
						n._masonryPlaceBrick(e, o)
					}
				})
			},
			_masonryPlaceBrick: function (e, t) {
				var n = Math.min.apply(Math, t),
					r = 0;
				for (var i = 0, s = t.length; i < s; i++)
					if (t[i] === n) {
						r = i;
						break
					}
				var o = this.masonry.columnWidth * r,
					u = n;
				this._pushPosition(e, o, u);
				var a = n + e.outerHeight(!0),
					f = this.masonry.cols + 1 - s;
				for (i = 0; i < f; i++) this.masonry.colYs[r + i] = a
			},
			_masonryGetContainerSize: function () {
				var e = Math.max.apply(Math, this.masonry.colYs);
				return {
					height: e
				}
			},
			_masonryResizeChanged: function () {
				return this._checkIfSegmentsChanged()
			},
			_fitRowsReset: function () {
				this.fitRows = {
					x: 0,
					y: 0,
					height: 0
				}
			},
			_fitRowsLayout: function (e) {
				var n = this,
					r = this.element.width(),
					i = this.fitRows;
				e.each(function () {
					var e = t(this),
						s = e.outerWidth(!0),
						o = e.outerHeight(!0);
					i.x !== 0 && s + i.x > r && (i.x = 0, i.y = i.height), n._pushPosition(e, i.x, i.y), i.height = Math.max(i.y + o, i.height), i.x += s
				})
			},
			_fitRowsGetContainerSize: function () {
				return {
					height: this.fitRows.height
				}
			},
			_fitRowsResizeChanged: function () {
				return !0
			},
			_cellsByRowReset: function () {
				this.cellsByRow = {
					index: 0
				}, this._getSegments(), this._getSegments(!0)
			},
			_cellsByRowLayout: function (e) {
				var n = this,
					r = this.cellsByRow;
				e.each(function () {
					var e = t(this),
						i = r.index % r.cols,
						s = Math.floor(r.index / r.cols),
						o = (i + .5) * r.columnWidth - e.outerWidth(!0) / 2,
						u = (s + .5) * r.rowHeight - e.outerHeight(!0) / 2;
					n._pushPosition(e, o, u), r.index++
				})
			},
			_cellsByRowGetContainerSize: function () {
				return {
					height: Math.ceil(this.$filteredAtoms.length / this.cellsByRow.cols) * this.cellsByRow.rowHeight + this.offset.top
				}
			},
			_cellsByRowResizeChanged: function () {
				return this._checkIfSegmentsChanged()
			},
			_straightDownReset: function () {
				this.straightDown = {
					y: 0
				}
			},
			_straightDownLayout: function (e) {
				var n = this;
				e.each(function (e) {
					var r = t(this);
					n._pushPosition(r, 0, n.straightDown.y), n.straightDown.y += r.outerHeight(!0)
				})
			},
			_straightDownGetContainerSize: function () {
				return {
					height: this.straightDown.y
				}
			},
			_straightDownResizeChanged: function () {
				return !0
			},
			_masonryHorizontalReset: function () {
				this.masonryHorizontal = {}, this._getSegments(!0);
				var e = this.masonryHorizontal.rows;
				this.masonryHorizontal.rowXs = [];
				while (e--) this.masonryHorizontal.rowXs.push(0)
			},
			_masonryHorizontalLayout: function (e) {
				var n = this,
					r = n.masonryHorizontal;
				e.each(function () {
					var e = t(this),
						i = Math.ceil(e.outerHeight(!0) / r.rowHeight);
					i = Math.min(i, r.rows);
					if (i === 1) n._masonryHorizontalPlaceBrick(e, r.rowXs);
					else {
						var s = r.rows + 1 - i,
							o = [],
							u, a;
						for (a = 0; a < s; a++) u = r.rowXs.slice(a, a + i), o[a] = Math.max.apply(Math, u);
						n._masonryHorizontalPlaceBrick(e, o)
					}
				})
			},
			_masonryHorizontalPlaceBrick: function (e, t) {
				var n = Math.min.apply(Math, t),
					r = 0;
				for (var i = 0, s = t.length; i < s; i++)
					if (t[i] === n) {
						r = i;
						break
					}
				var o = n,
					u = this.masonryHorizontal.rowHeight * r;
				this._pushPosition(e, o, u);
				var a = n + e.outerWidth(!0),
					f = this.masonryHorizontal.rows + 1 - s;
				for (i = 0; i < f; i++) this.masonryHorizontal.rowXs[r + i] = a
			},
			_masonryHorizontalGetContainerSize: function () {
				var e = Math.max.apply(Math, this.masonryHorizontal.rowXs);
				return {
					width: e
				}
			},
			_masonryHorizontalResizeChanged: function () {
				return this._checkIfSegmentsChanged(!0)
			},
			_fitColumnsReset: function () {
				this.fitColumns = {
					x: 0,
					y: 0,
					width: 0
				}
			},
			_fitColumnsLayout: function (e) {
				var n = this,
					r = this.element.height(),
					i = this.fitColumns;
				e.each(function () {
					var e = t(this),
						s = e.outerWidth(!0),
						o = e.outerHeight(!0);
					i.y !== 0 && o + i.y > r && (i.x = i.width, i.y = 0), n._pushPosition(e, i.x, i.y), i.width = Math.max(i.x + s, i.width), i.y += o
				})
			},
			_fitColumnsGetContainerSize: function () {
				return {
					width: this.fitColumns.width
				}
			},
			_fitColumnsResizeChanged: function () {
				return !0
			},
			_cellsByColumnReset: function () {
				this.cellsByColumn = {
					index: 0
				}, this._getSegments(), this._getSegments(!0)
			},
			_cellsByColumnLayout: function (e) {
				var n = this,
					r = this.cellsByColumn;
				e.each(function () {
					var e = t(this),
						i = Math.floor(r.index / r.rows),
						s = r.index % r.rows,
						o = (i + .5) * r.columnWidth - e.outerWidth(!0) / 2,
						u = (s + .5) * r.rowHeight - e.outerHeight(!0) / 2;
					n._pushPosition(e, o, u), r.index++
				})
			},
			_cellsByColumnGetContainerSize: function () {
				return {
					width: Math.ceil(this.$filteredAtoms.length / this.cellsByColumn.rows) * this.cellsByColumn.columnWidth
				}
			},
			_cellsByColumnResizeChanged: function () {
				return this._checkIfSegmentsChanged(!0)
			},
			_straightAcrossReset: function () {
				this.straightAcross = {
					x: 0
				}
			},
			_straightAcrossLayout: function (e) {
				var n = this;
				e.each(function (e) {
					var r = t(this);
					n._pushPosition(r, n.straightAcross.x, 0), n.straightAcross.x += r.outerWidth(!0)
				})
			},
			_straightAcrossGetContainerSize: function () {
				return {
					width: this.straightAcross.x
				}
			},
			_straightAcrossResizeChanged: function () {
				return !0
			}
		}, t.fn.imagesLoaded = function (e) {
			function u() {
				e.call(n, r)
			}

			function a(e) {
				var n = e.target;
				n.src !== s && t.inArray(n, o) === -1 && (o.push(n), --i <= 0 && (setTimeout(u), r.unbind(".imagesLoaded", a)))
			}
			var n = this,
				r = n.find("img").add(n.filter("img")),
				i = r.length,
				s = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==",
				o = [];
			return i || u(), r.bind("load.imagesLoaded error.imagesLoaded", a).each(function () {
				var e = this.src;
				this.src = s, this.src = e
			}), n
		};
		var x = function (t) {
			e.console && e.console.error(t)
		};
		t.fn.isotope = function (e, n) {
			if (typeof e == "string") {
				var r = Array.prototype.slice.call(arguments, 1);
				this.each(function () {
					var n = t.data(this, "isotope");
					if (!n) {
						x("cannot call methods on isotope prior to initialization; attempted to call method '" + e + "'");
						return
					}
					if (!t.isFunction(n[e]) || e.charAt(0) === "_") {
						x("no such method '" + e + "' for isotope instance");
						return
					}
					n[e].apply(n, r)
				})
			} else this.each(function () {
				var r = t.data(this, "isotope");
				r ? (r.option(e), r._init(n)) : t.data(this, "isotope", new t.Isotope(e, this, n))
			});
			return this
		}
	}(window, jQuery), define("lib/jquery.isotope", function () {}), define("modules/blog", ["jquery", "lib/jquery.isotope"], function (e) {
		e(function () {
			if (e("#squares").length) {
				window.onpopstate = function (t) {
					e(".blog-menu a[data-filter='" + t.state.filter + "']").trigger("click")
				};
				var t = "*";
				e(".blog-menu a").click(function (t) {
					t.preventDefault();
					var n = e(".showmore"),
						r = e("#breadcrumb");
					r.find("span").remove();
					var i = e(".blog-menu a:first-child");
					e(this).data("url") !== i.data("url") && r.append('<span><a href="' + i.data("url") + '" class="bread__item" title="' + i.data("title") + '">' + i.data("title") + "</a></span>"), r.append('<span><a href="' + e(this).data("url") + '" class="bread__item" title="' + e(this).data("title") + '">' + e(this).data("title") + "</a></span>"), window.history.pushState({
						url: e(this).data("url"),
						title: e(this).data("title"),
						filter: e(this).data("filter")
					}, e(this).data("title"), e(this).data("url"));
					var s = e("#breadcrumb + h1");
					return s.text(e(this).data("title")), e("title").text(e(this).data("title")), e(this).hasClass("active") || (e(".blog-menu .active").removeClass("active"), e(this).addClass("active"), url = e(this).data("url"), e.ajax({
						url: url,
						cache: !1,
						type: "POST",
						data: $('form[name="' + target + '-nav"]').serialize(), dataType: 'html',
						success: function (t) {
							setTimeout(function () {
								n.removeClass("loading"), e("#squares").html(e(t)), n.remove();
								var r = e(".shownore-new-block").find(".showmore");
								r.insertAfter("#squares"), e(".shownore-new-block").remove(), initShowMore(), e("#squares").isotope("reloadItems").isotope()
							}, 150)
						}
					})), !1
				}), e(window).on("resize orientationchange", function () {
					setTimeout(function () {
						e("#squares").isotope({
							itemSelector: '.blog-item'
						})
					}, 100)
				}).resize();
				var n = e(".shownore-new-block").find(".showmore");
				n.insertAfter("#squares"), e(".shownore-new-block").remove(), initShowMore()
			}
		})
	}), define("modules/about", ["jquery", "../lib/jquery.matchHeight"], function (e) {
		e(function () {
			e(".history__card-content").matchHeight(), e(window).on("resize orientationchange", function () {
				setTimeout(function () {
					h = e(".history__card-content").height(), w = e(window).width(), w > 1023 ? hh = h + 120 : w > 767 ? hh = (h + 60) * 2 + 360 + 60 : w > 550 ? hh = (h + 60) * 2 + 240 + 120 : w > 380 ? hh = (h + 60) * 2 + 240 + 240 : hh = (h + 60) * 2 + 240 + 340, e(".about_history").css("marginBottom", hh)
				}, 100)
			})
		})
	}), define("modules/campuses", ["jquery", "../lib/jquery.matchHeight"], function (e) {
		function r(n, r, s) {
			var o = [{
					stylers: [{
						saturation: -30
					}, {
						gamma: .72
					}]
				}],
				u = new google.maps.LatLng(n, r),
				a = {
					zoom: s,
					scrollwheel: !1,
					center: u,
					draggable: !0,
					zoomControl: !0,
					scaleControl: !0,
					mapTypeControl: !1,
					fullScreenControl: !1,
					streetViewControl: !0,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					styles: o
				},
				f = "/i/loc_small.svg",
				l = new google.maps.MarkerImage(f, new google.maps.Size(40, 50)),
				c = [];
			t = new google.maps.Map(document.getElementById("allcampuses"), a);
			var h = new google.maps.LatLngBounds;
			i = 0, e(".campuses-map__item").each(function (n) {
				ci = e(this), lat = ci.data("lat"), lng = ci.data("lng");
				if (typeof ci.data("lat") != "undefined") {
					var r = new google.maps.Marker({
							position: new google.maps.LatLng(lat, lng),
							map: t,
							optimized: !1,
							icon: {
								path: "M27,12.19A13.35,13.35,0,0,0,13.5,0,13.35,13.35,0,0,0,0,12.19a11.47,11.47,0,0,0,.82,5.18,13.71,13.71,0,0,0,3,4.58l8.79,9.68a1.09,1.09,0,0,0,1.63,0L23.11,22a14.13,14.13,0,0,0,3-4.58A12.08,12.08,0,0,0,27,12.19Zm-13.47,4a4.13,4.13,0,0,1-4.16-4.05,4.16,4.16,0,0,1,8.32,0A4.13,4.13,0,0,1,13.5,16.2Z",
								fillColor: "#bd3739",
								fillOpacity: 1,
								scale: 1,
								strokeColor: "#bd3739"
							}
						}),
						s = new google.maps.LatLng(lat, lng);
					c[i] = r, i++
				}
			}), c.length > 1
		}

		function s() {
			n.getAnimation() !== null ? n.setAnimation(null) : n.setAnimation(google.maps.Animation.BOUNCE)
		}
		var t, n;
		e(function () {
			var n = e("#allcampuses");
			n.length && (n.hasClass("loaded") || (n.addClass("loaded"), lat = n.data("lat"), lng = n.data("lng"), zoom = n.data("zoom"), e(".campuses-map__item").matchHeight(), e(".campus-item h6").matchHeight(), r(lat, lng, zoom)), e(".campuses-map__item").on("click touchstart", function (n) {
				n.preventDefault(), ii = e(this), a = ii.data("lat"), b = ii.data("lng");
				if (typeof ii.data("lat") != "undefined") {
					var r = new google.maps.LatLng(a, b);
					t.panTo(r), t.setZoom(10)
				}
			}))
		})
	}),
	function (e) {
		e.extend(e, {
			cacheImage: function (t, n) {
				if (typeof t == "object") {
					e.each(t, function () {
						e.cacheImage(String(this), n)
					});
					return
				}
				var r = new Image;
				return n = n || {}, e.each(["load", "error", "abort"], function () {
					var t = String(this);
					typeof n[t] == "function" && e(r).bind(t, n[t]), typeof n.complete == "function" && e(r).bind(t, n.complete)
				}), r.src = t, r
			}
		}), e.extend(e.fn, {
			cacheImage: function (t) {
				return this.each(function () {
					e.cacheImage(this.src, t)
				})
			}
		})
	}(jQuery), define("lib/jquery.cacheimage", function () {}), define("modules/preloader", ["jquery", "../lib/jquery.cacheimage"], function (e) {
		e(function () {
			function n() {
				e(".loader__bar").css({
					width: "100%"
				}, 100), setTimeout(function () {
					e(".loader").addClass("finished"), e("body").addClass("loaded")
				}, 100)
			}
			var t = [];
			e(".preload__image").each(function () {
				var n = new Image;
				n.src = e(this).attr("src") || e(this).css("background-image").replace(/.*\s?url\(['"]?|['"]?\)?$|^none$/g, ""), n.complete || t.push(n.src)
			});
			if (!t.length) {
				n();
				return
			}
			window.images = t.length, window.loadingProgress = 0, e.cacheImage(t, {
				complete: function () {
					window.loadingProgress++, window.loadingProgress >= window.images && n();
					var t = 100 * (window.loadingProgress / window.images);
					e(".loader__bar").css({
						width: t + "%"
					})
				}
			})
		})
	}), ! function (e) {
		"function" == typeof define && define.amd ? define("lib/jquery.formstyler.min", ["jquery"], e) : "object" == typeof exports ? module.exports = e($ || require("jquery")) : e(jQuery)
	}(function (e) {
		function t(t, n) {
			this.element = t, this.options = e.extend({}, i, n);
			var r = this.options.locale;
			void 0 !== this.options.locales[r] && e.extend(this.options, this.options.locales[r]), this.init()
		}

		function n(t) {
			if (!e(t.target).parents().hasClass("jq-selectbox") && "OPTION" != t.target.nodeName && e("div.jq-selectbox.opened").length) {
				var n = e("div.jq-selectbox.opened"),
					i = e("div.jq-selectbox__search input", n),
					s = e("div.jq-selectbox__dropdown", n);
				n.find("select").data("_" + r).options.onSelectClosed.call(n), i.length && i.val("").keyup(), s.hide().find("li.sel").addClass("selected"), n.removeClass("focused opened dropup dropdown")
			}
		}
		var r = "styler",
			i = {
				idSuffix: "-styler",
				filePlaceholder: "Файл не выбран",
				fileBrowse: "Обзор...",
				fileNumber: "Выбрано файлов: %s",
				selectPlaceholder: "Выберите...",
				selectSearch: !1,
				selectSearchLimit: 10,
				selectSearchNotFound: "Совпадений не найдено",
				selectSearchPlaceholder: "Поиск...",
				selectVisibleOptions: 0,
				selectSmartPositioning: !0,
				locale: "ru",
				locales: {
					en: {
						filePlaceholder: "No file selected",
						fileBrowse: "Browse...",
						fileNumber: "Selected files: %s",
						selectPlaceholder: "Select...",
						selectSearchNotFound: "No matches found",
						selectSearchPlaceholder: "Search..."
					}
				},
				onSelectOpened: function () {},
				onSelectClosed: function () {},
				onFormStyled: function () {}
			};
		t.prototype = {
			init: function () {
				function t() {
					void 0 !== r.attr("id") && "" !== r.attr("id") && (this.id = r.attr("id") + i.idSuffix), this.title = r.attr("title"), this.classes = r.attr("class"), this.data = r.data()
				}
				var r = e(this.element),
					i = this.options,
					o = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/i) && !navigator.userAgent.match(/(Windows\sPhone)/i),
					u = !!navigator.userAgent.match(/Android/i) && !navigator.userAgent.match(/(Windows\sPhone)/i);
				if (r.is(":checkbox")) {
					var a = function () {
						var n = new t,
							i = e('<div class="jq-checkbox"><div class="jq-checkbox__div"></div></div>').attr({
								id: n.id,
								title: n.title
							}).addClass(n.classes).data(n.data);
						r.after(i).prependTo(i), r.is(":checked") && i.addClass("checked"), r.is(":disabled") && i.addClass("disabled"), i.click(function (e) {
							e.preventDefault(), r.triggerHandler("click"), i.is(".disabled") || (r.is(":checked") ? (r.prop("checked", !1), i.removeClass("checked")) : (r.prop("checked", !0), i.addClass("checked")), r.focus().change())
						}), r.closest("label").add('label[for="' + r.attr("id") + '"]').on("click.styler", function (t) {
							e(t.target).is("a") || e(t.target).closest(i).length || (i.triggerHandler("click"), t.preventDefault())
						}), r.on("change.styler", function () {
							r.is(":checked") ? i.addClass("checked") : i.removeClass("checked")
						}).on("keydown.styler", function (e) {
							32 == e.which && i.click()
						}).on("focus.styler", function () {
							i.is(".disabled") || i.addClass("focused")
						}).on("blur.styler", function () {
							i.removeClass("focused")
						})
					};
					a(), r.on("refresh", function () {
						r.closest("label").add('label[for="' + r.attr("id") + '"]').off(".styler"), r.off(".styler").parent().before(r).remove(), a()
					})
				} else if (r.is(":radio")) {
					var f = function () {
						var n = new t,
							i = e('<div class="jq-radio"><div class="jq-radio__div"></div></div>').attr({
								id: n.id,
								title: n.title
							}).addClass(n.classes).data(n.data);
						r.after(i).prependTo(i), r.is(":checked") && i.addClass("checked"), r.is(":disabled") && i.addClass("disabled"), e.fn.commonParents = function () {
							var t = this;
							return t.first().parents().filter(function () {
								return e(this).find(t).length === t.length
							})
						}, e.fn.commonParent = function () {
							return e(this).commonParents().first()
						}, i.click(function (t) {
							if (t.preventDefault(), r.triggerHandler("click"), !i.is(".disabled")) {
								var n = e('input[name="' + r.attr("name") + '"]');
								n.commonParent().find(n).prop("checked", !1).parent().removeClass("checked"), r.prop("checked", !0).parent().addClass("checked"), r.focus().change()
							}
						}), r.closest("label").add('label[for="' + r.attr("id") + '"]').on("click.styler", function (t) {
							e(t.target).is("a") || e(t.target).closest(i).length || (i.triggerHandler("click"), t.preventDefault())
						}), r.on("change.styler", function () {
							r.parent().addClass("checked")
						}).on("focus.styler", function () {
							i.is(".disabled") || i.addClass("focused")
						}).on("blur.styler", function () {
							i.removeClass("focused")
						})
					};
					f(), r.on("refresh", function () {
						r.closest("label").add('label[for="' + r.attr("id") + '"]').off(".styler"), r.off(".styler").parent().before(r).remove(), f()
					})
				} else if (r.is(":file")) {
					var l = function () {
						var n = new t,
							s = r.data("placeholder");
						void 0 === s && (s = i.filePlaceholder);
						var o = r.data("browse");
						void 0 !== o && "" !== o || (o = i.fileBrowse);
						var u = e('<div class="jq-file"><div class="jq-file__name">' + s + '</div><div class="jq-file__browse">' + o + "</div></div>").attr({
							id: n.id,
							title: n.title
						}).addClass(n.classes).data(n.data);
						r.after(u).appendTo(u), r.is(":disabled") && u.addClass("disabled");
						var a = r.val(),
							f = e("div.jq-file__name", u);
						a && f.text(a.replace(/.+[\\\/]/, "")), r.on("change.styler", function () {
							var e = r.val();
							if (r.is("[multiple]")) {
								e = "";
								var t = r[0].files.length;
								if (t > 0) {
									var n = r.data("number");
									void 0 === n && (n = i.fileNumber), n = n.replace("%s", t), e = n
								}
							}
							f.text(e.replace(/.+[\\\/]/, "")), "" === e ? (f.text(s), u.removeClass("changed")) : u.addClass("changed")
						}).on("focus.styler", function () {
							u.addClass("focused")
						}).on("blur.styler", function () {
							u.removeClass("focused")
						}).on("click.styler", function () {
							u.removeClass("focused")
						})
					};
					l(), r.on("refresh", function () {
						r.off(".styler").parent().before(r).remove(), l()
					})
				} else if (r.is('input[type="number"]')) {
					var c = function () {
						var n = new t,
							i = e('<div class="jq-number"><div class="jq-number__spin minus"></div><div class="jq-number__spin plus"></div></div>').attr({
								id: n.id,
								title: n.title
							}).addClass(n.classes).data(n.data);
						r.after(i).prependTo(i).wrap('<div class="jq-number__field"></div>'), r.is(":disabled") && i.addClass("disabled");
						var s, o, u, a = null,
							f = null;
						void 0 !== r.attr("min") && (s = r.attr("min")), void 0 !== r.attr("max") && (o = r.attr("max")), u = void 0 !== r.attr("step") && e.isNumeric(r.attr("step")) ? Number(r.attr("step")) : Number(1);
						var l = function (t) {
							var n, i = r.val();
							e.isNumeric(i) || (i = 0, r.val("0")), t.is(".minus") ? n = Number(i) - u : t.is(".plus") && (n = Number(i) + u);
							var a = (u.toString().split(".")[1] || []).length;
							if (a > 0) {
								for (var f = "1"; f.length <= a;) f += "0";
								n = Math.round(n * f) / f
							}
							e.isNumeric(s) && e.isNumeric(o) ? n >= s && n <= o && r.val(n) : e.isNumeric(s) && !e.isNumeric(o) ? n >= s && r.val(n) : !e.isNumeric(s) && e.isNumeric(o) ? n <= o && r.val(n) : r.val(n)
						};
						i.is(".disabled") || (i.on("mousedown", "div.jq-number__spin", function () {
							var t = e(this);
							l(t), a = setTimeout(function () {
								f = setInterval(function () {
									l(t)
								}, 40)
							}, 350)
						}).on("mouseup mouseout", "div.jq-number__spin", function () {
							clearTimeout(a), clearInterval(f)
						}).on("mouseup", "div.jq-number__spin", function () {
							r.change().trigger("input")
						}), r.on("focus.styler", function () {
							i.addClass("focused")
						}).on("blur.styler", function () {
							i.removeClass("focused")
						}))
					};
					c(), r.on("refresh", function () {
						r.off(".styler").closest(".jq-number").before(r).remove(), c()
					})
				} else if (r.is("select")) {
					var h = function () {
						function a(e) {
							var t = e.prop("scrollHeight") - e.outerHeight(),
								n = null,
								r = null;
							e.off("mousewheel DOMMouseScroll").on("mousewheel DOMMouseScroll", function (i) {
								n = i.originalEvent.detail < 0 || i.originalEvent.wheelDelta > 0 ? 1 : -1, ((r = e.scrollTop()) >= t && n < 0 || r <= 0 && n > 0) && (i.stopPropagation(), i.preventDefault())
							})
						}

						function f() {
							for (var e = 0; e < l.length; e++) {
								var t = l.eq(e),
									n = "",
									r = "",
									s = "",
									o = "",
									u = "",
									a = "",
									f = "",
									h = "",
									p = "";
								t.prop("selected") && (r = "selected sel"), t.is(":disabled") && (r = "disabled"), t.is(":selected:disabled") && (r = "selected sel disabled"), void 0 !== t.attr("id") && "" !== t.attr("id") && (o = ' id="' + t.attr("id") + i.idSuffix + '"'), void 0 !== t.attr("title") && "" !== l.attr("title") && (u = ' title="' + t.attr("title") + '"'), void 0 !== t.attr("class") && (f = " " + t.attr("class"), p = ' data-jqfs-class="' + t.attr("class") + '"');
								var d = t.data();
								for (var v in d) "" !== d[v] && (a += " data-" + v + '="' + d[v] + '"');
								r + f !== "" && (s = ' class="' + r + f + '"'), n = "<li" + p + a + s + u + o + ">" + t.html() + "</li>", t.parent().is("optgroup") && (void 0 !== t.parent().attr("class") && (h = " " + t.parent().attr("class")), n = "<li" + p + a + ' class="' + r + f + " option" + h + '"' + u + o + ">" + t.html() + "</li>", t.is(":first-child") && (n = '<li class="optgroup' + h + '">' + t.parent().attr("label") + "</li>" + n)), c += n
							}
						}
						var l = e("option", r),
							c = "";
						if (r.is("[multiple]")) {
							if (u || o) return;
							! function () {
								var n = new t,
									i = e('<div class="jq-select-multiple jqselect"></div>').attr({
										id: n.id,
										title: n.title
									}).addClass(n.classes).data(n.data);
								r.after(i), f(), i.append("<ul>" + c + "</ul>");
								var s = e("ul", i),
									o = e("li", i),
									u = r.attr("size"),
									h = s.outerHeight(),
									p = o.outerHeight();
								void 0 !== u && u > 0 ? s.css({
									height: p * u
								}) : s.css({
									height: 4 * p
								}), h > i.height() && (s.css("overflowY", "scroll"), a(s), o.filter(".selected").length && s.scrollTop(s.scrollTop() + o.filter(".selected").position().top)), r.prependTo(i), r.is(":disabled") ? (i.addClass("disabled"), l.each(function () {
									e(this).is(":selected") && o.eq(e(this).index()).addClass("selected")
								})) : (o.filter(":not(.disabled):not(.optgroup)").click(function (t) {
									r.focus();
									var n = e(this);
									if (t.ctrlKey || t.metaKey || n.addClass("selected"), t.shiftKey || n.addClass("first"), t.ctrlKey || t.metaKey || t.shiftKey || n.siblings().removeClass("selected first"), (t.ctrlKey || t.metaKey) && (n.is(".selected") ? n.removeClass("selected first") : n.addClass("selected first"), n.siblings().removeClass("first")), t.shiftKey) {
										var i = !1,
											s = !1;
										n.siblings().removeClass("selected").siblings(".first").addClass("selected"), n.prevAll().each(function () {
											e(this).is(".first") && (i = !0)
										}), n.nextAll().each(function () {
											e(this).is(".first") && (s = !0)
										}), i && n.prevAll().each(function () {
											if (e(this).is(".selected")) return !1;
											e(this).not(".disabled, .optgroup").addClass("selected")
										}), s && n.nextAll().each(function () {
											if (e(this).is(".selected")) return !1;
											e(this).not(".disabled, .optgroup").addClass("selected")
										}), 1 == o.filter(".selected").length && n.addClass("first")
									}
									l.prop("selected", !1), o.filter(".selected").each(function () {
										var t = e(this),
											n = t.index();
										t.is(".option") && (n -= t.prevAll(".optgroup").length), l.eq(n).prop("selected", !0)
									}), r.change()
								}), l.each(function (t) {
									e(this).data("optionIndex", t)
								}), r.on("change.styler", function () {
									o.removeClass("selected");
									var t = [];
									l.filter(":selected").each(function () {
										t.push(e(this).data("optionIndex"))
									}), o.not(".optgroup").filter(function (n) {
										return e.inArray(n, t) > -1
									}).addClass("selected")
								}).on("focus.styler", function () {
									i.addClass("focused")
								}).on("blur.styler", function () {
									i.removeClass("focused")
								}), h > i.height() && r.on("keydown.styler", function (e) {
									38 != e.which && 37 != e.which && 33 != e.which || s.scrollTop(s.scrollTop() + o.filter(".selected").position().top - p), 40 != e.which && 39 != e.which && 34 != e.which || s.scrollTop(s.scrollTop() + o.filter(".selected:last").position().top - s.innerHeight() + 2 * p)
								}))
							}()
						} else ! function () {
							var u = new t,
								h = "",
								p = r.data("placeholder"),
								v = r.data("search"),
								m = r.data("search-limit"),
								g = r.data("search-not-found"),
								y = r.data("search-placeholder"),
								b = r.data("smart-positioning");
							void 0 === p && (p = i.selectPlaceholder), void 0 !== v && "" !== v || (v = i.selectSearch), void 0 !== m && "" !== m || (m = i.selectSearchLimit), void 0 !== g && "" !== g || (g = i.selectSearchNotFound), void 0 === y && (y = i.selectSearchPlaceholder), void 0 !== b && "" !== b || (b = i.selectSmartPositioning);
							var w = e('<div class="jq-selectbox jqselect"><div class="jq-selectbox__select"><div class="jq-selectbox__select-text"></div><div class="jq-selectbox__trigger"><div class="jq-selectbox__trigger-arrow"></div></div></div></div>').attr({
								id: u.id,
								title: u.title
							}).addClass(u.classes).data(u.data);
							r.after(w).prependTo(w);
							var E = w.css("z-index");
							E = E > 0 ? E : 1;
							var S = e("div.jq-selectbox__select", w),
								x = e("div.jq-selectbox__select-text", w),
								T = l.filter(":selected");
							f(), v && (h = '<div class="jq-selectbox__search"><input type="search" autocomplete="off" placeholder="' + y + '"></div><div class="jq-selectbox__not-found">' + g + "</div>");
							var N = e('<div class="jq-selectbox__dropdown">' + h + "<ul>" + c + "</ul></div>");
							w.append(N);
							var C = e("ul", N),
								k = e("li", N),
								L = e("input", N),
								A = e("div.jq-selectbox__not-found", N).hide();
							k.length < m && L.parent().hide(), "" === l.first().text() && l.first().is(":selected") && !1 !== p ? x.text(p).addClass("placeholder") : x.text(T.text());
							var O = 0,
								M = 0;
							if (k.css({
									display: "inline-block"
								}), k.each(function () {
									var t = e(this);
									t.innerWidth() > O && (O = t.innerWidth(), M = t.width())
								}), k.css({
									display: ""
								}), x.is(".placeholder") && x.width() > O) x.width(x.width());
							else {
								var _ = w.clone().appendTo("body").width("auto"),
									D = _.outerWidth();
								_.remove(), D == w.outerWidth() && x.width(M)
							}
							O > w.width() && N.width(O), "" === l.first().text() && "" !== r.data("placeholder") && k.first().hide();
							var P = w.outerHeight(!0),
								H = L.parent().outerHeight(!0) || 0,
								B = C.css("max-height"),
								j = k.filter(".selected");
							if (j.length < 1 && k.first().addClass("selected sel"), void 0 === k.data("li-height")) {
								var F = k.outerHeight();
								!1 !== p && (F = k.eq(1).outerHeight()), k.data("li-height", F)
							}
							var I = N.css("top");
							if ("auto" == N.css("left") && N.css({
									left: 0
								}), "auto" == N.css("top") && (N.css({
									top: P
								}), I = P), N.hide(), j.length && (l.first().text() != T.text() && w.addClass("changed"), w.data("jqfs-class", j.data("jqfs-class")), w.addClass(j.data("jqfs-class"))), r.is(":disabled")) return w.addClass("disabled"), !1;
							S.click(function () {
								if (e("div.jq-selectbox").filter(".opened").length && i.onSelectClosed.call(e("div.jq-selectbox").filter(".opened")), r.focus(), !o) {
									var t = e(window),
										n = k.data("li-height"),
										s = w.offset().top,
										u = t.height() - P - (s - t.scrollTop()),
										f = r.data("visible-options");
									void 0 !== f && "" !== f || (f = i.selectVisibleOptions);
									var c = 5 * n,
										h = n * f;
									f > 0 && f < 6 && (c = h), 0 === f && (h = "auto");
									var p = function () {
										N.height("auto").css({
											bottom: "auto",
											top: I
										});
										var e = function () {
											C.css("max-height", Math.floor((u - 20 - H) / n) * n)
										};
										e(), C.css("max-height", h), "none" != B && C.css("max-height", B), u < N.outerHeight() + 20 && e()
									};
									!0 === b || 1 === b ? u > c + H + 20 ? (p(), w.removeClass("dropup").addClass("dropdown")) : (function () {
										N.height("auto").css({
											top: "auto",
											bottom: I
										});
										var e = function () {
											C.css("max-height", Math.floor((s - t.scrollTop() - 20 - H) / n) * n)
										};
										e(), C.css("max-height", h), "none" != B && C.css("max-height", B), s - t.scrollTop() - 20 < N.outerHeight() + 20 && e()
									}(), w.removeClass("dropdown").addClass("dropup")) : !1 === b || 0 === b ? u > c + H + 20 && (p(), w.removeClass("dropup").addClass("dropdown")) : (N.height("auto").css({
										bottom: "auto",
										top: I
									}), C.css("max-height", h), "none" != B && C.css("max-height", B)), w.offset().left + N.outerWidth() > t.width() && N.css({
										left: "auto",
										right: 0
									}), e("div.jqselect").css({
										zIndex: E - 1
									}).removeClass("opened"), w.css({
										zIndex: E
									}), N.is(":hidden") ? (e("div.jq-selectbox__dropdown:visible").hide(), N.show(), w.addClass("opened focused"), i.onSelectOpened.call(w)) : (N.hide(), w.removeClass("opened dropup dropdown"), e("div.jq-selectbox").filter(".opened").length && i.onSelectClosed.call(w)), L.length && (L.val("").keyup(), A.hide(), L.keyup(function () {
										var t = e(this).val();
										k.each(function () {
											e(this).html().match(new RegExp(".*?" + t + ".*?", "i")) ? e(this).show() : e(this).hide()
										}), "" === l.first().text() && "" !== r.data("placeholder") && k.first().hide(), k.filter(":visible").length < 1 ? A.show() : A.hide()
									})), k.filter(".selected").length && ("" === r.val() ? C.scrollTop(0) : (C.innerHeight() / n % 2 != 0 && (n /= 2), C.scrollTop(C.scrollTop() + k.filter(".selected").position().top - C.innerHeight() / 2 + n))), a(C)
								}
							}), k.hover(function () {
								e(this).siblings().removeClass("selected")
							});
							var q = k.filter(".selected").text();
							k.filter(":not(.disabled):not(.optgroup)").click(function () {
								r.focus();
								var t = e(this),
									n = t.text();
								if (!t.is(".selected")) {
									var s = t.index();
									s -= t.prevAll(".optgroup").length, t.addClass("selected sel").siblings().removeClass("selected sel"), l.prop("selected", !1).eq(s).prop("selected", !0), q = n, x.text(n), w.data("jqfs-class") && w.removeClass(w.data("jqfs-class")), w.data("jqfs-class", t.data("jqfs-class")), w.addClass(t.data("jqfs-class")), r.change()
								}
								N.hide(), w.removeClass("opened dropup dropdown"), i.onSelectClosed.call(w)
							}), N.mouseout(function () {
								e("li.sel", N).addClass("selected")
							}), r.on("change.styler", function () {
								x.text(l.filter(":selected").text()).removeClass("placeholder"), k.removeClass("selected sel").not(".optgroup").eq(r[0].selectedIndex).addClass("selected sel"), l.first().text() != k.filter(".selected").text() ? w.addClass("changed") : w.removeClass("changed")
							}).on("focus.styler", function () {
								w.addClass("focused"), e("div.jqselect").not(".focused").removeClass("opened dropup dropdown").find("div.jq-selectbox__dropdown").hide()
							}).on("blur.styler", function () {
								w.removeClass("focused")
							}).on("keydown.styler keyup.styler", function (e) {
								var t = k.data("li-height");
								"" === r.val() ? x.text(p).addClass("placeholder") : x.text(l.filter(":selected").text()), k.removeClass("selected sel").not(".optgroup").eq(r[0].selectedIndex).addClass("selected sel"), 38 != e.which && 37 != e.which && 33 != e.which && 36 != e.which || ("" === r.val() ? C.scrollTop(0) : C.scrollTop(C.scrollTop() + k.filter(".selected").position().top)), 40 != e.which && 39 != e.which && 34 != e.which && 35 != e.which || C.scrollTop(C.scrollTop() + k.filter(".selected").position().top - C.innerHeight() + t), 13 == e.which && (e.preventDefault(), N.hide(), w.removeClass("opened dropup dropdown"), i.onSelectClosed.call(w))
							}).on("keydown.styler", function (e) {
								32 == e.which && (e.preventDefault(), S.click())
							}), n.registered || (e(document).on("click", n), n.registered = !0)
						}()
					};
					h(), r.on("refresh", function () {
						r.off(".styler").parent().before(r).remove(), h()
					})
				} else r.is(":reset") && r.on("click", function () {
					setTimeout(function () {
						r.closest("form").find("input, select").trigger("refresh")
					}, 1)
				})
			},
			destroy: function () {
				var t = e(this.element);
				t.is(":checkbox") || t.is(":radio") ? (t.removeData("_" + r).off(".styler refresh").removeAttr("style").parent().before(t).remove(), t.closest("label").add('label[for="' + t.attr("id") + '"]').off(".styler")) : t.is('input[type="number"]') ? t.removeData("_" + r).off(".styler refresh").closest(".jq-number").before(t).remove() : (t.is(":file") || t.is("select")) && t.removeData("_" + r).off(".styler refresh").removeAttr("style").parent().before(t).remove()
			}
		}, e.fn[r] = function (n) {
			var i = arguments;
			if (void 0 === n || "object" == typeof n) return this.each(function () {
				e.data(this, "_" + r) || e.data(this, "_" + r, new t(this, n))
			}).promise().done(function () {
				var t = e(this[0]).data("_" + r);
				t && t.options.onFormStyled.call()
			}), this;
			if ("string" == typeof n && "_" !== n[0] && "init" !== n) {
				var s;
				return this.each(function () {
					var u = e.data(this, "_" + r);
					u instanceof t && "function" == typeof u[n] && (s = u[n].apply(u, Array.prototype.slice.call(i, 1)))
				}), void 0 !== s ? s : this
			}
		}, n.registered = !1
	}), define("modules/form_apply", ["jquery", "../lib/jquery.formstyler.min"], function (e) {
		e(function () {
			function t() {
				var t = 1;
				e("p.age-select-wr").each(function () {
					e(this).find(".count").text(t), e('html[lang="en"]').length && e(this).find(".ending").text(t == 3 ? "rd" : "th"), t++
				})
			}
			e('.tabs-body select, .tabs-body input[type="file"], .tabs-block-title-left > select').styler(), e(".age-select-added.default-lng").on("click", function (n) {
				n.preventDefault();
				var r = e(this),
					i = r.closest("p.age-select-wr").find(".js-age-select-wr-remove");
				r.closest("p.age-select-wr").find("select").styler("destroy");
				var s = r.closest("p.age-select-wr").clone(!0).addClass("clone");
				r.closest("p.age-select-wr").after(s).find("select").styler(), s.find(".afd-field-class_of_child").val("").end().find("select option").eq(1).end().end().find("select").styler(), e("p.age-select-wr.clone").removeClass("clone"), i.addClass("is-active").on("click", function (n) {
					n.preventDefault(), e(this).closest("p.age-select-wr").remove(), t()
				}), t(), r.remove()
			}), e(".age-select-added.ru").on("click", function (n) {
				n.preventDefault();
				var r = e(this),
					i = r.closest("p.age-select-wr").find(".js-age-select-wr-remove");
				r.closest("p.age-select-wr").find("select").styler("destroy");
				var s = r.closest("p.age-select-wr").clone(!0).addClass("clone");
				r.closest("p.age-select-wr").after(s).find("select").styler(), s.find(".afd-field-class_of_child").val("").end().find("select option").eq(1).end().end().find("select").styler(), e("p.age-select-wr.clone").removeClass("clone"), i.addClass("is-active").on("click", function (n) {
					n.preventDefault(), e(this).closest("p.age-select-wr").remove(), t()
				}), t(), r.remove()
			}), e(".child-field-added.default-lng").on("click", function (t) {
				t.preventDefault();
				var n = e(this),
					r = e("fieldset.child-details").length + 1,
					i = r == 3 ? "rd" : r == 2 ? "nd" : "th";
				n.closest("fieldset.child-details").find("select").styler("destroy");
				var s = n.closest("fieldset.child-details").clone(!0).addClass("clone");
				n.closest("fieldset.child-details").after(s), e("fieldset.child-details").find("select").styler(), e("fieldset.child-details.clone").find(".count").text(r), e("fieldset.child-details.clone").find(".ending").text(i), e("fieldset.child-details.clone").removeClass("clone"), n.remove()
			}), e(".child-field-added.ru").on("click", function (t) {
				t.preventDefault();
				var n = e(this),
					r = e("fieldset.child-details").length + 1,
					i = r == 3 ? "-го" : r == 2 ? "-го" : "-го";
				n.closest("fieldset.child-details").find("select").styler("destroy");
				var s = n.closest("fieldset.child-details").clone(!0).addClass("clone");
				n.closest("fieldset.child-details").after(s), e("fieldset.child-details").find("select").styler(), e("fieldset.child-details.clone").find(".count").text(r), e("fieldset.child-details.clone").find(".ending").text(i), e("fieldset.child-details.clone").removeClass("clone"), n.remove()
			}), e(".tabs-block-title-left > a").on("click", function (t) {
				t.preventDefault();
				var n = e(this),
					r = n.attr("href");
				e(".tabs-block-title-left > a").removeClass("active"), n.addClass("active"), n.closest(".tabs-block-wr").find(".tabs-body").removeClass("opened"), n.closest(".tabs-block-wr").find(r).addClass("opened"), setTimeout(function () {
					e(".tabs-block-wr select").trigger("refresh")
				}, 100)
			}), e(".tabs-block-title-left select").on("change", function () {
				var t = e(this),
					n = t.val();
				t.closest(".tabs-block-wr").find(".tabs-body").removeClass("opened"), t.closest(".tabs-block-wr").find(n).addClass("opened"), setTimeout(function () {
					e(".tabs-block-wr select").trigger("refresh")
				}, 100)
			});
			var n = {
				email: function (t) {
					var r = t,
						i = /^.+@.+[.].{2,}$/i;
					r.each(function () {
						var t = e(this);
						!i.test(t.val()) && t.val().length != 0 ? (n.errors = !0, t.removeClass("correct").addClass("error")) : t.removeClass("error").addClass("correct")
					})
				},
				phone: function (t) {
					var r = t,
						i = /^([+]?[0-9\s-\(\)]{3,25})*$/i;
					r.each(function () {
						var t = e(this);
						(!i.test(t.val()) || t.val().length < 7) && t.val().length != 0 ? (n.errors = !0, t.removeClass("correct").addClass("error")) : t.removeClass("error").addClass("correct")
					})
				},
				required: function (t) {
					var r = t;
					r.each(function () {
						var t = e(this);
						t.val().length < 1 ? (n.errors = !0, t.removeClass("correct").addClass("error")) : t.removeClass("error").addClass("correct")
					})
				}
			};
			e(".required").keyup(function () {
				n.required(e(this))
			}), e(".email").keyup(function () {
				n.email(e(this))
			}), e(".phone").keyup(function () {
				n.phone(e(this))
			}), e(".submit-wr button[type=submit]").click(function (t) {
				var r = e("body,html"),
					i = e(this),
					s = i.closest("form");
				n.errors = !1, n.phone(s.find(".phone")), n.email(s.find(".email")), n.required(s.find(".required"));
				if (n.errors != 0) return t.preventDefault(), s.find(".error-form").fadeIn(50), setTimeout(function () {
					s.find(".error-form").fadeOut(200)
				}, 2e3), !1
			})
		})
	}), define("modules/teachers", ["jquery", "../lib/jquery.formstyler.min"], function (e) {
		e(function () {
			function t() {
				window.matchMedia("(min-width:601px)").matches ? e(".teachers-filter-wr .filter-item .filter-item-body").css("display", "") : e(".teachers-filter-wr select").styler()
			}

			function n() {
				e(".about-teacher-block-text-bg, .watermark").each(function () {
					var t = e(this).text().replace(/^\s+|\s+$|\(|\)|8-/gm, "").length,
						n = e(this).width() / t * parseFloat(1.7);
					e(this).css("font-size", n + "px"), e(this).css("opacity", "1")
				})
			}
			e(".teachers-filter-wr select").styler(), e(".filter-item-title").on("click", function (t) {
					t.preventDefault();
					if (window.matchMedia("(min-width:601px)").matches) return !1;
					var n = e(this),
						r = n.closest(".filter-item"),
						i = n.closest(".filter-item").find(".filter-item-body");
					i.slideToggle(400), r.toggleClass("opened")
				}), e(".filter-opened-btn, .filter-title .close-filter").on("click", function (t) {
					t.preventDefault();
					if (window.matchMedia("(min-width:601px)").matches) return !1;
					var n = e(".teachers-filter-wr");
					n.toggleClass("opened"), n.hasClass("opened") ? (e(".main-panel").addClass("zIndexClass"), e(".teachers-filter-wr.opened ul").each(function () {
						var t = e(".sel", e(this));
						t.length && t.index() != 0 && e("li", e(this)).not(".disabled, :first").addClass("sel")
					})) : e(".main-panel").removeClass("zIndexClass")
				}), e(window).on("resize", t).trigger("resize"),
				function () {
					function i() {
						n.not('[value="0"]').attr("disabled", ""), e(".filter-element").removeClass("filterFalse").each(function () {
							var t = e(this),
								n = t.data("options");
							for (var i in n) e.inArray(r[i], n[i]) == -1 && r[i] != 0 && t.addClass("filterFalse")
						}).not(".filterFalse").each(function () {
							var n = e(this).data("options");
							for (var r in n) {
								var i = "";
								e.each(n[r], function (e, t) {
									i += 'option[value="' + t + '"],'
								}), t.filter('[name="' + r + '"]').find(i.replace(/\,$/, "")).removeAttr("disabled")
							}
						})
					}
					var t = e(".teachers-filter-wr select");
					if (!t.length) return;
					var n = t.find("option"),
						r = {};
					t.on("change", function () {
						var t = e(this).attr("name"),
							n = e(this).val();
						r[t] = n, window.matchMedia("(min-width:601px)").matches && i()
					}), window.onhashchange = function () {
						e.each(t, function () {
							var t = e(this),
								n = e(this).attr("name");
							if (typeof n != "undefined" && n) {
								r[n] = 0;
								var i = e(this).find("option");
								i.each(function (n, r) {
									e(this).val().toLowerCase() == window.location.hash.toLowerCase().replace("#", "") && (t.val("0").trigger("change"), t.val(e(this).val()).trigger("change"))
								})
							}
						})
					}, e.each(t, function () {
						var t = e(this),
							n = e(this).attr("name");
						if (typeof n != "undefined" && n) {
							r[n] = 0;
							var i = e(this).find("option");
							i.each(function (n, r) {
								e(this).val().toLowerCase() == location.hash.toLowerCase().replace("#", "") && !e(this).attr("disabled") && t.val(e(this).val()).trigger("change")
							})
						}
					}), i(), e(".filter-btn-wr>a").on("click", function (t) {
						t.preventDefault();
						if (window.matchMedia("(min-width:601px)").matches) return !1;
						var n = e(".teachers-filter-wr");
						n.toggleClass("opened"), i(), e("select").trigger("refresh")
					})
				}(), e(window).on("resize", n).trigger("resize"), e(".play-button.button").on("click", function (t) {
					t.preventDefault(), e(".video-block-wrap").addClass("video-popup"), e(".main-panel").addClass("zIndexClass")
				}), e(document).on("click", function (t) {
					if (e(".video-block-wrap").hasClass("video-popup")) {
						if (e(t.target).closest(".play-button.button, .video-block-popup-in").length) return;
						e(".video-block-wrap").removeClass("video-popup"), e(".main-panel").removeClass("zIndexClass")
					}
				})
		})
	}), define("modules/work-at-cis", ["jquery"], function (e) {
		e(function () {
			var t = e(".tabs-block--work-at-cis");
			if (!t.length) return;
			e(".work-at-cis-accordion-title").on("click", function () {
				e("#form_apply_cv_field_desired_position").val(e(this).data("position-id")).trigger("change");
				var n = e(this).closest(".grid");
				e(".tabs-block--work-at-cis").removeClass("is-hidden"), n.hasClass("is-active") ? (n.removeClass("is-active"), e(".admission__grid").append(t)) : (e(this).closest(".accordion").find(">.grid").removeClass("is-active"), n.addClass("is-active"), n.after(t))
			})
		})
	}), define("modules/campus-page", ["jquery"], function (e) {
		e(function () {
			function n() {
				window.matchMedia("(max-width:620px)").matches ? e(".gallery-block-body").hasClass("slick-initialized") || e(".gallery-block-body").slick({
					dots: !1,
					infinite: !1,
					speed: 300,
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: !0,
					centerPadding: "20px",
					infinite: !0
				}) : e(".gallery-block-body").hasClass("slick-initialized") && e(".gallery-block-body").slick("unslick")
			}
			e("[data-section-bg]").each(function () {
				var t = e(this),
					n = t.data("section-bg");
				n && t.css("background-image", "url(" + n + ")")
			});
			var t = 0;
			e(".feedback-block-btn").on("click", function (n) {
				n.preventDefault(), t = e(window).scrollTop(), e(".feedback-block-popup-wr").toggleClass("opened"), e(".main-panel").addClass("zIndexClass"), e("body").addClass("popup__active")
			}), e(document).on("click", function (n) {
				if (e(".feedback-block-popup-wr").hasClass("opened")) {
					if (e(n.target).closest(".play-button.button, .feedback-block-popup-in, .feedback-block-btn").length) return;
					e(".feedback-block-popup-wr").removeClass("opened"), e(".main-panel").removeClass("zIndexClass"), e("body").removeClass("popup__active"), e("body,html").scrollTop(t)
				}
			}), e(window).on("resize", n).trigger("resize")
		})
	}), ! function (e, t) {
		"function" == typeof define && define.amd ? define("lib/photoswipe.min", t) : "object" == typeof exports ? module.exports = t() : e.PhotoSwipe = t()
	}(this, function () {
		var e = function (e, t, n, r) {
			var i = {
				features: null,
				bind: function (e, t, n, r) {
					var i = (r ? "remove" : "add") + "EventListener";
					t = t.split(" ");
					for (var s = 0; s < t.length; s++) t[s] && e[i](t[s], n, !1)
				},
				isArray: function (e) {
					return e instanceof Array
				},
				createEl: function (e, t) {
					var n = document.createElement(t || "div");
					return e && (n.className = e), n
				},
				getScrollY: function () {
					var e = window.pageYOffset;
					return void 0 !== e ? e : document.documentElement.scrollTop
				},
				unbind: function (e, t, n) {
					i.bind(e, t, n, !0)
				},
				removeClass: function (e, t) {
					var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
					e.className = e.className.replace(n, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
				},
				addClass: function (e, t) {
					i.hasClass(e, t) || (e.className += (e.className ? " " : "") + t)
				},
				hasClass: function (e, t) {
					return e.className && (new RegExp("(^|\\s)" + t + "(\\s|$)")).test(e.className)
				},
				getChildByClass: function (e, t) {
					for (var n = e.firstChild; n;) {
						if (i.hasClass(n, t)) return n;
						n = n.nextSibling
					}
				},
				arraySearch: function (e, t, n) {
					for (var r = e.length; r--;)
						if (e[r][n] === t) return r;
					return -1
				},
				extend: function (e, t, n) {
					for (var r in t)
						if (t.hasOwnProperty(r)) {
							if (n && e.hasOwnProperty(r)) continue;
							e[r] = t[r]
						}
				},
				easing: {
					sine: {
						out: function (e) {
							return Math.sin(e * (Math.PI / 2))
						},
						inOut: function (e) {
							return -(Math.cos(Math.PI * e) - 1) / 2
						}
					},
					cubic: {
						out: function (e) {
							return --e * e * e + 1
						}
					}
				},
				detectFeatures: function () {
					if (i.features) return i.features;
					var e = i.createEl(),
						t = e.style,
						n = "",
						r = {};
					if (r.oldIE = document.all && !document.addEventListener, r.touch = "ontouchstart" in window, window.requestAnimationFrame && (r.raf = window.requestAnimationFrame, r.caf = window.cancelAnimationFrame), r.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled, !r.pointerEvent) {
						var s = navigator.userAgent;
						if (/iP(hone|od)/.test(navigator.platform)) {
							var o = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
							o && o.length > 0 && (o = parseInt(o[1], 10), o >= 1 && o < 8 && (r.isOldIOSPhone = !0))
						}
						var u = s.match(/Android\s([0-9\.]*)/),
							a = u ? u[1] : 0;
						a = parseFloat(a), a >= 1 && (a < 4.4 && (r.isOldAndroid = !0), r.androidVersion = a), r.isMobileOpera = /opera mini|opera mobi/i.test(s)
					}
					for (var f, l, c = ["transform", "perspective", "animationName"], h = ["", "webkit", "Moz", "ms", "O"], p = 0; p < 4; p++) {
						n = h[p];
						for (var d = 0; d < 3; d++) f = c[d], l = n + (n ? f.charAt(0).toUpperCase() + f.slice(1) : f), !r[f] && l in t && (r[f] = l);
						n && !r.raf && (n = n.toLowerCase(), r.raf = window[n + "RequestAnimationFrame"], r.raf && (r.caf = window[n + "CancelAnimationFrame"] || window[n + "CancelRequestAnimationFrame"]))
					}
					if (!r.raf) {
						var v = 0;
						r.raf = function (e) {
							var t = (new Date).getTime(),
								n = Math.max(0, 16 - (t - v)),
								r = window.setTimeout(function () {
									e(t + n)
								}, n);
							return v = t + n, r
						}, r.caf = function (e) {
							clearTimeout(e)
						}
					}
					return r.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, i.features = r, r
				}
			};
			i.detectFeatures(), i.features.oldIE && (i.bind = function (e, t, n, r) {
				t = t.split(" ");
				for (var i, s = (r ? "detach" : "attach") + "Event", o = function () {
						n.handleEvent.call(n)
					}, u = 0; u < t.length; u++)
					if (i = t[u])
						if ("object" == typeof n && n.handleEvent) {
							if (r) {
								if (!n["oldIE" + i]) return !1
							} else n["oldIE" + i] = o;
							e[s]("on" + i, n["oldIE" + i])
						} else e[s]("on" + i, n)
			});
			var s = this,
				o = 25,
				u = 3,
				a = {
					allowPanToNext: !0,
					spacing: .12,
					bgOpacity: 1,
					mouseUsed: !1,
					loop: !0,
					pinchToClose: !0,
					closeOnScroll: !0,
					closeOnVerticalDrag: !0,
					verticalDragRange: .75,
					hideAnimationDuration: 333,
					showAnimationDuration: 333,
					showHideOpacity: !1,
					focus: !0,
					escKey: !0,
					arrowKeys: !0,
					mainScrollEndFriction: .35,
					panEndFriction: .35,
					isClickableElement: function (e) {
						return "A" === e.tagName
					},
					getDoubleTapZoom: function (e, t) {
						return e ? 1 : t.initialZoomLevel < .7 ? 1 : 1.33
					},
					maxSpreadZoom: 1.33,
					modal: !0,
					scaleMode: "fit"
				};
			i.extend(a, r);
			var f, l, c, h, p, d, v, m, g, y, b, w, E, S, x, T, N, C, k, L, A, O, M, _, D, P, H, B, j, F, I, q, R, U, z, W, X, V, $, J, K, Q, G, Y, Z, et, tt, nt, rt, it, st, ot, ut, at, ft, lt, ct, ht = function () {
					return {
						x: 0,
						y: 0
					}
				},
				pt = ht(),
				dt = ht(),
				vt = ht(),
				mt = {},
				gt = 0,
				yt = {},
				bt = ht(),
				wt = 0,
				Et = !0,
				St = [],
				xt = {},
				Tt = !1,
				Nt = function (e, t) {
					i.extend(s, t.publicMethods), St.push(e)
				},
				Ct = function (e) {
					var t = tr();
					return e > t - 1 ? e - t : e < 0 ? t + e : e
				},
				kt = {},
				Lt = function (e, t) {
					return kt[e] || (kt[e] = []), kt[e].push(t)
				},
				At = function (e) {
					var t = kt[e];
					if (t) {
						var n = Array.prototype.slice.call(arguments);
						n.shift();
						for (var r = 0; r < t.length; r++) t[r].apply(s, n)
					}
				},
				Ot = function () {
					return (new Date).getTime()
				},
				Mt = function (e) {
					ft = e, s.bg.style.opacity = e * a.bgOpacity
				},
				_t = function (e, t, n, r, i) {
					(!Tt || i && i !== s.currItem) && (r /= i ? i.fitRatio : s.currItem.fitRatio), e[O] = w + t + "px, " + n + "px" + E + " scale(" + r + ")"
				},
				Dt = function (e) {
					it && (e && (y > s.currItem.fitRatio ? Tt || (pr(s.currItem, !1, !0), Tt = !0) : Tt && (pr(s.currItem), Tt = !1)), _t(it, vt.x, vt.y, y))
				},
				Pt = function (e) {
					e.container && _t(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e)
				},
				Ht = function (e, t) {
					t[O] = w + e + "px, 0px" + E
				},
				Bt = function (e, t) {
					if (!a.loop && t) {
						var n = h + (bt.x * gt - e) / bt.x,
							r = Math.round(e - wn.x);
						(n < 0 && r > 0 || n >= tr() - 1 && r < 0) && (e = wn.x + r * a.mainScrollEndFriction)
					}
					wn.x = e, Ht(e, p)
				},
				jt = function (e, t) {
					var n = En[e] - yt[e];
					return dt[e] + pt[e] + n - n * (t / b)
				},
				Ft = function (e, t) {
					e.x = t.x, e.y = t.y, t.id && (e.id = t.id)
				},
				It = function (e) {
					e.x = Math.round(e.x), e.y = Math.round(e.y)
				},
				qt = null,
				Rt = function () {
					qt && (i.unbind(document, "mousemove", Rt), i.addClass(e, "pswp--has_mouse"), a.mouseUsed = !0, At("mouseUsed")), qt = setTimeout(function () {
						qt = null
					}, 100)
				},
				Ut = function () {
					i.bind(document, "keydown", s), I.transform && i.bind(s.scrollWrap, "click", s), a.mouseUsed || i.bind(document, "mousemove", Rt), i.bind(window, "resize scroll orientationchange", s), At("bindEvents")
				},
				zt = function () {
					i.unbind(window, "resize scroll orientationchange", s), i.unbind(window, "scroll", g.scroll), i.unbind(document, "keydown", s), i.unbind(document, "mousemove", Rt), I.transform && i.unbind(s.scrollWrap, "click", s), $ && i.unbind(window, v, s), clearTimeout(q), At("unbindEvents")
				},
				Wt = function (e, t) {
					var n = fr(s.currItem, mt, e);
					return t && (rt = n), n
				},
				Xt = function (e) {
					return e || (e = s.currItem), e.initialZoomLevel
				},
				Vt = function (e) {
					return e || (e = s.currItem), e.w > 0 ? a.maxSpreadZoom : 1
				},
				$t = function (e, t, n, r) {
					return r === s.currItem.initialZoomLevel ? (n[e] = s.currItem.initialPosition[e], !0) : (n[e] = jt(e, r), n[e] > t.min[e] ? (n[e] = t.min[e], !0) : n[e] < t.max[e] && (n[e] = t.max[e], !0))
				},
				Jt = function () {
					if (O) {
						var t = I.perspective && !_;
						return w = "translate" + (t ? "3d(" : "("), void(E = I.perspective ? ", 0px)" : ")")
					}
					O = "left", i.addClass(e, "pswp--ie"), Ht = function (e, t) {
						t.left = e + "px"
					}, Pt = function (e) {
						var t = e.fitRatio > 1 ? 1 : e.fitRatio,
							n = e.container.style,
							r = t * e.w,
							i = t * e.h;
						n.width = r + "px", n.height = i + "px", n.left = e.initialPosition.x + "px", n.top = e.initialPosition.y + "px"
					}, Dt = function () {
						if (it) {
							var e = it,
								t = s.currItem,
								n = t.fitRatio > 1 ? 1 : t.fitRatio,
								r = n * t.w,
								i = n * t.h;
							e.width = r + "px", e.height = i + "px", e.left = vt.x + "px", e.top = vt.y + "px"
						}
					}
				},
				Kt = function (e) {
					var t = "";
					a.escKey && 27 === e.keyCode ? t = "close" : a.arrowKeys && (37 === e.keyCode ? t = "prev" : 39 === e.keyCode && (t = "next")), t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : e.returnValue = !1, s[t]()))
				},
				Qt = function (e) {
					e && (Q || K || st || X) && (e.preventDefault(), e.stopPropagation())
				},
				Gt = function () {
					s.setScrollOffset(0, i.getScrollY())
				},
				Yt = {},
				Zt = 0,
				en = function (e) {
					Yt[e] && (Yt[e].raf && P(Yt[e].raf), Zt--, delete Yt[e])
				},
				tn = function (e) {
					Yt[e] && en(e), Yt[e] || (Zt++, Yt[e] = {})
				},
				nn = function () {
					for (var e in Yt) Yt.hasOwnProperty(e) && en(e)
				},
				rn = function (e, t, n, r, i, s, o) {
					var u, a = Ot();
					tn(e);
					var f = function () {
						if (Yt[e]) {
							if (u = Ot() - a, u >= r) return en(e), s(n), void(o && o());
							s((n - t) * i(u / r) + t), Yt[e].raf = D(f)
						}
					};
					f()
				},
				sn = {
					shout: At,
					listen: Lt,
					viewportSize: mt,
					options: a,
					isMainScrollAnimating: function () {
						return st
					},
					getZoomLevel: function () {
						return y
					},
					getCurrentIndex: function () {
						return h
					},
					isDragging: function () {
						return $
					},
					isZooming: function () {
						return et
					},
					setScrollOffset: function (e, t) {
						yt.x = e, F = yt.y = t, At("updateScrollOffset", yt)
					},
					applyZoomPan: function (e, t, n, r) {
						vt.x = t, vt.y = n, y = e, Dt(r)
					},
					init: function () {
						if (!f && !l) {
							var n;
							s.framework = i, s.template = e, s.bg = i.getChildByClass(e, "pswp__bg"), H = e.className, f = !0, I = i.detectFeatures(), D = I.raf, P = I.caf, O = I.transform, j = I.oldIE, s.scrollWrap = i.getChildByClass(e, "pswp__scroll-wrap"), s.container = i.getChildByClass(s.scrollWrap, "pswp__container"), p = s.container.style, s.itemHolders = T = [{
								el: s.container.children[0],
								wrap: 0,
								index: -1
							}, {
								el: s.container.children[1],
								wrap: 0,
								index: -1
							}, {
								el: s.container.children[2],
								wrap: 0,
								index: -1
							}], T[0].el.style.display = T[2].el.style.display = "none", Jt(), g = {
								resize: s.updateSize,
								orientationchange: function () {
									clearTimeout(q), q = setTimeout(function () {
										mt.x !== s.scrollWrap.clientWidth && s.updateSize()
									}, 500)
								},
								scroll: Gt,
								keydown: Kt,
								click: Qt
							};
							var r = I.isOldIOSPhone || I.isOldAndroid || I.isMobileOpera;
							for (I.animationName && I.transform && !r || (a.showAnimationDuration = a.hideAnimationDuration = 0), n = 0; n < St.length; n++) s["init" + St[n]]();
							if (t) {
								var o = s.ui = new t(s, i);
								o.init()
							}
							At("firstUpdate"), h = h || a.index || 0, (isNaN(h) || h < 0 || h >= tr()) && (h = 0), s.currItem = er(h), (I.isOldIOSPhone || I.isOldAndroid) && (Et = !1), e.setAttribute("aria-hidden", "false"), a.modal && (Et ? e.style.position = "fixed" : (e.style.position = "absolute", e.style.top = i.getScrollY() + "px")), void 0 === F && (At("initialLayout"), F = B = i.getScrollY());
							var c = "pswp--open ";
							for (a.mainClass && (c += a.mainClass + " "), a.showHideOpacity && (c += "pswp--animate_opacity "), c += _ ? "pswp--touch" : "pswp--notouch", c += I.animationName ? " pswp--css_animation" : "", c += I.svg ? " pswp--svg" : "", i.addClass(e, c), s.updateSize(), d = -1, wt = null, n = 0; n < u; n++) Ht((n + d) * bt.x, T[n].el.style);
							j || i.bind(s.scrollWrap, m, s), Lt("initialZoomInEnd", function () {
								s.setContent(T[0], h - 1), s.setContent(T[2], h + 1), T[0].el.style.display = T[2].el.style.display = "block", a.focus && e.focus(), Ut()
							}), s.setContent(T[1], h), s.updateCurrItem(), At("afterInit"), Et || (S = setInterval(function () {
								Zt || $ || et || y !== s.currItem.initialZoomLevel || s.updateSize()
							}, 1e3)), i.addClass(e, "pswp--visible")
						}
					},
					close: function () {
						f && (f = !1, l = !0, At("close"), zt(), rr(s.currItem, null, !0, s.destroy))
					},
					destroy: function () {
						At("destroy"), Qn && clearTimeout(Qn), e.setAttribute("aria-hidden", "true"), e.className = H, S && clearInterval(S), i.unbind(s.scrollWrap, m, s), i.unbind(window, "scroll", s), Cn(), nn(), kt = null
					},
					panTo: function (e, t, n) {
						n || (e > rt.min.x ? e = rt.min.x : e < rt.max.x && (e = rt.max.x), t > rt.min.y ? t = rt.min.y : t < rt.max.y && (t = rt.max.y)), vt.x = e, vt.y = t, Dt()
					},
					handleEvent: function (e) {
						e = e || window.event, g[e.type] && g[e.type](e)
					},
					goTo: function (e) {
						e = Ct(e);
						var t = e - h;
						wt = t, h = e, s.currItem = er(h), gt -= t, Bt(bt.x * gt), nn(), st = !1, s.updateCurrItem()
					},
					next: function () {
						s.goTo(h + 1)
					},
					prev: function () {
						s.goTo(h - 1)
					},
					updateCurrZoomItem: function (e) {
						if (e && At("beforeChange", 0), T[1].el.children.length) {
							var t = T[1].el.children[0];
							it = i.hasClass(t, "pswp__zoom-wrap") ? t.style : null
						} else it = null;
						rt = s.currItem.bounds, b = y = s.currItem.initialZoomLevel, vt.x = rt.center.x, vt.y = rt.center.y, e && At("afterChange")
					},
					invalidateCurrItems: function () {
						x = !0;
						for (var e = 0; e < u; e++) T[e].item && (T[e].item.needsUpdate = !0)
					},
					updateCurrItem: function (e) {
						if (0 !== wt) {
							var t, n = Math.abs(wt);
							if (!(e && n < 2)) {
								s.currItem = er(h), Tt = !1, At("beforeChange", wt), n >= u && (d += wt + (wt > 0 ? -u : u), n = u);
								for (var r = 0; r < n; r++) wt > 0 ? (t = T.shift(), T[u - 1] = t, d++, Ht((d + 2) * bt.x, t.el.style), s.setContent(t, h - n + r + 1 + 1)) : (t = T.pop(), T.unshift(t), d--, Ht(d * bt.x, t.el.style), s.setContent(t, h + n - r - 1 - 1));
								if (it && 1 === Math.abs(wt)) {
									var i = er(N);
									i.initialZoomLevel !== y && (fr(i, mt), pr(i), Pt(i))
								}
								wt = 0, s.updateCurrZoomItem(), N = h, At("afterChange")
							}
						}
					},
					updateSize: function (t) {
						if (!Et && a.modal) {
							var n = i.getScrollY();
							if (F !== n && (e.style.top = n + "px", F = n), !t && xt.x === window.innerWidth && xt.y === window.innerHeight) return;
							xt.x = window.innerWidth, xt.y = window.innerHeight, e.style.height = xt.y + "px"
						}
						if (mt.x = s.scrollWrap.clientWidth, mt.y = s.scrollWrap.clientHeight, Gt(), bt.x = mt.x + Math.round(mt.x * a.spacing), bt.y = mt.y, Bt(bt.x * gt), At("beforeResize"), void 0 !== d) {
							for (var r, o, f, l = 0; l < u; l++) r = T[l], Ht((l + d) * bt.x, r.el.style), f = h + l - 1, a.loop && tr() > 2 && (f = Ct(f)), o = er(f), o && (x || o.needsUpdate || !o.bounds) ? (s.cleanSlide(o), s.setContent(r, f), 1 === l && (s.currItem = o, s.updateCurrZoomItem(!0)), o.needsUpdate = !1) : r.index === -1 && f >= 0 && s.setContent(r, f), o && o.container && (fr(o, mt), pr(o), Pt(o));
							x = !1
						}
						b = y = s.currItem.initialZoomLevel, rt = s.currItem.bounds, rt && (vt.x = rt.center.x, vt.y = rt.center.y, Dt(!0)), At("resize")
					},
					zoomTo: function (e, t, n, r, s) {
						t && (b = y, En.x = Math.abs(t.x) - vt.x, En.y = Math.abs(t.y) - vt.y, Ft(dt, vt));
						var o = Wt(e, !1),
							u = {};
						$t("x", o, u, e), $t("y", o, u, e);
						var a = y,
							f = {
								x: vt.x,
								y: vt.y
							};
						It(u);
						var l = function (t) {
							1 === t ? (y = e, vt.x = u.x, vt.y = u.y) : (y = (e - a) * t + a, vt.x = (u.x - f.x) * t + f.x, vt.y = (u.y - f.y) * t + f.y), s && s(t), Dt(1 === t)
						};
						n ? rn("customZoomTo", 0, 1, n, r || i.easing.sine.inOut, l) : l(1)
					}
				},
				on = 30,
				un = 10,
				an = {},
				fn = {},
				ln = {},
				cn = {},
				hn = {},
				pn = [],
				dn = {},
				vn = [],
				mn = {},
				gn = 0,
				yn = ht(),
				bn = 0,
				wn = ht(),
				En = ht(),
				Sn = ht(),
				xn = function (e, t) {
					return e.x === t.x && e.y === t.y
				},
				Tn = function (e, t) {
					return Math.abs(e.x - t.x) < o && Math.abs(e.y - t.y) < o
				},
				Nn = function (e, t) {
					return mn.x = Math.abs(e.x - t.x), mn.y = Math.abs(e.y - t.y), Math.sqrt(mn.x * mn.x + mn.y * mn.y)
				},
				Cn = function () {
					G && (P(G), G = null)
				},
				kn = function () {
					$ && (G = D(kn), zn())
				},
				Ln = function () {
					return "fit" !== a.scaleMode || y !== s.currItem.initialZoomLevel
				},
				An = function (e, t) {
					return !!e && e !== document && !(e.getAttribute("class") && e.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (t(e) ? e : An(e.parentNode, t))
				},
				On = {},
				Mn = function (e, t) {
					return On.prevent = !An(e.target, a.isClickableElement), At("preventDragEvent", e, t, On), On.prevent
				},
				_n = function (e, t) {
					return t.x = e.pageX, t.y = e.pageY, t.id = e.identifier, t
				},
				Dn = function (e, t, n) {
					n.x = .5 * (e.x + t.x), n.y = .5 * (e.y + t.y)
				},
				Pn = function (e, t, n) {
					if (e - U > 50) {
						var r = vn.length > 2 ? vn.shift() : {};
						r.x = t, r.y = n, vn.push(r), U = e
					}
				},
				Hn = function () {
					var e = vt.y - s.currItem.initialPosition.y;
					return 1 - Math.abs(e / (mt.y / 2))
				},
				Bn = {},
				jn = {},
				Fn = [],
				In = function (e) {
					for (; Fn.length > 0;) Fn.pop();
					return M ? (ct = 0, pn.forEach(function (e) {
						0 === ct ? Fn[0] = e : 1 === ct && (Fn[1] = e), ct++
					})) : e.type.indexOf("touch") > -1 ? e.touches && e.touches.length > 0 && (Fn[0] = _n(e.touches[0], Bn), e.touches.length > 1 && (Fn[1] = _n(e.touches[1], jn))) : (Bn.x = e.pageX, Bn.y = e.pageY, Bn.id = "", Fn[0] = Bn), Fn
				},
				qn = function (e, t) {
					var n, r, i, o, u = 0,
						f = vt[e] + t[e],
						l = t[e] > 0,
						c = wn.x + t.x,
						h = wn.x - dn.x;
					return n = f > rt.min[e] || f < rt.max[e] ? a.panEndFriction : 1, f = vt[e] + t[e] * n, !a.allowPanToNext && y !== s.currItem.initialZoomLevel || (it ? "h" !== ot || "x" !== e || K || (l ? (f > rt.min[e] && (n = a.panEndFriction, u = rt.min[e] - f, r = rt.min[e] - dt[e]), (r <= 0 || h < 0) && tr() > 1 ? (o = c, h < 0 && c > dn.x && (o = dn.x)) : rt.min.x !== rt.max.x && (i = f)) : (f < rt.max[e] && (n = a.panEndFriction, u = f - rt.max[e], r = dt[e] - rt.max[e]), (r <= 0 || h > 0) && tr() > 1 ? (o = c, h > 0 && c < dn.x && (o = dn.x)) : rt.min.x !== rt.max.x && (i = f))) : o = c, "x" !== e) ? void(st || Y || y > s.currItem.fitRatio && (vt[e] += t[e] * n)) : (void 0 !== o && (Bt(o, !0), Y = o !== dn.x), rt.min.x !== rt.max.x && (void 0 !== i ? vt.x = i : Y || (vt.x += t.x * n)), void 0 !== o)
				},
				Rn = function (e) {
					if (!("mousedown" === e.type && e.button > 0)) {
						if (Zn) return void e.preventDefault();
						if (!V || "mousedown" !== e.type) {
							if (Mn(e, !0) && e.preventDefault(), At("pointerDown"), M) {
								var t = i.arraySearch(pn, e.pointerId, "id");
								t < 0 && (t = pn.length), pn[t] = {
									x: e.pageX,
									y: e.pageY,
									id: e.pointerId
								}
							}
							var n = In(e),
								r = n.length;
							Z = null, nn(), $ && 1 !== r || ($ = ut = !0, i.bind(window, v, s), W = lt = at = X = Y = Q = J = K = !1, ot = null, At("firstTouchStart", n), Ft(dt, vt), pt.x = pt.y = 0, Ft(cn, n[0]), Ft(hn, cn), dn.x = bt.x * gt, vn = [{
								x: cn.x,
								y: cn.y
							}], U = R = Ot(), Wt(y, !0), Cn(), kn()), !et && r > 1 && !st && !Y && (b = y, K = !1, et = J = !0, pt.y = pt.x = 0, Ft(dt, vt), Ft(an, n[0]), Ft(fn, n[1]), Dn(an, fn, Sn), En.x = Math.abs(Sn.x) - vt.x, En.y = Math.abs(Sn.y) - vt.y, tt = nt = Nn(an, fn))
						}
					}
				},
				Un = function (e) {
					if (e.preventDefault(), M) {
						var t = i.arraySearch(pn, e.pointerId, "id");
						if (t > -1) {
							var n = pn[t];
							n.x = e.pageX, n.y = e.pageY
						}
					}
					if ($) {
						var r = In(e);
						if (ot || Q || et) Z = r;
						else if (wn.x !== bt.x * gt) ot = "h";
						else {
							var s = Math.abs(r[0].x - cn.x) - Math.abs(r[0].y - cn.y);
							Math.abs(s) >= un && (ot = s > 0 ? "h" : "v", Z = r)
						}
					}
				},
				zn = function () {
					if (Z) {
						var e = Z.length;
						if (0 !== e)
							if (Ft(an, Z[0]), ln.x = an.x - cn.x, ln.y = an.y - cn.y, et && e > 1) {
								if (cn.x = an.x, cn.y = an.y, !ln.x && !ln.y && xn(Z[1], fn)) return;
								Ft(fn, Z[1]), K || (K = !0, At("zoomGestureStarted"));
								var t = Nn(an, fn),
									n = Jn(t);
								n > s.currItem.initialZoomLevel + s.currItem.initialZoomLevel / 15 && (lt = !0);
								var r = 1,
									i = Xt(),
									o = Vt();
								if (n < i)
									if (a.pinchToClose && !lt && b <= s.currItem.initialZoomLevel) {
										var u = i - n,
											f = 1 - u / (i / 1.2);
										Mt(f), At("onPinchClose", f), at = !0
									} else r = (i - n) / i, r > 1 && (r = 1), n = i - r * (i / 3);
								else n > o && (r = (n - o) / (6 * i), r > 1 && (r = 1), n = o + r * i);
								r < 0 && (r = 0), tt = t, Dn(an, fn, yn), pt.x += yn.x - Sn.x, pt.y += yn.y - Sn.y, Ft(Sn, yn), vt.x = jt("x", n), vt.y = jt("y", n), W = n > y, y = n, Dt()
							} else {
								if (!ot) return;
								if (ut && (ut = !1, Math.abs(ln.x) >= un && (ln.x -= Z[0].x - hn.x), Math.abs(ln.y) >= un && (ln.y -= Z[0].y - hn.y)), cn.x = an.x, cn.y = an.y, 0 === ln.x && 0 === ln.y) return;
								if ("v" === ot && a.closeOnVerticalDrag && !Ln()) {
									pt.y += ln.y, vt.y += ln.y;
									var l = Hn();
									return X = !0, At("onVerticalDrag", l), Mt(l), void Dt()
								}
								Pn(Ot(), an.x, an.y), Q = !0, rt = s.currItem.bounds;
								var c = qn("x", ln);
								c || (qn("y", ln), It(vt), Dt())
							}
					}
				},
				Wn = function (e) {
					if (I.isOldAndroid) {
						if (V && "mouseup" === e.type) return;
						e.type.indexOf("touch") > -1 && (clearTimeout(V), V = setTimeout(function () {
							V = 0
						}, 600))
					}
					At("pointerUp"), Mn(e, !1) && e.preventDefault();
					var t;
					if (M) {
						var n = i.arraySearch(pn, e.pointerId, "id");
						if (n > -1)
							if (t = pn.splice(n, 1)[0], navigator.pointerEnabled) t.type = e.pointerType || "mouse";
							else {
								var r = {
									4: "mouse",
									2: "touch",
									3: "pen"
								};
								t.type = r[e.pointerType], t.type || (t.type = e.pointerType || "mouse")
							}
					}
					var o, u = In(e),
						f = u.length;
					if ("mouseup" === e.type && (f = 0), 2 === f) return Z = null, !0;
					1 === f && Ft(hn, u[0]), 0 !== f || ot || st || (t || ("mouseup" === e.type ? t = {
						x: e.pageX,
						y: e.pageY,
						type: "mouse"
					} : e.changedTouches && e.changedTouches[0] && (t = {
						x: e.changedTouches[0].pageX,
						y: e.changedTouches[0].pageY,
						type: "touch"
					})), At("touchRelease", e, t));
					var l = -1;
					if (0 === f && ($ = !1, i.unbind(window, v, s), Cn(), et ? l = 0 : bn !== -1 && (l = Ot() - bn)), bn = 1 === f ? Ot() : -1, o = l !== -1 && l < 150 ? "zoom" : "swipe", et && f < 2 && (et = !1, 1 === f && (o = "zoomPointerUp"), At("zoomGestureEnded")), Z = null, Q || K || st || X)
						if (nn(), z || (z = Xn()), z.calculateSwipeSpeed("x"), X) {
							var c = Hn();
							if (c < a.verticalDragRange) s.close();
							else {
								var h = vt.y,
									p = ft;
								rn("verticalDrag", 0, 1, 300, i.easing.cubic.out, function (e) {
									vt.y = (s.currItem.initialPosition.y - h) * e + h, Mt((1 - p) * e + p), Dt()
								}), At("onVerticalDrag", 1)
							}
						} else {
							if ((Y || st) && 0 === f) {
								var d = $n(o, z);
								if (d) return;
								o = "zoomPointerUp"
							}
							if (!st) return "swipe" !== o ? void Kn() : void(!Y && y > s.currItem.fitRatio && Vn(z))
						}
				},
				Xn = function () {
					var e, t, n = {
						lastFlickOffset: {},
						lastFlickDist: {},
						lastFlickSpeed: {},
						slowDownRatio: {},
						slowDownRatioReverse: {},
						speedDecelerationRatio: {},
						speedDecelerationRatioAbs: {},
						distanceOffset: {},
						backAnimDestination: {},
						backAnimStarted: {},
						calculateSwipeSpeed: function (r) {
							vn.length > 1 ? (e = Ot() - U + 50, t = vn[vn.length - 2][r]) : (e = Ot() - R, t = hn[r]), n.lastFlickOffset[r] = cn[r] - t, n.lastFlickDist[r] = Math.abs(n.lastFlickOffset[r]), n.lastFlickDist[r] > 20 ? n.lastFlickSpeed[r] = n.lastFlickOffset[r] / e : n.lastFlickSpeed[r] = 0, Math.abs(n.lastFlickSpeed[r]) < .1 && (n.lastFlickSpeed[r] = 0), n.slowDownRatio[r] = .95, n.slowDownRatioReverse[r] = 1 - n.slowDownRatio[r], n.speedDecelerationRatio[r] = 1
						},
						calculateOverBoundsAnimOffset: function (e, t) {
							n.backAnimStarted[e] || (vt[e] > rt.min[e] ? n.backAnimDestination[e] = rt.min[e] : vt[e] < rt.max[e] && (n.backAnimDestination[e] = rt.max[e]), void 0 !== n.backAnimDestination[e] && (n.slowDownRatio[e] = .7, n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e], n.speedDecelerationRatioAbs[e] < .05 && (n.lastFlickSpeed[e] = 0, n.backAnimStarted[e] = !0, rn("bounceZoomPan" + e, vt[e], n.backAnimDestination[e], t || 300, i.easing.sine.out, function (t) {
								vt[e] = t, Dt()
							}))))
						},
						calculateAnimOffset: function (e) {
							n.backAnimStarted[e] || (n.speedDecelerationRatio[e] = n.speedDecelerationRatio[e] * (n.slowDownRatio[e] + n.slowDownRatioReverse[e] - n.slowDownRatioReverse[e] * n.timeDiff / 10), n.speedDecelerationRatioAbs[e] = Math.abs(n.lastFlickSpeed[e] * n.speedDecelerationRatio[e]), n.distanceOffset[e] = n.lastFlickSpeed[e] * n.speedDecelerationRatio[e] * n.timeDiff, vt[e] += n.distanceOffset[e])
						},
						panAnimLoop: function () {
							if (Yt.zoomPan && (Yt.zoomPan.raf = D(n.panAnimLoop), n.now = Ot(), n.timeDiff = n.now - n.lastNow, n.lastNow = n.now, n.calculateAnimOffset("x"), n.calculateAnimOffset("y"), Dt(), n.calculateOverBoundsAnimOffset("x"), n.calculateOverBoundsAnimOffset("y"), n.speedDecelerationRatioAbs.x < .05 && n.speedDecelerationRatioAbs.y < .05)) return vt.x = Math.round(vt.x), vt.y = Math.round(vt.y), Dt(), void en("zoomPan")
						}
					};
					return n
				},
				Vn = function (e) {
					return e.calculateSwipeSpeed("y"), rt = s.currItem.bounds, e.backAnimDestination = {}, e.backAnimStarted = {}, Math.abs(e.lastFlickSpeed.x) <= .05 && Math.abs(e.lastFlickSpeed.y) <= .05 ? (e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0, e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0) : (tn("zoomPan"), e.lastNow = Ot(), void e.panAnimLoop())
				},
				$n = function (e, t) {
					var n;
					st || (gn = h);
					var r;
					if ("swipe" === e) {
						var o = cn.x - hn.x,
							u = t.lastFlickDist.x < 10;
						o > on && (u || t.lastFlickOffset.x > 20) ? r = -1 : o < -on && (u || t.lastFlickOffset.x < -20) && (r = 1)
					}
					var f;
					r && (h += r, h < 0 ? (h = a.loop ? tr() - 1 : 0, f = !0) : h >= tr() && (h = a.loop ? 0 : tr() - 1, f = !0), f && !a.loop || (wt += r, gt -= r, n = !0));
					var l, c = bt.x * gt,
						p = Math.abs(c - wn.x);
					return n || c > wn.x == t.lastFlickSpeed.x > 0 ? (l = Math.abs(t.lastFlickSpeed.x) > 0 ? p / Math.abs(t.lastFlickSpeed.x) : 333, l = Math.min(l, 400), l = Math.max(l, 250)) : l = 333, gn === h && (n = !1), st = !0, At("mainScrollAnimStart"), rn("mainScroll", wn.x, c, l, i.easing.cubic.out, Bt, function () {
						nn(), st = !1, gn = -1, (n || gn !== h) && s.updateCurrItem(), At("mainScrollAnimComplete")
					}), n && s.updateCurrItem(!0), n
				},
				Jn = function (e) {
					return 1 / nt * e * b
				},
				Kn = function () {
					var e = y,
						t = Xt(),
						n = Vt();
					y < t ? e = t : y > n && (e = n);
					var r, o = 1,
						u = ft;
					return at && !W && !lt && y < t ? (s.close(), !0) : (at && (r = function (e) {
						Mt((o - u) * e + u)
					}), s.zoomTo(e, 0, 200, i.easing.cubic.out, r), !0)
				};
			Nt("Gestures", {
				publicMethods: {
					initGestures: function () {
						var e = function (e, t, n, r, i) {
							C = e + t, k = e + n, L = e + r, A = i ? e + i : ""
						};
						M = I.pointerEvent, M && I.touch && (I.touch = !1), M ? navigator.pointerEnabled ? e("pointer", "down", "move", "up", "cancel") : e("MSPointer", "Down", "Move", "Up", "Cancel") : I.touch ? (e("touch", "start", "move", "end", "cancel"), _ = !0) : e("mouse", "down", "move", "up"), v = k + " " + L + " " + A, m = C, M && !_ && (_ = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1), s.likelyTouchDevice = _, g[C] = Rn, g[k] = Un, g[L] = Wn, A && (g[A] = g[L]), I.touch && (m += " mousedown", v += " mousemove mouseup", g.mousedown = g[C], g.mousemove = g[k], g.mouseup = g[L]), _ || (a.allowPanToNext = !1)
					}
				}
			});
			var Qn, Gn, Yn, Zn, er, tr, nr, rr = function (t, n, r, o) {
					Qn && clearTimeout(Qn), Zn = !0, Yn = !0;
					var u;
					t.initialLayout ? (u = t.initialLayout, t.initialLayout = null) : u = a.getThumbBoundsFn && a.getThumbBoundsFn(h);
					var f = r ? a.hideAnimationDuration : a.showAnimationDuration,
						l = function () {
							en("initialZoom"), r ? (s.template.removeAttribute("style"), s.bg.removeAttribute("style")) : (Mt(1), n && (n.style.display = "block"), i.addClass(e, "pswp--animated-in"), At("initialZoom" + (r ? "OutEnd" : "InEnd"))), o && o(), Zn = !1
						};
					if (!f || !u || void 0 === u.x) return At("initialZoom" + (r ? "Out" : "In")), y = t.initialZoomLevel, Ft(vt, t.initialPosition), Dt(), e.style.opacity = r ? 0 : 1, Mt(1), void(f ? setTimeout(function () {
						l()
					}, f) : l());
					var p = function () {
						var n = c,
							o = !s.currItem.src || s.currItem.loadError || a.showHideOpacity;
						t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"), r || (y = u.w / t.w, vt.x = u.x, vt.y = u.y - B, s[o ? "template" : "bg"].style.opacity = .001, Dt()), tn("initialZoom"), r && !n && i.removeClass(e, "pswp--animated-in"), o && (r ? i[(n ? "remove" : "add") + "Class"](e, "pswp--animate_opacity") : setTimeout(function () {
							i.addClass(e, "pswp--animate_opacity")
						}, 30)), Qn = setTimeout(function () {
							if (At("initialZoom" + (r ? "Out" : "In")), r) {
								var s = u.w / t.w,
									a = {
										x: vt.x,
										y: vt.y
									},
									c = y,
									h = ft,
									p = function (t) {
										1 === t ? (y = s, vt.x = u.x, vt.y = u.y - F) : (y = (s - c) * t + c, vt.x = (u.x - a.x) * t + a.x, vt.y = (u.y - F - a.y) * t + a.y), Dt(), o ? e.style.opacity = 1 - t : Mt(h - t * h)
									};
								n ? rn("initialZoom", 0, 1, f, i.easing.cubic.out, p, l) : (p(1), Qn = setTimeout(l, f + 20))
							} else y = t.initialZoomLevel, Ft(vt, t.initialPosition), Dt(), Mt(1), o ? e.style.opacity = 1 : Mt(1), Qn = setTimeout(l, f + 20)
						}, r ? 25 : 90)
					};
					p()
				},
				ir = {},
				sr = [],
				or = {
					index: 0,
					errorMsg: '<div class="pswp__error-msg"><a href="../assets/%url%" target="_blank">The image</a> could not be loaded.</div>',
					forceProgressiveLoading: !1,
					preload: [1, 1],
					getNumItemsFn: function () {
						return Gn.length
					}
				},
				ur = function () {
					return {
						center: {
							x: 0,
							y: 0
						},
						max: {
							x: 0,
							y: 0
						},
						min: {
							x: 0,
							y: 0
						}
					}
				},
				ar = function (e, t, n) {
					var r = e.bounds;
					r.center.x = Math.round((ir.x - t) / 2), r.center.y = Math.round((ir.y - n) / 2) + e.vGap.top, r.max.x = t > ir.x ? Math.round(ir.x - t) : r.center.x, r.max.y = n > ir.y ? Math.round(ir.y - n) + e.vGap.top : r.center.y, r.min.x = t > ir.x ? 0 : r.center.x, r.min.y = n > ir.y ? e.vGap.top : r.center.y
				},
				fr = function (e, t, n) {
					if (e.src && !e.loadError) {
						var r = !n;
						if (r && (e.vGap || (e.vGap = {
								top: 0,
								bottom: 0
							}), At("parseVerticalMargin", e)), ir.x = t.x, ir.y = t.y - e.vGap.top - e.vGap.bottom, r) {
							var i = ir.x / e.w,
								s = ir.y / e.h;
							e.fitRatio = i < s ? i : s;
							var o = a.scaleMode;
							"orig" === o ? n = 1 : "fit" === o && (n = e.fitRatio), n > 1 && (n = 1), e.initialZoomLevel = n, e.bounds || (e.bounds = ur())
						}
						if (!n) return;
						return ar(e, e.w * n, e.h * n), r && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center), e.bounds
					}
					return e.w = e.h = 0, e.initialZoomLevel = e.fitRatio = 1, e.bounds = ur(), e.initialPosition = e.bounds.center, e.bounds
				},
				lr = function (e, t, n, r, i, o) {
					t.loadError || r && (t.imageAppended = !0, pr(t, r, t === s.currItem && Tt), n.appendChild(r), o && setTimeout(function () {
						t && t.loaded && t.placeholder && (t.placeholder.style.display = "none", t.placeholder = null)
					}, 500))
				},
				cr = function (e) {
					e.loading = !0, e.loaded = !1;
					var t = e.img = i.createEl("pswp__img", "img"),
						n = function () {
							e.loading = !1, e.loaded = !0, e.loadComplete ? e.loadComplete(e) : e.img = null, t.onload = t.onerror = null, t = null
						};
					return t.onload = n, t.onerror = function () {
						e.loadError = !0, n()
					}, t.src = e.src, t
				},
				hr = function (e, t) {
					if (e.src && e.loadError && e.container) return t && (e.container.innerHTML = ""), e.container.innerHTML = a.errorMsg.replace("%url%", e.src), !0
				},
				pr = function (e, t, n) {
					if (e.src) {
						t || (t = e.container.lastChild);
						var r = n ? e.w : Math.round(e.w * e.fitRatio),
							i = n ? e.h : Math.round(e.h * e.fitRatio);
						e.placeholder && !e.loaded && (e.placeholder.style.width = r + "px", e.placeholder.style.height = i + "px"), t.style.width = r + "px", t.style.height = i + "px"
					}
				},
				dr = function () {
					if (sr.length) {
						for (var e, t = 0; t < sr.length; t++) e = sr[t], e.holder.index === e.index && lr(e.index, e.item, e.baseDiv, e.img, !1, e.clearPlaceholder);
						sr = []
					}
				};
			Nt("Controller", {
				publicMethods: {
					lazyLoadItem: function (e) {
						e = Ct(e);
						var t = er(e);
						t && (!t.loaded && !t.loading || x) && (At("gettingData", e, t), t.src && cr(t))
					},
					initController: function () {
						i.extend(a, or, !0), s.items = Gn = n, er = s.getItemAt, tr = a.getNumItemsFn, nr = a.loop, tr() < 3 && (a.loop = !1), Lt("beforeChange", function (e) {
							var t, n = a.preload,
								r = null === e || e >= 0,
								i = Math.min(n[0], tr()),
								o = Math.min(n[1], tr());
							for (t = 1; t <= (r ? o : i); t++) s.lazyLoadItem(h + t);
							for (t = 1; t <= (r ? i : o); t++) s.lazyLoadItem(h - t)
						}), Lt("initialLayout", function () {
							s.currItem.initialLayout = a.getThumbBoundsFn && a.getThumbBoundsFn(h)
						}), Lt("mainScrollAnimComplete", dr), Lt("initialZoomInEnd", dr), Lt("destroy", function () {
							for (var e, t = 0; t < Gn.length; t++) e = Gn[t], e.container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
							sr = null
						})
					},
					getItemAt: function (e) {
						return e >= 0 && void 0 !== Gn[e] && Gn[e]
					},
					allowProgressiveImg: function () {
						return a.forceProgressiveLoading || !_ || a.mouseUsed || screen.width > 1200
					},
					setContent: function (e, t) {
						a.loop && (t = Ct(t));
						var n = s.getItemAt(e.index);
						n && (n.container = null);
						var r, o = s.getItemAt(t);
						if (!o) return void(e.el.innerHTML = "");
						At("gettingData", t, o), e.index = t, e.item = o;
						var u = o.container = i.createEl("pswp__zoom-wrap");
						if (!o.src && o.html && (o.html.tagName ? u.appendChild(o.html) : u.innerHTML = o.html), hr(o), fr(o, mt), !o.src || o.loadError || o.loaded) o.src && !o.loadError && (r = i.createEl("pswp__img", "img"), r.style.opacity = 1, r.src = o.src, pr(o, r), lr(t, o, u, r, !0));
						else {
							if (o.loadComplete = function (n) {
									if (f) {
										if (e && e.index === t) {
											if (hr(n, !0)) return n.loadComplete = n.img = null, fr(n, mt), Pt(n), void(e.index === h && s.updateCurrZoomItem());
											n.imageAppended ? !Zn && n.placeholder && (n.placeholder.style.display = "none", n.placeholder = null) : I.transform && (st || Zn) ? sr.push({
												item: n,
												baseDiv: u,
												img: n.img,
												index: t,
												holder: e,
												clearPlaceholder: !0
											}) : lr(t, n, u, n.img, st || Zn, !0)
										}
										n.loadComplete = null, n.img = null, At("imageLoadComplete", t, n)
									}
								}, i.features.transform) {
								var l = "pswp__img pswp__img--placeholder";
								l += o.msrc ? "" : " pswp__img--placeholder--blank";
								var c = i.createEl(l, o.msrc ? "img" : "");
								o.msrc && (c.src = o.msrc), pr(o, c), u.appendChild(c), o.placeholder = c
							}
							o.loading || cr(o), s.allowProgressiveImg() && (!Yn && I.transform ? sr.push({
								item: o,
								baseDiv: u,
								img: o.img,
								index: t,
								holder: e
							}) : lr(t, o, u, o.img, !0, !0))
						}
						Yn || t !== h ? Pt(o) : (it = u.style, rr(o, r || o.img)), e.el.innerHTML = "", e.el.appendChild(u)
					},
					cleanSlide: function (e) {
						e.img && (e.img.onload = e.img.onerror = null), e.loaded = e.loading = e.img = e.imageAppended = !1
					}
				}
			});
			var vr, mr = {},
				gr = function (e, t, n) {
					var r = document.createEvent("CustomEvent"),
						i = {
							origEvent: e,
							target: e.target,
							releasePoint: t,
							pointerType: n || "touch"
						};
					r.initCustomEvent("pswpTap", !0, !0, i), e.target.dispatchEvent(r)
				};
			Nt("Tap", {
				publicMethods: {
					initTap: function () {
						Lt("firstTouchStart", s.onTapStart), Lt("touchRelease", s.onTapRelease), Lt("destroy", function () {
							mr = {}, vr = null
						})
					},
					onTapStart: function (e) {
						e.length > 1 && (clearTimeout(vr), vr = null)
					},
					onTapRelease: function (e, t) {
						if (t && !Q && !J && !Zt) {
							var n = t;
							if (vr && (clearTimeout(vr), vr = null, Tn(n, mr))) return void At("doubleTap", n);
							if ("mouse" === t.type) return void gr(e, t, "mouse");
							var r = e.target.tagName.toUpperCase();
							if ("BUTTON" === r || i.hasClass(e.target, "pswp__single-tap")) return void gr(e, t);
							Ft(mr, n), vr = setTimeout(function () {
								gr(e, t), vr = null
							}, 300)
						}
					}
				}
			});
			var yr;
			Nt("DesktopZoom", {
				publicMethods: {
					initDesktopZoom: function () {
						j || (_ ? Lt("mouseUsed", function () {
							s.setupDesktopZoom()
						}) : s.setupDesktopZoom(!0))
					},
					setupDesktopZoom: function (t) {
						yr = {};
						var n = "wheel mousewheel DOMMouseScroll";
						Lt("bindEvents", function () {
							i.bind(e, n, s.handleMouseWheel)
						}), Lt("unbindEvents", function () {
							yr && i.unbind(e, n, s.handleMouseWheel)
						}), s.mouseZoomedIn = !1;
						var r, o = function () {
								s.mouseZoomedIn && (i.removeClass(e, "pswp--zoomed-in"), s.mouseZoomedIn = !1), y < 1 ? i.addClass(e, "pswp--zoom-allowed") : i.removeClass(e, "pswp--zoom-allowed"), u()
							},
							u = function () {
								r && (i.removeClass(e, "pswp--dragging"), r = !1)
							};
						Lt("resize", o), Lt("afterChange", o), Lt("pointerDown", function () {
							s.mouseZoomedIn && (r = !0, i.addClass(e, "pswp--dragging"))
						}), Lt("pointerUp", u), t || o()
					},
					handleMouseWheel: function (e) {
						if (y <= s.currItem.fitRatio) return a.modal && (!a.closeOnScroll || Zt || $ ? e.preventDefault() : O && Math.abs(e.deltaY) > 2 && (c = !0, s.close())), !0;
						if (e.stopPropagation(), yr.x = 0, "deltaX" in e) 1 === e.deltaMode ? (yr.x = 18 * e.deltaX, yr.y = 18 * e.deltaY) : (yr.x = e.deltaX, yr.y = e.deltaY);
						else if ("wheelDelta" in e) e.wheelDeltaX && (yr.x = -0.16 * e.wheelDeltaX), e.wheelDeltaY ? yr.y = -0.16 * e.wheelDeltaY : yr.y = -0.16 * e.wheelDelta;
						else {
							if (!("detail" in e)) return;
							yr.y = e.detail
						}
						Wt(y, !0);
						var t = vt.x - yr.x,
							n = vt.y - yr.y;
						(a.modal || t <= rt.min.x && t >= rt.max.x && n <= rt.min.y && n >= rt.max.y) && e.preventDefault(), s.panTo(t, n)
					},
					toggleDesktopZoom: function (t) {
						t = t || {
							x: mt.x / 2 + yt.x,
							y: mt.y / 2 + yt.y
						};
						var n = a.getDoubleTapZoom(!0, s.currItem),
							r = y === n;
						s.mouseZoomedIn = !r, s.zoomTo(r ? s.currItem.initialZoomLevel : n, t, 333), i[(r ? "remove" : "add") + "Class"](e, "pswp--zoomed-in")
					}
				}
			});
			var br, wr, Er, Sr, xr, Tr, Nr, Cr, kr, Lr, Ar, Or, Mr = {
					history: !0,
					galleryUID: 1
				},
				_r = function () {
					return Ar.hash.substring(1)
				},
				Dr = function () {
					br && clearTimeout(br), Er && clearTimeout(Er)
				},
				Pr = function () {
					var e = _r(),
						t = {};
					if (e.length < 5) return t;
					var n, r = e.split("&");
					for (n = 0; n < r.length; n++)
						if (r[n]) {
							var i = r[n].split("=");
							i.length < 2 || (t[i[0]] = i[1])
						}
					if (a.galleryPIDs) {
						var s = t.pid;
						for (t.pid = 0, n = 0; n < Gn.length; n++)
							if (Gn[n].pid === s) {
								t.pid = n;
								break
							}
					} else t.pid = parseInt(t.pid, 10) - 1;
					return t.pid < 0 && (t.pid = 0), t
				},
				Hr = function () {
					if (Er && clearTimeout(Er), Zt || $) return void(Er = setTimeout(Hr, 500));
					Sr ? clearTimeout(wr) : Sr = !0;
					var e = h + 1,
						t = er(h);
					t.hasOwnProperty("pid") && (e = t.pid);
					var n = Nr + "&gid=" + a.galleryUID + "&pid=" + e;
					Cr || Ar.hash.indexOf(n) === -1 && (Lr = !0);
					var r = Ar.href.split("#")[0] + "#" + n;
					Or ? "#" + n !== window.location.hash && history[Cr ? "replaceState" : "pushState"]("", document.title, r) : Cr ? Ar.replace(r) : Ar.hash = n, Cr = !0, wr = setTimeout(function () {
						Sr = !1
					}, 60)
				};
			Nt("History", {
				publicMethods: {
					initHistory: function () {
						if (i.extend(a, Mr, !0), a.history) {
							Ar = window.location, Lr = !1, kr = !1, Cr = !1, Nr = _r(), Or = "pushState" in history, Nr.indexOf("gid=") > -1 && (Nr = Nr.split("&gid=")[0], Nr = Nr.split("?gid=")[0]), Lt("afterChange", s.updateURL), Lt("unbindEvents", function () {
								i.unbind(window, "hashchange", s.onHashChange)
							});
							var e = function () {
								Tr = !0, kr || (Lr ? history.back() : Nr ? Ar.hash = Nr : Or ? history.pushState("", document.title, Ar.pathname + Ar.search) : Ar.hash = ""), Dr()
							};
							Lt("unbindEvents", function () {
								c && e()
							}), Lt("destroy", function () {
								Tr || e()
							}), Lt("firstUpdate", function () {
								h = Pr().pid
							});
							var t = Nr.indexOf("pid=");
							t > -1 && (Nr = Nr.substring(0, t), "&" === Nr.slice(-1) && (Nr = Nr.slice(0, -1))), setTimeout(function () {
								f && i.bind(window, "hashchange", s.onHashChange)
							}, 40)
						}
					},
					onHashChange: function () {
						return _r() === Nr ? (kr = !0, void s.close()) : void(Sr || (xr = !0, s.goTo(Pr().pid), xr = !1))
					},
					updateURL: function () {
						Dr(), xr || (Cr ? br = setTimeout(Hr, 800) : Hr())
					}
				}
			}), i.extend(s, sn)
		};
		return e
	}), ! function (e, t) {
		"function" == typeof define && define.amd ? define("lib/photoswipe-ui-default.min", t) : "object" == typeof exports ? module.exports = t() : e.PhotoSwipeUI_Default = t()
	}(this, function () {
		var e = function (e, t) {
			var n, r, i, s, o, u, a, f, l, c, h, p, d, v, m, g, y, b, w, E = this,
				S = !1,
				x = !0,
				T = !0,
				N = {
					barsSize: {
						top: 44,
						bottom: "auto"
					},
					closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
					timeToIdle: 4e3,
					timeToIdleOutside: 1e3,
					loadingIndicatorDelay: 1e3,
					addCaptionHTMLFn: function (e, t) {
						return e.title ? (t.children[0].innerHTML = e.title, !0) : (t.children[0].innerHTML = "", !1)
					},
					closeEl: !0,
					captionEl: !0,
					fullscreenEl: !0,
					zoomEl: !0,
					shareEl: !0,
					counterEl: !0,
					arrowEl: !0,
					preloaderEl: !0,
					tapToClose: !1,
					tapToToggleControls: !0,
					clickToCloseNonZoomable: !0,
					shareButtons: [{
						id: "facebook",
						label: "Share on Facebook",
						url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
					}, {
						id: "twitter",
						label: "Tweet",
						url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
					}, {
						id: "pinterest",
						label: "Pin it",
						url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
					}, {
						id: "download",
						label: "Download image",
						url: "{{raw_image_url}}",
						download: !0
					}],
					getImageURLForShare: function () {
						return e.currItem.src || ""
					},
					getPageURLForShare: function () {
						return window.location.href
					},
					getTextForShare: function () {
						return e.currItem.title || ""
					},
					indexIndicatorSep: " / ",
					fitControlsWidth: 1200
				},
				C = function (e) {
					if (g) return !0;
					e = e || window.event, m.timeToIdle && m.mouseUsed && !l && B();
					for (var n, r, i = e.target || e.srcElement, s = i.getAttribute("class") || "", o = 0; o < W.length; o++) n = W[o], n.onTap && s.indexOf("pswp__" + n.name) > -1 && (n.onTap(), r = !0);
					if (r) {
						e.stopPropagation && e.stopPropagation(), g = !0;
						var u = t.features.isOldAndroid ? 600 : 30;
						y = setTimeout(function () {
							g = !1
						}, u)
					}
				},
				k = function () {
					return !e.likelyTouchDevice || m.mouseUsed || screen.width > m.fitControlsWidth
				},
				L = function (e, n, r) {
					t[(r ? "add" : "remove") + "Class"](e, "pswp__" + n)
				},
				A = function () {
					var e = 1 === m.getNumItemsFn();
					e !== v && (L(r, "ui--one-slide", e), v = e)
				},
				O = function () {
					L(a, "share-modal--hidden", T)
				},
				M = function () {
					return T = !T, T ? (t.removeClass(a, "pswp__share-modal--fade-in"), setTimeout(function () {
						T && O()
					}, 300)) : (O(), setTimeout(function () {
						T || t.addClass(a, "pswp__share-modal--fade-in")
					}, 30)), T || D(), !1
				},
				_ = function (t) {
					t = t || window.event;
					var n = t.target || t.srcElement;
					return e.shout("shareLinkClick", t, n), !!n.href && (!!n.hasAttribute("download") || (window.open(n.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), T || M(), !1))
				},
				D = function () {
					for (var e, t, n, r, i, s = "", o = 0; o < m.shareButtons.length; o++) e = m.shareButtons[o], n = m.getImageURLForShare(e), r = m.getPageURLForShare(e), i = m.getTextForShare(e), t = e.url.replace("{{url}}", encodeURIComponent(r)).replace("{{image_url}}", encodeURIComponent(n)).replace("{{raw_image_url}}", n).replace("{{text}}", encodeURIComponent(i)), s += '<a href="../assets/' + t + '" target="_blank" class="pswp__share--' + e.id + '"' + (e.download ? "download" : "") + ">" + e.label + "</a>", m.parseShareButtonOut && (s = m.parseShareButtonOut(e, s));
					a.children[0].innerHTML = s, a.children[0].onclick = _
				},
				P = function (e) {
					for (var n = 0; n < m.closeElClasses.length; n++)
						if (t.hasClass(e, "pswp__" + m.closeElClasses[n])) return !0
				},
				H = 0,
				B = function () {
					clearTimeout(w), H = 0, l && E.setIdle(!1)
				},
				j = function (e) {
					e = e ? e : window.event;
					var t = e.relatedTarget || e.toElement;
					t && "HTML" !== t.nodeName || (clearTimeout(w), w = setTimeout(function () {
						E.setIdle(!0)
					}, m.timeToIdleOutside))
				},
				F = function () {
					m.fullscreenEl && !t.features.isOldAndroid && (n || (n = E.getFullscreenAPI()), n ? (t.bind(document, n.eventK, E.updateFullscreen), E.updateFullscreen(), t.addClass(e.template, "pswp--supports-fs")) : t.removeClass(e.template, "pswp--supports-fs"))
				},
				I = function () {
					m.preloaderEl && (q(!0), c("beforeChange", function () {
						clearTimeout(d), d = setTimeout(function () {
							e.currItem && e.currItem.loading ? (!e.allowProgressiveImg() || e.currItem.img && !e.currItem.img.naturalWidth) && q(!1) : q(!0)
						}, m.loadingIndicatorDelay)
					}), c("imageLoadComplete", function (t, n) {
						e.currItem === n && q(!0)
					}))
				},
				q = function (e) {
					p !== e && (L(h, "preloader--active", !e), p = e)
				},
				R = function (e) {
					var n = e.vGap;
					if (k()) {
						var o = m.barsSize;
						if (m.captionEl && "auto" === o.bottom)
							if (s || (s = t.createEl("pswp__caption pswp__caption--fake"), s.appendChild(t.createEl("pswp__caption__center")), r.insertBefore(s, i), t.addClass(r, "pswp__ui--fit")), m.addCaptionHTMLFn(e, s, !0)) {
								var u = s.clientHeight;
								n.bottom = parseInt(u, 10) || 44
							} else n.bottom = o.top;
						else n.bottom = "auto" === o.bottom ? 0 : o.bottom;
						n.top = o.top
					} else n.top = n.bottom = 0
				},
				U = function () {
					m.timeToIdle && c("mouseUsed", function () {
						t.bind(document, "mousemove", B), t.bind(document, "mouseout", j), b = setInterval(function () {
							H++, 2 === H && E.setIdle(!0)
						}, m.timeToIdle / 2)
					})
				},
				z = function () {
					c("onVerticalDrag", function (e) {
						x && e < .95 ? E.hideControls() : !x && e >= .95 && E.showControls()
					});
					var e;
					c("onPinchClose", function (t) {
						x && t < .9 ? (E.hideControls(), e = !0) : e && !x && t > .9 && E.showControls()
					}), c("zoomGestureEnded", function () {
						e = !1, e && !x && E.showControls()
					})
				},
				W = [{
					name: "caption",
					option: "captionEl",
					onInit: function (e) {
						i = e
					}
				}, {
					name: "share-modal",
					option: "shareEl",
					onInit: function (e) {
						a = e
					},
					onTap: function () {
						M()
					}
				}, {
					name: "button--share",
					option: "shareEl",
					onInit: function (e) {
						u = e
					},
					onTap: function () {
						M()
					}
				}, {
					name: "button--zoom",
					option: "zoomEl",
					onTap: e.toggleDesktopZoom
				}, {
					name: "counter",
					option: "counterEl",
					onInit: function (e) {
						o = e
					}
				}, {
					name: "button--close",
					option: "closeEl",
					onTap: e.close
				}, {
					name: "button--arrow--left",
					option: "arrowEl",
					onTap: e.prev
				}, {
					name: "button--arrow--right",
					option: "arrowEl",
					onTap: e.next
				}, {
					name: "button--fs",
					option: "fullscreenEl",
					onTap: function () {
						n.isFullscreen() ? n.exit() : n.enter()
					}
				}, {
					name: "preloader",
					option: "preloaderEl",
					onInit: function (e) {
						h = e
					}
				}],
				X = function () {
					var e, n, i, s = function (r) {
						if (r)
							for (var s = r.length, o = 0; o < s; o++) {
								e = r[o], n = e.className;
								for (var u = 0; u < W.length; u++) i = W[u], n.indexOf("pswp__" + i.name) > -1 && (m[i.option] ? (t.removeClass(e, "pswp__element--disabled"), i.onInit && i.onInit(e)) : t.addClass(e, "pswp__element--disabled"))
							}
					};
					s(r.children);
					var o = t.getChildByClass(r, "pswp__top-bar");
					o && s(o.children)
				};
			E.init = function () {
				t.extend(e.options, N, !0), m = e.options, r = t.getChildByClass(e.scrollWrap, "pswp__ui"), c = e.listen, z(), c("beforeChange", E.update), c("doubleTap", function (t) {
					var n = e.currItem.initialZoomLevel;
					e.getZoomLevel() !== n ? e.zoomTo(n, t, 333) : e.zoomTo(m.getDoubleTapZoom(!1, e.currItem), t, 333)
				}), c("preventDragEvent", function (e, t, n) {
					var r = e.target || e.srcElement;
					r && r.getAttribute("class") && e.type.indexOf("mouse") > -1 && (r.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(r.tagName)) && (n.prevent = !1)
				}), c("bindEvents", function () {
					t.bind(r, "pswpTap click", C), t.bind(e.scrollWrap, "pswpTap", E.onGlobalTap), e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", E.onMouseOver)
				}), c("unbindEvents", function () {
					T || M(), b && clearInterval(b), t.unbind(document, "mouseout", j), t.unbind(document, "mousemove", B), t.unbind(r, "pswpTap click", C), t.unbind(e.scrollWrap, "pswpTap", E.onGlobalTap), t.unbind(e.scrollWrap, "mouseover", E.onMouseOver), n && (t.unbind(document, n.eventK, E.updateFullscreen), n.isFullscreen() && (m.hideAnimationDuration = 0, n.exit()), n = null)
				}), c("destroy", function () {
					m.captionEl && (s && r.removeChild(s), t.removeClass(i, "pswp__caption--empty")), a && (a.children[0].onclick = null), t.removeClass(r, "pswp__ui--over-close"), t.addClass(r, "pswp__ui--hidden"), E.setIdle(!1)
				}), m.showAnimationDuration || t.removeClass(r, "pswp__ui--hidden"), c("initialZoomIn", function () {
					m.showAnimationDuration && t.removeClass(r, "pswp__ui--hidden")
				}), c("initialZoomOut", function () {
					t.addClass(r, "pswp__ui--hidden")
				}), c("parseVerticalMargin", R), X(), m.shareEl && u && a && (T = !0), A(), U(), F(), I()
			}, E.setIdle = function (e) {
				l = e, L(r, "ui--idle", e)
			}, E.update = function () {
				x && e.currItem ? (E.updateIndexIndicator(), m.captionEl && (m.addCaptionHTMLFn(e.currItem, i), L(i, "caption--empty", !e.currItem.title)), S = !0) : S = !1, T || M(), A()
			}, E.updateFullscreen = function (r) {
				r && setTimeout(function () {
					e.setScrollOffset(0, t.getScrollY())
				}, 50), t[(n.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pswp--fs")
			}, E.updateIndexIndicator = function () {
				m.counterEl && (o.innerHTML = e.getCurrentIndex() + 1 + m.indexIndicatorSep + m.getNumItemsFn())
			}, E.onGlobalTap = function (n) {
				n = n || window.event;
				var r = n.target || n.srcElement;
				if (!g)
					if (n.detail && "mouse" === n.detail.pointerType) {
						if (P(r)) return void e.close();
						t.hasClass(r, "pswp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? m.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(n.detail.releasePoint))
					} else if (m.tapToToggleControls && (x ? E.hideControls() : E.showControls()), m.tapToClose && (t.hasClass(r, "pswp__img") || P(r))) return void e.close()
			}, E.onMouseOver = function (e) {
				e = e || window.event;
				var t = e.target || e.srcElement;
				L(r, "ui--over-close", P(t))
			}, E.hideControls = function () {
				t.addClass(r, "pswp__ui--hidden"), x = !1
			}, E.showControls = function () {
				x = !0, S || E.update(), t.removeClass(r, "pswp__ui--hidden")
			}, E.supportsFullscreen = function () {
				var e = document;
				return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen)
			}, E.getFullscreenAPI = function () {
				var t, n = document.documentElement,
					r = "fullscreenchange";
				return n.requestFullscreen ? t = {
					enterK: "requestFullscreen",
					exitK: "exitFullscreen",
					elementK: "fullscreenElement",
					eventK: r
				} : n.mozRequestFullScreen ? t = {
					enterK: "mozRequestFullScreen",
					exitK: "mozCancelFullScreen",
					elementK: "mozFullScreenElement",
					eventK: "moz" + r
				} : n.webkitRequestFullscreen ? t = {
					enterK: "webkitRequestFullscreen",
					exitK: "webkitExitFullscreen",
					elementK: "webkitFullscreenElement",
					eventK: "webkit" + r
				} : n.msRequestFullscreen && (t = {
					enterK: "msRequestFullscreen",
					exitK: "msExitFullscreen",
					elementK: "msFullscreenElement",
					eventK: "MSFullscreenChange"
				}), t && (t.enter = function () {
					return f = m.closeOnScroll, m.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK ? e.template[this.enterK]() : void e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
				}, t.exit = function () {
					return m.closeOnScroll = f, document[this.exitK]()
				}, t.isFullscreen = function () {
					return document[this.elementK]
				}), t
			}
		};
		return e
	}), define("modules/photoswipe_gallery", ["jquery", "../lib/photoswipe.min", "../lib/photoswipe-ui-default.min"], function (e, t, n) {
		e(function () {
			var e = function (e) {
				var r = function (e) {
						var t = e.childNodes,
							n = t.length,
							r = [],
							i, s, o, u;
						for (var a = 0; a < n; a++) {
							i = t[a];
							if (i.nodeType !== 1) continue;
							s = i.children[0], o = s.getAttribute("data-size").split("x"), u = {
								src: s.getAttribute("href"),
								w: parseInt(o[0], 10),
								h: parseInt(o[1], 10)
							}, i.children.length > 1 && (u.title = i.children[1].innerHTML), s.children.length > 0 && (u.msrc = s.children[0].getAttribute("src")), u.el = i, r.push(u)
						}
						return r
					},
					i = function h(e, t) {
						return e && (t(e) ? e : h(e.parentNode, t))
					},
					s = function (e) {
						e = e || window.event, e.preventDefault ? e.preventDefault() : e.returnValue = !1;
						var t = e.target || e.srcElement,
							n = i(t, function (e) {
								return e.tagName && e.tagName.toUpperCase() === "FIGURE"
							});
						if (!n) return;
						var r = n.parentNode,
							s = n.parentNode.childNodes,
							o = s.length,
							a = 0,
							f;
						for (var l = 0; l < o; l++) {
							if (s[l].nodeType !== 1) continue;
							if (s[l] === n) {
								f = a;
								break
							}
							a++
						}
						return f >= 0 && u(f, r), !1
					},
					o = function () {
						var e = window.location.hash.substring(1),
							t = {};
						if (e.length < 5) return t;
						var n = e.split("&");
						for (var r = 0; r < n.length; r++) {
							if (!n[r]) continue;
							var i = n[r].split("=");
							if (i.length < 2) continue;
							t[i[0]] = i[1]
						}
						return t.gid && (t.gid = parseInt(t.gid, 10)), t
					},
					u = function (e, i, s, o) {
						var u = document.querySelectorAll(".pswp")[0],
							a, f, l;
						l = r(i), f = {
							galleryUID: i.getAttribute("data-pswp-uid"),
							closeOnScroll: !1,
							getThumbBoundsFn: function (e) {
								var t = l[e].el.getElementsByTagName("img")[0],
									n = window.pageYOffset || document.documentElement.scrollTop,
									r = t.getBoundingClientRect();
								return {
									x: r.left,
									y: r.top + n,
									w: r.width
								}
							}
						};
						if (o)
							if (f.galleryPIDs) {
								for (var c = 0; c < l.length; c++)
									if (l[c].pid == e) {
										f.index = c;
										break
									}
							} else f.index = parseInt(e, 10) - 1;
						else f.index = parseInt(e, 10);
						if (isNaN(f.index)) return;
						s && (f.showAnimationDuration = 0), a = new t(u, n, l, f), a.init()
					},
					a = document.querySelectorAll(e);
				for (var f = 0, l = a.length; f < l; f++) a[f].setAttribute("data-pswp-uid", f + 1), a[f].onclick = s;
				var c = o();
				c.pid && c.gid && u(c.pid, a[c.gid - 1], !0, !0)
			};
			e(".gallery-block-body");
			e(".fleet-slider-init");
		})
	}), define("modules/content", ["jquery", "../lib/photoswipe.min", "../lib/photoswipe-ui-default.min", "../lib/slick.min"], function (e, t, n) {
		e(function () {
			
			e(".post-slider-init").slick({
				infinite: !1,
				dots: !0,
				arrows: !0,
				responsive: [{
					breakpoint: 1024,
					settings: {
						dots: !1,
						arrows: !1
					}
				}]
			}), e(".post-slider__item a").on("click", function (t) {
				if (e(t.target).hasClass("slick-arrow")) return e(t.target).hasClass("slick-prev") ? e(".post-slider-init").slick("slickPrev") : e(".post-slider-init").slick("slickNext"), !1;
				if (e(t.target).hasClass("slick-arrow")) return e(t.target).hasClass("slick-prev") ? e(".fleet-slider-init").slick("slickPrev") : e(".fleet-slider-init").slick("slickNext"), !1
			});
			var r = function (e) {
				var r = function (e) {
						var t = e.childNodes,
							n = t.length,
							r = [],
							i, s, o, u;
						for (var a = 0; a < n; a++) {
							i = t[a];
							if (i.nodeType !== 1) continue;
							console.log(t);
							s = i.children[0], o = s.getAttribute("data-size").split("x"), u = {
								src: s.getAttribute("href"),
								w: parseInt(o[0], 10),
								h: parseInt(o[1], 10)
							}, i.children.length > 1 && (u.title = i.children[1].innerHTML), s.children.length > 0 && (u.msrc = s.children[0].getAttribute("src")), u.el = i, r.push(u)
						}
						return r
					},
					i = function h(e, t) {
						return e && (t(e) ? e : h(e.parentNode, t))
					},
					s = function (e) {
						e = e || window.event, e.preventDefault ? e.preventDefault() : e.returnValue = !1;
						var t = e.target || e.srcElement,
							n = i(t, function (e) {
								return e.tagName && e.tagName.toUpperCase() === "FIGURE"
							});
						if (!n) return;
						var r = n.parentNode,
							s = n.parentNode.childNodes,
							o = s.length,
							a = 0,
							f;
						for (var l = 0; l < o; l++) {
							if (s[l].nodeType !== 1) continue;
							if (s[l] === n) {
								f = a;
								break
							}
							a++
						}
						return f >= 0 && u(f, r), !1
					},
					o = function () {
						var e = window.location.hash.substring(1),
							t = {};
						if (e.length < 5) return t;
						var n = e.split("&");
						for (var r = 0; r < n.length; r++) {
							if (!n[r]) continue;
							var i = n[r].split("=");
							if (i.length < 2) continue;
							t[i[0]] = i[1]
						}
						return t.gid && (t.gid = parseInt(t.gid, 10)), t
					},
					u = function (e, i, s, o) {
						var u = document.querySelectorAll(".pswp")[0],
							a, f, l;
						l = r(i), f = {
							galleryUID: i.getAttribute("data-pswp-uid"),
							closeOnScroll: !1,
							getThumbBoundsFn: function (e) {
								var t = l[e].el.getElementsByTagName("img")[0],
									n = window.pageYOffset || document.documentElement.scrollTop,
									r = t.getBoundingClientRect();
								return {
									x: r.left,
									y: r.top + n,
									w: r.width
								}
							}
						};
						if (o)
							if (f.galleryPIDs) {
								for (var c = 0; c < l.length; c++)
									if (l[c].pid == e) {
										f.index = c;
										break
									}
							} else f.index = parseInt(e, 10) - 1;
						else f.index = parseInt(e, 10);
						if (isNaN(f.index)) return;
						s && (f.showAnimationDuration = 0), a = new t(u, n, l, f), a.init()
					},
					a = document.querySelectorAll(e);
				for (var f = 0, l = a.length; f < l; f++) a[f].setAttribute("data-pswp-uid", f + 1), a[f].onclick = s;
				var c = o();
				c.pid && c.gid && u(c.pid, a[c.gid - 1], !0, !0)
			};
			r(".post-slider-init");
			r(".fleet-slider-init")
		})
	}), requirejs.config({
		paths: {
			jquery: ["lib/jquery-3.2.1.min"]
		}
	}), requirejs(["jquery", "modules/hamburger", "modules/topmenu", "modules/steps", "modules/campus-switch", "modules/home-events", "modules/bannerslider", "modules/admission", "modules/accordion", "modules/simple_carousel", "modules/contact_section", "modules/blog", "modules/about", "modules/campuses", "modules/preloader", "modules/form_apply", "modules/teachers", "modules/work-at-cis", "modules/campus-page", "modules/photoswipe_gallery", "modules/content"], function (e, t) {
		window.dataLayer = window.dataLayer || []
	}), define("app", function () {});
